// /* eslint-disable react/jsx-no-undef */
// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from "react-router-dom";
// import { 
//   FaReceipt, 
//   FaExclamationTriangle, 
//   FaLayerGroup, 
//   FaShieldAlt, 
//   FaPaperPlane, 
//   FaBriefcase, 
//   FaClock, 
//   FaExchangeAlt, 
//   FaHistory, 
//   FaStopwatch,
//   FaLock,
//   FaServer,
//   FaDownload,
//   FaCheckCircle,
//   FaEnvelope,
//   FaMobileAlt,
//   FaCalendarAlt,
//   FaCode,
//   FaArrowRight,
//   FaLink,
//   FaCheck,
//   FaTimes,
//   FaVolumeMute,
//   FaFileExport,
//   FaChevronLeft,
//   FaChevronRight,
//   FaChevronDown 
// } from 'react-icons/fa';

// const LogItOnce = () => {
//   const navigate = useNavigate();
//   const [scrolled, setScrolled] = useState(false);
//   const [activeFAQ, setActiveFAQ] = useState(null);
//   const [testimonialIndex, setTestimonialIndex] = useState(0);
//   const [useCaseIndex, setUseCaseIndex] = useState(0);
  
//   // Refs for horizontal scrolling
//   const useCasesRef = useRef(null);
//   const statsRef = useRef(null);
//   const testimonialRef = useRef(null);
  
//   const testimonials = [
//     {
//       content: "Log It Once completely changed how we handle client deliverables. Disputes over what was sent and when have dropped to zero. It's become essential to our workflow.",
//       author: "Sarah Chen",
//       role: "Operations Lead, TechFlow Inc.",
//       initials: "SC"
//     },
//     {
//       content: "The moment we started using Log It Once, the 'I never got that email' conversations stopped. It provides a neutral record that both sides can trust.",
//       author: "Marcus Rivera",
//       role: "Legal Counsel, ScaleFast Partners",
//       initials: "MR"
//     },
//     {
//       content: "As a remote team, clear documentation is critical. Log It Once gives us confidence that every request and acknowledgment is preserved exactly as it happened.",
//       author: "Jamila Davis",
//       role: "VP Engineering, RemoteFirst Co.",
//       initials: "JD"
//     },
//     {
//       content: "We've reduced follow-up emails by 80% since implementing Log It Once. The automatic silence recording feature has been a game-changer for accountability.",
//       author: "David Park",
//       role: "Project Manager, Global Solutions",
//       initials: "DP"
//     },
//     {
//       content: "The cryptographic verification gives us legal-grade documentation without the complexity. It's simple, elegant, and absolutely reliable.",
//       author: "Emily Zhang",
//       role: "Compliance Officer, SecureCorp",
//       initials: "EZ"
//     }
//   ];

//   const useCases = [
//     { icon: <FaBriefcase />, title: 'Delivering work and awaiting acceptance' },
//     { icon: <FaPaperPlane />, title: 'Sending a request that requires acknowledgment' },
//     { icon: <FaClock />, title: 'Setting a deadline that matters' },
//     { icon: <FaExchangeAlt />, title: 'Hand-offs and responsibility transfers' },
//     { icon: <FaHistory />, title: 'Giving notice' },
//     { icon: <FaStopwatch />, title: 'Preparing for escalation without escalating' },
//     { icon: <FaExclamationTriangle />, title: 'If you would normally chase, remind, or reconstruct later' },
//     { icon: <FaShieldAlt />, title: 'Client deliverables and acceptance' },
//     { icon: <FaLayerGroup />, title: 'Team communications and decisions' },
//     { icon: <FaFileExport />, title: 'Regulatory compliance documentation' }
//   ];

//   const stats = [
//     { value: "50M+", label: 'Actions Logged', description: 'Across thousands of teams' },
//     { value: "99%", label: 'Reduction in Disputes', description: 'For teams using systematic logging' },
//     { value: "10s", label: 'To Create a Receipt', description: 'Average time per action' },
//     { value: "100%", label: 'Append-Only', description: 'Nothing edited or deleted' },
//     { value: "24/7", label: 'Automated Recording', description: 'Including silence as an outcome' },
//     { value: "∞", label: 'Verifiable History', description: 'Cryptographically signed records' }
//   ];

//   const faqs = [
//     {
//       question: "How do I get started?",
//       answer: "Create a free account, connect your email or app, and start logging actions immediately. No credit card required for the trial."
//     },
//     {
//       question: "What happens if no one responds?",
//       answer: "Silence is recorded as a factual event. After the response window closes, the receipt shows 'No Response Recorded' as the outcome."
//     },
//     {
//       question: "Can receipts be edited or deleted?",
//       answer: "No. Log It Once is append-only. Once created, receipts cannot be edited or deleted, ensuring an authentic record of events."
//     },
//     {
//       question: "How are receipts verified?",
//       answer: "Each receipt includes a server-authoritative timestamp and cryptographic signature that can be independently verified."
//     },
//     {
//       question: "Is there a free trial?",
//       answer: "Yes, you can start with 100 free receipts per month. No credit card required to get started."
//     }
//   ];

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 50);
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const goToSignup = () => {
//     navigate("/signup");
//   };

//   // Horizontal scroll functions
//   const scrollUseCases = (direction) => {
//     if (useCasesRef.current) {
//       const scrollAmount = 300;
//       useCasesRef.current.scrollBy({
//         left: direction === 'left' ? -scrollAmount : scrollAmount,
//         behavior: 'smooth'
//       });
//     }
//   };

//   const scrollStats = (direction) => {
//     if (statsRef.current) {
//       const scrollAmount = 300;
//       statsRef.current.scrollBy({
//         left: direction === 'left' ? -scrollAmount : scrollAmount,
//         behavior: 'smooth'
//       });
//     }
//   };

//   const scrollTestimonial = (direction) => {
//     if (testimonialRef.current) {
//       const scrollAmount = 400;
//       testimonialRef.current.scrollBy({
//         left: direction === 'left' ? -scrollAmount : scrollAmount,
//         behavior: 'smooth'
//       });
//     }
//   };

//   return (
//     <>
//       <style jsx global>{`
//         :root {
//           --color-bg: #ffffff;
//           --color-text: #202020;
//           --color-text-light: #6b7280;
//           --color-accent-light: #E0F5FF;
//           --color-accent-dark: #F0FAFF;
//           --color-button: #202020;
//           --color-button-text: #ffffff;
//           --gradient-primary: linear-gradient(135deg, var(--color-accent-light) 0%, var(--color-accent-dark) 100%);
//           --gradient-subtle: linear-gradient(180deg, var(--color-accent-light) 0%, var(--color-accent-dark) 44.95%, #FFFFFF 100%);
//           --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.05);
//           --shadow-md: 0 8px 30px rgba(0, 0, 0, 0.12);
//           --shadow-lg: 0 20px 60px rgba(0, 0, 0, 0.15);
//           --border-radius: 12px;
//           --border-radius-lg: 24px;
//           --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//           --container-width: 1200px;
//         }
// /* Hero animation styles */
// .hero {
//   position: relative;
//   overflow: hidden;
// }

// .hero .container {
//   display: grid;
//   grid-template-columns: 1fr;
//   gap: 4rem;
//   align-items: center;
// }

// @media (min-width: 1024px) {
//   .hero .container {
//     grid-template-columns: 1fr 1fr;
//     gap: 6rem;
//   }
  
//   .hero-content {
//     max-width: 800px;
//   }
// }

// .hero-animation {
//   position: relative;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   min-height: 400px;
// }

// .receipt-illustration {
//   position: relative;
//   width: 100%;
//   max-width: 400px;
//   height: 400px;
// }

// .receipt-card {
//   position: absolute;
//   top: 50%;
//   left: 50%;
//   transform: translate(-50%, -50%);
//   width: 280px;
//   padding: 1.5rem;
//   background: white;
//   border-radius: var(--border-radius);
//   box-shadow: var(--shadow-lg);
//   border: 2px solid rgba(224, 245, 255, 0.8);
//   animation: floatCard 6s ease-in-out infinite;
//   z-index: 2;
//   backdrop-filter: blur(10px);
// }

// @keyframes floatCard {
//   0%, 100% { 
//     transform: translate(-50%, -50%) translateY(0) rotate(0deg); 
//   }
//   33% { 
//     transform: translate(-50%, -50%) translateY(-10px) rotate(0.5deg); 
//   }
//   66% { 
//     transform: translate(-50%, -50%) translateY(-5px) rotate(-0.5deg); 
//   }
// }

// .receipt-header {
//   display: flex;
//   align-items: center;
//   gap: 1rem;
//   margin-bottom: 1.5rem;
//   padding-bottom: 1rem;
//   border-bottom: 2px solid rgba(224, 245, 255, 0.5);
// }

// .receipt-icon {
//   width: 48px;
//   height: 48px;
//   border-radius: 50%;
//   background: var(--gradient-primary);
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   font-size: 1.5rem;
//   color: var(--color-text);
//   animation: pulseIcon 2s ease-in-out infinite;
// }

// @keyframes pulseIcon {
//   0%, 100% { transform: scale(1); }
//   50% { transform: scale(1.05); }
// }

// .receipt-title h4 {
//   margin: 0;
//   color: var(--color-text);
//   font-size: 1.25rem;
// }

// .timestamp {
//   font-size: 0.85rem;
//   color: var(--color-text-light);
//   margin-top: 0.25rem;
// }

// .receipt-content {
//   display: flex;
//   flex-direction: column;
//   gap: 0.75rem;
//   margin-bottom: 1.5rem;
// }

// .receipt-item {
//   display: flex;
//   justify-content: space-between;
//   padding: 0.5rem 0;
//   border-bottom: 1px solid rgba(224, 245, 255, 0.3);
// }

// .receipt-item:last-child {
//   border-bottom: none;
// }

// .receipt-item .label {
//   color: var(--color-text-light);
//   font-weight: 500;
//   font-size: 0.9rem;
// }

// .receipt-item .value {
//   color: var(--color-text);
//   font-weight: 600;
//   font-size: 0.9rem;
//   text-align: right;
//   max-width: 60%;
//   overflow: hidden;
//   text-overflow: ellipsis;
// }

// .status-pending {
//   color: #F59E0B !important;
//   position: relative;
//   padding-left: 1.25rem;
// }

// .status-pending::before {
//   content: '';
//   position: absolute;
//   left: 0;
//   top: 50%;
//   transform: translateY(-50%);
//   width: 10px;
//   height: 10px;
//   border-radius: 50%;
//   background: #F59E0B;
//   animation: pulseDot 1.5s ease-in-out infinite;
// }

// @keyframes pulseDot {
//   0%, 100% { opacity: 1; transform: translateY(-50%) scale(1); }
//   50% { opacity: 0.5; transform: translateY(-50%) scale(0.8); }
// }

// .receipt-footer {
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   padding-top: 1rem;
//   border-top: 2px solid rgba(224, 245, 255, 0.5);
// }

// .receipt-id {
//   font-family: 'Monaco', 'Courier New', monospace;
//   font-size: 0.8rem;
//   color: var(--color-text-light);
//   opacity: 0.8;
// }

// .verification-badge {
//   display: flex;
//   align-items: center;
//   gap: 0.5rem;
//   font-size: 0.8rem;
//   color: #10B981;
//   font-weight: 600;
//   background: rgba(16, 185, 129, 0.1);
//   padding: 0.25rem 0.5rem;
//   border-radius: 9999px;
// }

// .response-indicators {
//   position: absolute;
//   top: 50%;
//   left: 50%;
//   transform: translate(-50%, -50%);
//   display: flex;
//   gap: 3rem;
//   z-index: 1;
//   width: 300px;
//   height: 300px;
// }

// .response-option {
//   position: absolute;
//   width: 60px;
//   height: 60px;
//   border-radius: 50%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   font-size: 1.5rem;
//   box-shadow: var(--shadow-md);
//   animation-duration: 3s;
//   animation-iteration-count: infinite;
//   animation-timing-function: ease-in-out;
// }

// .response-acknowledged {
//   background: #10B981;
//   color: white;
//   top: 20%;
//   left: 10%;
//   animation-name: floatAcknowledge;
// }

// .response-disputed {
//   background: #EF4444;
//   color: white;
//   top: 10%;
//   right: 10%;
//   animation-name: floatDisputed;
// }

// .response-silence {
//   background: #6B7280;
//   color: white;
//   bottom: 20%;
//   left: 50%;
//   transform: translateX(-50%);
//   animation-name: floatSilence;
// }

// @keyframes floatAcknowledge {
//   0%, 100% { 
//     transform: translateY(0) scale(1); 
//     box-shadow: 0 8px 20px rgba(16, 185, 129, 0.3);
//   }
//   50% { 
//     transform: translateY(-15px) scale(1.1); 
//     box-shadow: 0 15px 30px rgba(16, 185, 129, 0.4);
//   }
// }

// @keyframes floatDisputed {
//   0%, 100% { 
//     transform: translateY(0) scale(1); 
//     box-shadow: 0 8px 20px rgba(239, 68, 68, 0.3);
//   }
//   50% { 
//     transform: translateY(-20px) scale(1.1); 
//     box-shadow: 0 15px 30px rgba(239, 68, 68, 0.4);
//   }
// }

// @keyframes floatSilence {
//   0%, 100% { 
//     transform: translateX(-50%) scale(1); 
//     box-shadow: 0 8px 20px rgba(107, 114, 128, 0.3);
//   }
//   50% { 
//     transform: translateX(-50%) translateY(15px) scale(1.1); 
//     box-shadow: 0 15px 30px rgba(107, 114, 128, 0.4);
//   }
// }

// .floating-particle {
//   position: absolute;
//   background: rgba(224, 245, 255, 0.6);
//   border-radius: 50%;
//   z-index: 0;
// }

// .particle-1 {
//   width: 20px;
//   height: 20px;
//   top: 10%;
//   left: 5%;
//   animation: floatParticle 20s linear infinite;
// }

// .particle-2 {
//   width: 15px;
//   height: 15px;
//   top: 30%;
//   right: 15%;
//   animation: floatParticle 25s linear infinite reverse;
//   background: rgba(224, 245, 255, 0.4);
// }

// .particle-3 {
//   width: 25px;
//   height: 25px;
//   bottom: 15%;
//   left: 10%;
//   animation: floatParticle 30s linear infinite;
//   background: rgba(224, 245, 255, 0.3);
// }

// .particle-4 {
//   width: 12px;
//   height: 12px;
//   bottom: 25%;
//   right: 5%;
//   animation: floatParticle 22s linear infinite reverse;
//   background: rgba(224, 245, 255, 0.5);
// }

// @keyframes floatParticle {
//   0% {
//     transform: translate(0, 0) rotate(0deg);
//   }
//   25% {
//     transform: translate(20px, 30px) rotate(90deg);
//   }
//   50% {
//     transform: translate(40px, -20px) rotate(180deg);
//   }
//   75% {
//     transform: translate(-10px, 40px) rotate(270deg);
//   }
//   100% {
//     transform: translate(0, 0) rotate(360deg);
//   }
// }

// /* Mobile responsive adjustments */
// @media (max-width: 768px) {
//   .hero-animation {
//     min-height: 300px;
//     margin-top: 2rem;
//   }
  
//   .receipt-illustration {
//     transform: scale(0.9);
//   }
  
//   .response-indicators {
//     transform: translate(-50%, -50%) scale(0.8);
//   }
// }

// @media (max-width: 480px) {
//   .receipt-illustration {
//     transform: scale(0.8);
//   }
  
//   .response-indicators {
//     transform: translate(-50%, -50%) scale(0.7);
//   }
  
//   .floating-particle {
//     display: none;
//   }
// }
//         * {
//           margin: 0;
//           padding: 0;
//           box-sizing: border-box;
//         }

//         html {
//           scroll-behavior: smooth;
//         }

//         body {
//           font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
//           color: var(--color-text);
//           background-color: var(--color-bg);
//           line-height: 1.6;
//           overflow-x: hidden;
//         }

//         .container {
//           width: 100%;
//           max-width: var(--container-width);
//           margin: 0 auto;
//           padding: 0 24px;
//         }

//         section {
//           padding: 80px 0;
//         }

//         h1, h2, h3, h4 {
//           font-weight: 800;
//           line-height: 1.2;
//         }

//         h1 {
//           font-size: 3.5rem;
//           margin-bottom: 1.5rem;
//         }

//         h2 {
//           font-size: 2.5rem;
//           margin-bottom: 1rem;
//           text-align: center;
//         }

//         h3 {
//           font-size: 1.5rem;
//           margin-bottom: 0.75rem;
//         }

//         p {
//           color: var(--color-text-light);
//           margin-bottom: 1.5rem;
//         }

//         .section-subtitle {
//           text-align: center;
//           max-width: 700px;
//           margin: 0 auto 3rem;
//           font-size: 1.125rem;
//         }

//         /* Animations */
//         @keyframes fadeIn {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }

//         @keyframes fadeInUp {
//           from {
//             opacity: 0;
//             transform: translateY(30px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         @keyframes float {
//           0%, 100% { transform: translateY(0); }
//           50% { transform: translateY(-10px); }
//         }

//         @keyframes pulse {
//           0%, 100% { transform: scale(1); }
//           50% { transform: scale(1.05); }
//         }

//         /* Header */
//         .header {
//           position: sticky;
//           top: 0;
//           z-index: 1000;
//           background-color: rgba(255, 255, 255, 0.95);
//           backdrop-filter: blur(10px);
//           border-bottom: 1px solid rgba(0, 0, 0, 0.05);
//           padding: 1rem 0;
//           transition: var(--transition);
//         }

//         .header.scrolled {
//           box-shadow: var(--shadow-sm);
//         }

//         .header-content {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//         }

//         .logo {
//           display: flex;
//           align-items: center;
//           font-weight: 800;
//           font-size: 1.5rem;
//           text-decoration: none;
//           color: var(--color-text);
//           cursor: pointer;
//           transition: var(--transition);
//         }

//         .logo:hover {
//           transform: scale(1.05);
//         }

//         .logo-icon {
//           margin-right: 10px;
//           font-size: 1.8rem;
//           color: var(--color-text);
//           animation: float 3s ease-in-out infinite;
//         }

//         .nav {
//           display: flex;
//           gap: 2rem;
//         }

//         .nav a {
//           text-decoration: none;
//           color: var(--color-text-light);
//           font-weight: 500;
//           font-size: 0.95rem;
//           position: relative;
//           transition: var(--transition);
//         }

//         .nav a:hover {
//           color: var(--color-text);
//           transform: translateY(-2px);
//         }

//         .cta-button {
//           background-color: var(--color-button);
//           color: var(--color-button-text);
//           border: none;
//           border-radius: 9999px;
//           padding: 12px 24px;
//           font-weight: 700;
//           font-size: 0.95rem;
//           cursor: pointer;
//           transition: var(--transition);
//           display: inline-flex;
//           align-items: center;
//           gap: 8px;
//           text-decoration: none;
//         }

//         .cta-button:hover {
//           transform: translateY(-2px);
//           box-shadow: var(--shadow-md);
//           background: linear-gradient(135deg, #202020, #404040);
//           animation: pulse 1s ease-in-out;
//         }

//         .cta-button.primary {
//           padding: 16px 32px;
//           font-size: 1rem;
//         }

//         .cta-button.large {
//           padding: 18px 40px;
//           font-size: 1.1rem;
//         }

//         /* Hero */
//         .hero {
//           padding: 120px 0;
//           background: var(--gradient-subtle);
//           position: relative;
//           overflow: hidden;
//           animation: fadeIn 1s ease-out;
//         }

//         .hero-content {
//           position: relative;
//           z-index: 2;
//           max-width: 800px;
//         }

//         .tagline {
//           display: inline-flex;
//           align-items: center;
//           gap: 10px;
//           background: rgba(32, 32, 32, 0.05);
//           color: var(--color-text);
//           font-weight: 600;
//           padding: 8px 16px;
//           border-radius: 9999px;
//           margin-bottom: 1.5rem;
//           animation: fadeInUp 0.8s ease-out 0.2s both;
//         }

//         .hero-subtitle {
//           font-size: 1.25rem;
//           margin-bottom: 3rem;
//           max-width: 700px;
//           animation: fadeInUp 0.8s ease-out 0.4s both;
//         }

//         .hero-actions {
//           display: flex;
//           gap: 1rem;
//           flex-wrap: wrap;
//           animation: fadeInUp 0.8s ease-out 0.6s both;
//         }

//         .secondary-button {
//           background: transparent;
//           color: var(--color-text);
//           border: 2px solid var(--color-text);
//           border-radius: 9999px;
//           padding: 12px 24px;
//           font-weight: 700;
//           font-size: 0.95rem;
//           cursor: pointer;
//           transition: var(--transition);
//           text-decoration: none;
//           display: inline-flex;
//           align-items: center;
//           gap: 8px;
//         }

//         .secondary-button:hover {
//           background-color: var(--color-text);
//           color: white;
//           transform: translateY(-2px);
//           box-shadow: var(--shadow-md);
//         }

//         /* Horizontal Scroll Sections */
//         .horizontal-scroll-section {
//           position: relative;
//           padding: 0 24px;
//         }

//         .horizontal-scroll-container {
//           display: flex;
//           overflow-x: auto;
//           gap: 24px;
//           padding: 24px 0;
//           scrollbar-width: none;
//           -ms-overflow-style: none;
//           scroll-behavior: smooth;
//         }

//         .horizontal-scroll-container::-webkit-scrollbar {
//           display: none;
//         }

//         .scroll-button {
//           position: absolute;
//           top: 50%;
//           transform: translateY(-50%);
//           background: white;
//           border: 2px solid var(--color-text);
//           border-radius: 50%;
//           width: 48px;
//           height: 48px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           cursor: pointer;
//           transition: var(--transition);
//           z-index: 10;
//           box-shadow: var(--shadow-md);
//         }

//         .scroll-button:hover {
//           background: var(--color-text);
//           color: white;
//           transform: translateY(-50%) scale(1.1);
//         }

//         .scroll-button.left {
//           left: 0;
//         }

//         .scroll-button.right {
//           right: 0;
//         }

//         /* Statistics Section with Horizontal Scroll */
//         .stats-scroll-container {
//           display: flex;
//           overflow-x: auto;
//           gap: 24px;
//           padding: 24px 0;
//           scrollbar-width: none;
//           -ms-overflow-style: none;
//         }

//         .stats-scroll-container::-webkit-scrollbar {
//           display: none;
//         }

//         .stat-card {
//           flex: 0 0 auto;
//           width: 280px;
//           text-align: center;
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           transition: var(--transition);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//           opacity: 0;
//           transform: translateY(30px);
//           animation: fadeInUp 0.8s ease-out forwards;
//         }

//         .stat-card:hover {
//           transform: translateY(-8px);
//           box-shadow: var(--shadow-lg);
//         }

//         .stat-number {
//           font-size: 3rem;
//           font-weight: 800;
//           color: var(--color-text);
//           margin-bottom: 0.5rem;
//           display: block;
//         }

//         .stat-label {
//           font-weight: 600;
//           color: var(--color-text);
//           font-size: 1.1rem;
//           margin-bottom: 0.5rem;
//         }

//         .stat-description {
//           font-size: 0.9rem;
//           color: var(--color-text-light);
//         }

//         /* Use Cases with Horizontal Scroll */
//         .use-cases-scroll-container {
//           display: flex;
//           overflow-x: auto;
//           gap: 24px;
//           padding: 24px 0;
//           scrollbar-width: none;
//           -ms-overflow-style: none;
//         }

//         .use-cases-scroll-container::-webkit-scrollbar {
//           display: none;
//         }

//         .use-case-card {
//           flex: 0 0 auto;
//           width: 320px;
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           transition: var(--transition);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//           text-align: center;
//         }

//         .use-case-card:hover {
//           transform: translateY(-8px);
//           box-shadow: var(--shadow-md);
//           border-color: rgba(224, 245, 255, 0.8);
//         }

//         .use-case-icon {
//           font-size: 2.5rem;
//           color: var(--color-text);
//           margin-bottom: 1.5rem;
//           display: block;
//           transition: var(--transition);
//         }

//         .use-case-card:hover .use-case-icon {
//           transform: scale(1.2) rotate(5deg);
//         }

//         /* Testimonials with Horizontal Scroll */
//         .testimonials-scroll-container {
//           display: flex;
//           overflow-x: auto;
//           gap: 32px;
//           padding: 32px 0;
//           scrollbar-width: none;
//           -ms-overflow-style: none;
//         }

//         .testimonials-scroll-container::-webkit-scrollbar {
//           display: none;
//         }

//         .testimonial-card {
//           flex: 0 0 auto;
//           width: 380px;
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           transition: var(--transition);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//         }

//         .testimonial-card:hover {
//           transform: translateY(-8px);
//           box-shadow: var(--shadow-md);
//         }

//         .testimonial-content {
//           font-style: italic;
//           margin-bottom: 1.5rem;
//           color: var(--color-text);
//           font-size: 1.1rem;
//           line-height: 1.6;
//         }

//         .testimonial-author {
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//         }

//         .author-avatar {
//           width: 48px;
//           height: 48px;
//           border-radius: 50%;
//           background: var(--gradient-primary);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-weight: 700;
//           color: var(--color-text);
//           transition: var(--transition);
//         }

//         .testimonial-card:hover .author-avatar {
//           transform: rotate(360deg);
//         }

//         /* What Is Section */
//         .what-is-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
//           gap: 2rem;
//           margin-top: 3rem;
//         }

//         .what-is-card {
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           transition: var(--transition);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//           text-align: center;
//         }

//         .what-is-card:hover {
//           transform: translateY(-8px);
//           box-shadow: var(--shadow-md);
//         }

//         .what-is-icon {
//           font-size: 2.5rem;
//           color: var(--color-text);
//           margin-bottom: 1.5rem;
//         }

//         /* How It Works */
//         .steps {
//           display: flex;
//           flex-direction: column;
//           gap: 2rem;
//           max-width: 800px;
//           margin: 3rem auto 0;
//         }

//         .step {
//           display: flex;
//           gap: 2rem;
//           align-items: flex-start;
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//         }

//         .step-number {
//           width: 60px;
//           height: 60px;
//           border-radius: 50%;
//           background: var(--color-text);
//           color: white;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 1.5rem;
//           font-weight: 800;
//           flex-shrink: 0;
//         }

//         .step-content {
//           flex: 1;
//         }

//         .outcome-options {
//           display: flex;
//           flex-direction: column;
//           gap: 12px;
//           margin: 1rem 0;
//         }

//         .outcome-option {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//           font-size: 0.95rem;
//           transition: var(--transition);
//           padding: 8px 12px;
//           border-radius: 8px;
//           background: rgba(224, 245, 255, 0.2);
//         }

//         .outcome-option:hover {
//           transform: translateX(10px);
//           background: rgba(224, 245, 255, 0.4);
//         }

//         .option-icon {
//           font-size: 1.25rem;
//           flex-shrink: 0;
//         }

//         .option-icon.acknowledged {
//           color: #10B981;
//         }

//         .option-icon.disputed {
//           color: #EF4444;
//         }

//         .option-icon.no-response {
//           color: #6B7280;
//         }

//         /* Outcomes Section */
//         .outcomes-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
//           gap: 2rem;
//           margin-top: 3rem;
//         }

//         .outcome-card {
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           transition: var(--transition);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//         }

//         .outcome-card:hover {
//           transform: translateY(-8px);
//           box-shadow: var(--shadow-md);
//         }

//         .outcome-card.acknowledged {
//           border-top: 4px solid #10B981;
//         }

//         .outcome-card.disputed {
//           border-top: 4px solid #EF4444;
//         }

//         .outcome-card.no-response {
//           border-top: 4px solid #6B7280;
//         }

//         .outcome-header {
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//           margin-bottom: 1rem;
//         }

//         .outcome-icon {
//           font-size: 2rem;
//         }

//         /* Differentiator Section */
//         .comparison {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
//           gap: 3rem;
//           margin-top: 3rem;
//         }

//         .comparison-column {
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//         }

//         .comparison-list {
//           display: flex;
//           flex-direction: column;
//           gap: 1rem;
//           margin-top: 1rem;
//         }

//         .comparison-item {
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//           padding: 0.75rem;
//           border-radius: 8px;
//           transition: var(--transition);
//         }

//         .comparison-item:hover {
//           background: rgba(224, 245, 255, 0.2);
//           transform: translateX(5px);
//         }

//         .is-icon {
//           width: 24px;
//           height: 24px;
//           border-radius: 50%;
//           background: #10B981;
//           color: white;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-weight: bold;
//           flex-shrink: 0;
//         }

//         .not-icon {
//           width: 24px;
//           height: 24px;
//           border-radius: 50%;
//           background: #EF4444;
//           color: white;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-weight: bold;
//           flex-shrink: 0;
//         }

//         /* Verification Section */
//         .verification-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
//           gap: 2rem;
//           margin-top: 3rem;
//         }

//         .verification-card {
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           transition: var(--transition);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//           text-align: center;
//         }

//         .verification-card:hover {
//           transform: translateY(-8px);
//           box-shadow: var(--shadow-md);
//         }

//         .verification-icon {
//           font-size: 2.5rem;
//           color: var(--color-text);
//           margin-bottom: 1.5rem;
//         }

//         /* CTA Section */
//         .cta-card {
//           background: white;
//           border-radius: var(--border-radius);
//           padding: 4rem;
//           text-align: center;
//           box-shadow: var(--shadow-lg);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//           max-width: 900px;
//           margin: 0 auto;
//         }

//         .cta-subtitle {
//           font-size: 1.25rem;
//           margin-bottom: 3rem;
//         }

//         .integration-methods {
//           margin: 3rem 0;
//         }

//         .methods {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
//           gap: 2rem;
//           margin-top: 2rem;
//         }

//         .method {
//           padding: 1.5rem;
//           background: rgba(224, 245, 255, 0.2);
//           border-radius: var(--border-radius);
//           transition: var(--transition);
//         }

//         .method:hover {
//           transform: translateY(-5px);
//           background: rgba(224, 245, 255, 0.4);
//         }

//         .method svg {
//           font-size: 2rem;
//           color: var(--color-text);
//           margin-bottom: 1rem;
//         }

//         .email-example {
//           background: rgba(32, 32, 32, 0.05);
//           border-radius: var(--border-radius);
//           padding: 2rem;
//           margin: 2rem 0;
//           text-align: left;
//           font-family: 'Monaco', 'Courier New', monospace;
//           font-size: 0.9rem;
//         }

//         .email-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 1rem;
//           color: var(--color-text);
//           font-weight: 600;
//         }

//         /* FAQ */
//         .faq-grid {
//           max-width: 800px;
//           margin: 3rem auto 0;
//         }

//         .faq-item {
//           border-bottom: 1px solid rgba(224, 245, 255, 0.5);
//           padding: 1.5rem 0;
//         }

//         .faq-question {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           cursor: pointer;
//           font-weight: 700;
//           font-size: 1.1rem;
//           color: var(--color-text);
//           transition: var(--transition);
//         }

//         .faq-question:hover {
//           color: var(--color-text);
//           transform: translateX(5px);
//         }

//         .faq-answer {
//           max-height: 0;
//           overflow: hidden;
//           transition: max-height 0.3s ease;
//           color: var(--color-text-light);
//           padding-top: 0;
//         }

//         .faq-item.active .faq-answer {
//           max-height: 300px;
//           padding-top: 1rem;
//         }

//         .faq-item.active .faq-question svg {
//           transform: rotate(180deg);
//         }

//         /* Footer */
//         .footer {
//           background-color: var(--color-text);
//           color: white;
//           padding: 4rem 0 2rem;
//         }

//         .footer-content {
//           display: flex;
//           justify-content: space-between;
//           align-items: flex-start;
//           flex-wrap: wrap;
//           gap: 2rem;
//           margin-bottom: 3rem;
//         }

//         .footer-logo {
//           display: flex;
//           align-items: center;
//           font-weight: 800;
//           font-size: 1.5rem;
//           margin-bottom: 1rem;
//         }

//         .footer-links {
//           display: flex;
//           flex-direction: column;
//           gap: 0.75rem;
//         }

//         .footer-links a {
//           color: rgba(255, 255, 255, 0.7);
//           text-decoration: none;
//           transition: var(--transition);
//         }

//         .footer-links a:hover {
//           color: white;
//           transform: translateX(5px);
//         }

//         .footer-disclaimer {
//           text-align: center;
//           padding-top: 2rem;
//           border-top: 1px solid rgba(255, 255, 255, 0.1);
//           color: rgba(255, 255, 255, 0.5);
//           font-size: 0.9rem;
//         }

//         /* Responsive */
//         @media (max-width: 768px) {
//           h1 {
//             font-size: 2.5rem;
//           }
          
//           h2 {
//             font-size: 2rem;
//           }
          
//           .header-content {
//             flex-direction: column;
//             gap: 1rem;
//           }
          
//           .nav {
//             gap: 1rem;
//             flex-wrap: wrap;
//             justify-content: center;
//           }
          
//           .hero-actions {
//             justify-content: center;
//           }
          
//           .step {
//             flex-direction: column;
//             text-align: center;
//           }
          
//           .cta-card {
//             padding: 2rem;
//           }
          
//           .scroll-button {
//             width: 40px;
//             height: 40px;
//             font-size: 0.8rem;
//           }
          
//           .stat-card,
//           .use-case-card,
//           .testimonial-card {
//             width: 280px;
//           }
//         }

//         @media (max-width: 480px) {
//           .container {
//             padding: 0 16px;
//           }
          
//           section {
//             padding: 60px 0;
//           }
          
//           .horizontal-scroll-section {
//             padding: 0 16px;
//           }
          
//           .scroll-button {
//             display: none;
//           }
//         }
//       `}</style>

//       <header className={`header ${scrolled ? 'scrolled' : ''}`}>
//         <div className="container">
//           <div className="header-content">
//             <div className="logo">
//               <FaReceipt className="logo-icon" />
//               <span>Log It Once</span>
//             </div>

//             <nav className="nav">
//               <a href="#what">What</a>
//               <a href="#why">Why</a>
//               <a href="#how">How</a>
//               <a href="#uses">Use Cases</a>
//               <a href="#verification">Verification</a>
//             </nav>

//             <button className="cta-button" onClick={goToSignup}>
//               Start Logging
//             </button>
//           </div>
//         </div>
//       </header>


//       <section className="hero">
//   <div className="container">
//     <div className="hero-content">
//       <div className="tagline">
//         <FaReceipt /> Log it once. Get a receipt.
//       </div>
      
//       <h1>Log It Once</h1>
      
//       <p className="hero-subtitle">
//         Create a neutral, time-stamped receipt for actions, requests, and outcomes —
//         including when no one responds.
//         <br />
//         <strong>No chasing. No confrontation. Nothing rewritten later.</strong>
//       </p>
      
//       <div className="hero-actions">
//         <button className="cta-button primary" onClick={goToSignup}>
//           USE FOR FREE <FaArrowRight />
//         </button>
        
//         <a href="#how" className="secondary-button">
//           See How It Works
//         </a>
//       </div>
//     </div>
    
//     {/* Animated receipt illustration */}
//     <div className="hero-animation">
//       <div className="receipt-illustration">
//         {/* Floating receipt card */}
//         <div className="receipt-card">
//           <div className="receipt-header">
//             <div className="receipt-icon">
//               <FaReceipt />
//             </div>
//             <div className="receipt-title">
//               <h4>Action Receipt</h4>
//               <div className="timestamp">Just now</div>
//             </div>
//           </div>
          
//           <div className="receipt-content">
//             <div className="receipt-item">
//               <span className="label">Action:</span>
//               <span className="value">Deliverable sent</span>
//             </div>
//             <div className="receipt-item">
//               <span className="label">To:</span>
//               <span className="value">client@company.com</span>
//             </div>
//             <div className="receipt-item">
//               <span className="label">Status:</span>
//               <span className="value status-pending">Awaiting response</span>
//             </div>
//           </div>
          
//           <div className="receipt-footer">
//             <div className="receipt-id">#LOG-9842-2024</div>
//             <div className="verification-badge">
//               <FaLock /> Verified
//             </div>
//           </div>
//         </div>
        
//         {/* Animated response indicators */}
//         <div className="response-indicators">
//           <div className="response-option response-acknowledged">
//             <FaCheck />
//           </div>
//           <div className="response-option response-disputed">
//             <FaTimes />
//           </div>
//           <div className="response-option response-silence">
//             <FaVolumeMute />
//           </div>
//         </div>
        
//         {/* Floating particles */}
//         <div className="floating-particle particle-1"></div>
//         <div className="floating-particle particle-2"></div>
//         <div className="floating-particle particle-3"></div>
//         <div className="floating-particle particle-4"></div>
//       </div>
//     </div>
//   </div>
// </section>
// {/* 
//       <section className="hero">

//         <div className="container">
//           <div className="hero-content">
//             <div className="tagline">
//               <FaReceipt /> Log it once. Get a receipt.
//             </div>
            
//             <h1>Log It Once</h1>
            
//             <p className="hero-subtitle">
//               Create a neutral, time-stamped receipt for actions, requests, and outcomes —
//               including when no one responds.
//               <br />
//               <strong>No chasing. No confrontation. Nothing rewritten later.</strong>
//             </p>
            
//             <div className="hero-actions">
//               <button className="cta-button primary" onClick={goToSignup}>
//                 USE FOR FREE <FaArrowRight />
//               </button>
              
//               <a href="#how" className="secondary-button">
//                 See How It Works
//               </a>
//             </div>
//           </div>
//         </div>
//       </section> */}

//       <section id="what" className="section">
//         <div className="container">
//           <h2>What Log It Once Is</h2>
          
//           <p className="section-subtitle">
//             Log It Once issues a receipt the moment something happens.
//             That receipt records:
//           </p>
          
//           <div className="what-is-grid">
//             <div className="what-is-card">
//               <div className="what-is-icon">
//                 <FaShieldAlt />
//               </div>
//               <h3>What was sent or done</h3>
//               <p>The action, request, or delivery</p>
//             </div>
            
//             <div className="what-is-card">
//               <div className="what-is-icon">
//                 <FaLayerGroup />
//               </div>
//               <h3>Who was involved</h3>
//               <p>Sender and recipient information</p>
//             </div>
            
//             <div className="what-is-card">
//               <div className="what-is-icon">
//                 <FaServer />
//               </div>
//               <h3>When it occurred</h3>
//               <p>Server-authoritative time</p>
//             </div>
            
//             <div className="what-is-card">
//               <div className="what-is-icon">
//                 <FaHistory />
//               </div>
//               <h3>What happened next — or didn't</h3>
//               <p>Response or silence recorded</p>
//             </div>
//           </div>
          
//           <div style={{ textAlign: 'center', marginTop: '2rem' }}>
//             <FaCheckCircle style={{ fontSize: '2rem', color: '#10B981', marginBottom: '1rem' }} />
//             <p style={{ fontSize: '1.1rem', fontWeight: '600' }}>Receipts are append-only. Nothing is edited. Nothing is deleted.</p>
//           </div>
//         </div>
//       </section>

//       <section className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <h2>The Numbers That Power Log It Once</h2>
          
//           <p className="section-subtitle">
//             Real impact from teams who document actions and outcomes systematically.
//           </p>
          
//           <div className="horizontal-scroll-section">
//             <button className="scroll-button left" onClick={() => scrollStats('left')}>
//               <FaChevronLeft />
//             </button>
            
//             <div className="stats-scroll-container" ref={statsRef}>
//               {stats.map((stat, index) => (
//                 <div
//                   key={stat.label}
//                   className="stat-card"
//                   style={{ animationDelay: `${index * 0.1}s` }}
//                 >
//                   <span className="stat-number">
//                     {stat.value}
//                   </span>
//                   <span className="stat-label">{stat.label}</span>
//                   <p className="stat-description">{stat.description}</p>
//                 </div>
//               ))}
//             </div>
            
//             <button className="scroll-button right" onClick={() => scrollStats('right')}>
//               <FaChevronRight />
//             </button>
//           </div>
//         </div>
//       </section>

//       <section id="why" className="section">
//         <div className="container">
//           <h2>Why This Exists</h2>
          
//           <div style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto' }}>
//             <h3 style={{ marginBottom: '1rem' }}>Most systems record messages. They lose outcomes.</h3>
//             <p>
//               When time passes and nothing happens, the record disappears — 
//               and disputes begin. Log It Once preserves the sequence.
//             </p>
//           </div>
          
//           <div style={{ 
//             display: 'flex', 
//             justifyContent: 'center', 
//             alignItems: 'center',
//             marginTop: '3rem',
//             padding: '2rem',
//             background: 'white',
//             borderRadius: 'var(--border-radius)',
//             boxShadow: 'var(--shadow-sm)'
//           }}>
//             <div style={{ display: 'flex', alignItems: 'center', gap: '2rem', flexWrap: 'wrap', justifyContent: 'center' }}>
//               <div style={{ textAlign: 'center' }}>
//                 <div style={{ 
//                   width: '80px', 
//                   height: '80px', 
//                   borderRadius: '50%', 
//                   background: 'var(--color-text)', 
//                   color: 'white',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   fontSize: '2rem',
//                   fontWeight: '800',
//                   margin: '0 auto 1rem'
//                 }}>1</div>
//                 <p style={{ fontWeight: '600' }}>Message Sent</p>
//               </div>
              
//               <div style={{ fontSize: '2rem', color: 'var(--color-text-light)' }}>→</div>
              
//               <div style={{ textAlign: 'center' }}>
//                 <div style={{ 
//                   width: '80px', 
//                   height: '80px', 
//                   borderRadius: '50%', 
//                   background: '#EF4444', 
//                   color: 'white',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   fontSize: '2rem',
//                   fontWeight: '800',
//                   margin: '0 auto 1rem'
//                 }}>2</div>
//                 <p style={{ fontWeight: '600' }}>Outcome Lost</p>
//               </div>
              
//               <div style={{ fontSize: '2rem', color: 'var(--color-text-light)' }}>→</div>
              
//               <div style={{ textAlign: 'center' }}>
//                 <div style={{ 
//                   width: '80px', 
//                   height: '80px', 
//                   borderRadius: '50%', 
//                   background: '#DC2626', 
//                   color: 'white',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   fontSize: '2rem',
//                   fontWeight: '800',
//                   margin: '0 auto 1rem'
//                 }}>3</div>
//                 <p style={{ fontWeight: '600' }}>Dispute Begins</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       <section id="how" className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <h2>How It Works</h2>
          
//           <div className="steps">
//             <div className="step">
//               <div className="step-number">1</div>
//               <div className="step-content">
//                 <h3>You log an action</h3>
//                 <p>Email, app, calendar, or API.</p>
//               </div>
//             </div>
            
//             <div className="step">
//               <div className="step-number">2</div>
//               <div className="step-content">
//                 <h3>A receipt is created immediately</h3>
//                 <p>Time-stamped by the server.</p>
//               </div>
//             </div>
            
//             <div className="step">
//               <div className="step-number">3</div>
//               <div className="step-content">
//                 <h3>The recipient responds — or doesn't</h3>
//                 <p>Recipients receive a receipt link with three possible outcomes:</p>
//                 <div className="outcome-options">
//                   <div className="outcome-option">
//                     <FaCheck className="option-icon acknowledged" />
//                     <span>Acknowledge — they formally accept receipt</span>
//                   </div>
//                   <div className="outcome-option">
//                     <FaTimes className="option-icon disputed" />
//                     <span>Dispute — they formally contest it</span>
//                   </div>
//                   <div className="outcome-option">
//                     <FaVolumeMute className="option-icon no-response" />
//                     <span>No response — if nothing happens by the deadline, silence is recorded automatically</span>
//                   </div>
//                 </div>
//                 <p className="note" style={{ fontSize: '0.9rem', color: 'var(--color-text-light)', marginTop: '1rem' }}>
//                   <small>Replies sent by regular email are not recorded as formal responses.</small>
//                 </p>
//               </div>
//             </div>
            
//             <div className="step">
//               <div className="step-number">4</div>
//               <div className="step-content">
//                 <h3>The timeline grows intact</h3>
//                 <p>All events are appended in order. Nothing is rewritten later.</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       <section className="section">
//         <div className="container">
//           <h2>The Three Outcomes (clearly defined)</h2>
          
//           <p className="section-subtitle">
//             Every receipt ends in one of these states:
//           </p>
          
//           <div className="outcomes-grid">
//             <div className="outcome-card acknowledged">
//               <div className="outcome-header">
//                 <FaCheck className="outcome-icon" style={{ color: '#10B981' }} />
//                 <h3>Acknowledged</h3>
//               </div>
//               <p>The recipient explicitly accepted via the receipt link.</p>
//             </div>
            
//             <div className="outcome-card disputed">
//               <div className="outcome-header">
//                 <FaTimes className="outcome-icon" style={{ color: '#EF4444' }} />
//                 <h3>Disputed</h3>
//               </div>
//               <p>The recipient formally contested via the receipt link.</p>
//             </div>
            
//             <div className="outcome-card no-response">
//               <div className="outcome-header">
//                 <FaVolumeMute className="outcome-icon" style={{ color: '#6B7280' }} />
//                 <h3>No Response Recorded</h3>
//               </div>
//               <p>No formal response occurred within the response window.</p>
//             </div>
//           </div>
          
//           <div style={{ textAlign: 'center', marginTop: '3rem' }}>
//             <p style={{ fontSize: '1.1rem', fontWeight: '600' }}>
//               <strong>No interpretation is added. Only sequence is preserved.</strong>
//             </p>
//           </div>
//         </div>
//       </section>

//       <section className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <h2>Neutral by Design</h2>
          
//           <div className="comparison">
//             <div className="comparison-column">
//               <h3>Log It Once is:</h3>
//               <div className="comparison-list">
//                 <div className="comparison-item">
//                   <div className="is-icon">✓</div>
//                   <span>Chronological</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="is-icon">✓</div>
//                   <span>Append-only</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="is-icon">✓</div>
//                   <span>Independently verifiable</span>
//                 </div>
//               </div>
//             </div>
            
//             <div className="comparison-column">
//               <h3>Log It Once is not:</h3>
//               <div className="comparison-list">
//                 <div className="comparison-item">
//                   <div className="not-icon">✗</div>
//                   <span>A judge</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="not-icon">✗</div>
//                   <span>An arbitrator</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="not-icon">✗</div>
//                   <span>A score</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="not-icon">✗</div>
//                   <span>A decision engine</span>
//                 </div>
//               </div>
//             </div>
//           </div>
          
//           <div style={{ textAlign: 'center', marginTop: '3rem' }}>
//             <p style={{ fontSize: '1.1rem', fontWeight: '600' }}>
//               It records what happened. It does not decide what it means.
//             </p>
//           </div>
//         </div>
//       </section>

//       <section className="section">
//         <div className="container">
//           <h2>What The Receipt Includes</h2>
          
//           <div className="what-is-grid">
//             <div className="what-is-card">
//               <div style={{ fontSize: '2.5rem', marginBottom: '1.5rem' }}>📤</div>
//               <h3>What was sent or done</h3>
//               <p>The action, request, or delivery</p>
//             </div>
            
//             <div className="what-is-card">
//               <div style={{ fontSize: '2.5rem', marginBottom: '1.5rem' }}>👥</div>
//               <h3>Who was involved</h3>
//               <p>Sender and recipient information</p>
//             </div>
            
//             <div className="what-is-card">
//               <div style={{ fontSize: '2.5rem', marginBottom: '1.5rem' }}>🕒</div>
//               <h3>When it occurred</h3>
//               <p>Server-authoritative time</p>
//             </div>
            
//             <div className="what-is-card">
//               <div style={{ fontSize: '2.5rem', marginBottom: '1.5rem' }}>🔇</div>
//               <h3>What happened next — or didn't</h3>
//               <p>Non-response is recorded as a factual event</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       <section id="uses" className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <h2>When People Use Log It Once</h2>
          
//           <p className="section-subtitle">
//             Common scenarios where systematic documentation makes the difference.
//           </p>
          
//           <div className="horizontal-scroll-section">
//             <button className="scroll-button left" onClick={() => scrollUseCases('left')}>
//               <FaChevronLeft />
//             </button>
            
//             <div className="use-cases-scroll-container" ref={useCasesRef}>
//               {useCases.map((useCase, index) => (
//                 <div key={index} className="use-case-card">
//                   <div className="use-case-icon">
//                     {useCase.icon}
//                   </div>
//                   <h3>{useCase.title}</h3>
//                 </div>
//               ))}
//             </div>
            
//             <button className="scroll-button right" onClick={() => scrollUseCases('right')}>
//               <FaChevronRight />
//             </button>
//           </div>
//         </div>
//       </section>

//       <section className="section">
//         <div className="container">
//           <h2>Teams Love Log It Once</h2>
          
//           <p className="section-subtitle">
//             See how teams use systematic documentation to reduce conflict and increase accountability.
//           </p>
          
//           <div className="horizontal-scroll-section">
//             <button className="scroll-button left" onClick={() => scrollTestimonial('left')}>
//               <FaChevronLeft />
//             </button>
            
//             <div className="testimonials-scroll-container" ref={testimonialRef}>
//               {testimonials.map((testimonial, index) => (
//                 <div key={testimonial.author} className="testimonial-card">
//                   <p className="testimonial-content">
//                     "{testimonial.content}"
//                   </p>
//                   <div className="testimonial-author">
//                     <div className="author-avatar">
//                       {testimonial.initials}
//                     </div>
//                     <div className="author-info">
//                       <h4>{testimonial.author}</h4>
//                       <p>{testimonial.role}</p>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
            
//             <button className="scroll-button right" onClick={() => scrollTestimonial('right')}>
//               <FaChevronRight />
//             </button>
//           </div>
//         </div>
//       </section>

//       <section id="verification" className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <h2>Verification & Exports</h2>
          
//           <p className="section-subtitle">
//             When a receipt needs to leave the system, its integrity goes with it.
//           </p>
          
//           <div className="verification-grid">
//             <div className="verification-card">
//               <div className="verification-icon">
//                 <FaFileExport />
//               </div>
//               <h3>Full chronological timeline</h3>
//               <p>Export complete event sequences in original order</p>
//             </div>
            
//             <div className="verification-card">
//               <div className="verification-icon">
//                 <FaLock />
//               </div>
//               <h3>Cryptographic verification</h3>
//               <p>Receipts are cryptographically signed and verifiable</p>
//             </div>
            
//             <div className="verification-card">
//               <div className="verification-icon">
//                 <FaServer />
//               </div>
//               <h3>Server-authoritative timestamps</h3>
//               <p>All timestamps are server-based and cannot be manipulated</p>
//             </div>
//           </div>
          
//           <div style={{ textAlign: 'center', marginTop: '3rem' }}>
//             <FaDownload style={{ fontSize: '2rem', color: 'var(--color-text)', marginBottom: '1rem' }} />
//             <p style={{ fontSize: '1.1rem', fontWeight: '600' }}>
//               <strong>Records can be verified independently.</strong>
//               <br />
//               If anything is altered, verification fails.
//             </p>
//           </div>
//         </div>
//       </section>

//       <section id="faq" className="section">
//         <div className="container">
//           <h2>Have Questions? We Have Answers</h2>
          
//           <p className="section-subtitle">
//             Common questions about Log It Once and systematic documentation.
//           </p>
          
//           <div className="faq-grid">
//             {faqs.map((faq, index) => (
//               <div
//                 key={index}
//                 className={`faq-item ${activeFAQ === index ? 'active' : ''}`}
//                 onClick={() => setActiveFAQ(activeFAQ === index ? null : index)}
//               >
//                 <div className="faq-question">
//                   <span>{faq.question}</span>
//                   <FaChevronDown />
//                 </div>
//                 <div className="faq-answer">
//                   <p>{faq.answer}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       <section className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <div className="cta-card">
//             <h2>Start Now</h2>
//             <p className="cta-subtitle">Log it once. No account required. No workflow change.</p>
            
//             <div className="integration-methods">
//               <h3>Use It Without Changing Your Workflow</h3>
//               <div className="methods">
//                 <div className="method">
//                   <FaEnvelope />
//                   <h4>Email</h4>
//                   <p>BCC <strong>record@logitonce.com</strong></p>
//                 </div>
//                 <div className="method">
//                   <FaMobileAlt />
//                   <h4>App</h4>
//                   <p>One tap to log</p>
//                 </div>
//                 <div className="method">
//                   <FaCalendarAlt />
//                   <h4>Calendar</h4>
//                   <p>Log meetings & deadlines</p>
//                 </div>
//                 <div className="method">
//                   <FaCode />
//                   <h4>API</h4>
//                   <p>Programmatic ingestion</p>
//                 </div>
//               </div>
//             </div>
            
//             <p className="cta-note" style={{ fontSize: '1.1rem', fontWeight: '600', margin: '2rem 0' }}>
//               <strong>No account required to log.</strong>
//             </p>
            
//             <div className="email-example">
//               <div className="email-header">
//                 <span>Email Example</span>
//                 <FaLink />
//               </div>
//               <code>
//                 To: client@example.com<br />
//                 <strong>Bcc: record@logitonce.com</strong><br />
//                 Subject: Project deliverables for review<br />
//                 Body: [Your normal email content]
//               </code>
//             </div>
            
//             <p className="cta-final" style={{ fontSize: '1.1rem', fontWeight: '600', margin: '2rem 0' }}>
//               <strong>That's it. Your receipt will be created automatically.</strong>
//             </p>
//             <button className="cta-button large" onClick={goToSignup}>
//               Get Started Now <FaArrowRight />
//             </button>
//           </div>
//         </div>
//       </section>

//       <footer className="footer">
//         <div className="container">
//           <div className="footer-content">
//             <div>
//               <div className="footer-logo">
//                 <FaReceipt /> Log It Once
//               </div>
//               <p style={{ color: 'rgba(255,255,255,0.7)', maxWidth: '300px' }}>
//                 Create neutral, time-stamped receipts for actions, requests, and outcomes.
//               </p>
//             </div>
//             <div className="footer-links">
//               <a href="mailto:support@logitonce.com">Support: support@logitonce.com</a>
//               <a href="#how">How it works</a>
//               <a href="#uses">Use cases</a>
//               <a href="#verification">Verify</a>
//               <a href="#">Terms</a>
//               <a href="#">Privacy</a>
//             </div>
//           </div>
//           <div className="footer-disclaimer">
//             <p>© Log It Once</p>
//             <p>Log It Once records events and timestamps. It does not provide legal advice or determine outcomes.</p>
//           </div>
//         </div>
//       </footer>
//     </>
//   );
// };

// export default LogItOnce;







































// /* eslint-disable react/jsx-no-undef */
// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from "react-router-dom";
// import logitoncegif from "./log it once Gif.gif"
// import { 
//   FaReceipt, 
//   FaExclamationTriangle, 
//   FaLayerGroup, 
//   FaShieldAlt, 
//   FaPaperPlane, 
//   FaBriefcase, 
//   FaClock, 
//   FaExchangeAlt, 
//   FaHistory, 
//   FaStopwatch,
//   FaLock,
//   FaServer,
//   FaDownload,
//   FaCheckCircle,
//   FaEnvelope,
//   FaMobileAlt,
//   FaCalendarAlt,
//   FaCode,
//   FaArrowRight,
//   FaLink,
//   FaCheck,
//   FaTimes,
//   FaVolumeMute,
//   FaFileExport,
//   FaChevronLeft,
//   FaChevronRight,
//   FaChevronDown,
//   FaHistory as FaReplay
// } from 'react-icons/fa';

// const LogItOnce = () => {
//   const navigate = useNavigate();
//   const [scrolled, setScrolled] = useState(false);
//   const [activeFAQ, setActiveFAQ] = useState(null);
//   const [isGifLoading, setIsGifLoading] = useState(true);
  
//   // Refs for horizontal scrolling
//   const useCasesRef = useRef(null);
//   const statsRef = useRef(null);
//   const testimonialRef = useRef(null);
//   const gifRef = useRef(null);
  
//   const testimonials = [
//     {
//       content: "Log It Once completely changed how we handle client deliverables. Disputes over what was sent and when have dropped to zero. It's become essential to our workflow.",
//       author: "Sarah Chen",
//       role: "Operations Lead, TechFlow Inc.",
//       initials: "SC"
//     },
//     {
//       content: "The moment we started using Log It Once, the 'I never got that email' conversations stopped. It provides a neutral record that both sides can trust.",
//       author: "Marcus Rivera",
//       role: "Legal Counsel, ScaleFast Partners",
//       initials: "MR"
//     },
//     {
//       content: "As a remote team, clear documentation is critical. Log It Once gives us confidence that every request and acknowledgment is preserved exactly as it happened.",
//       author: "Jamila Davis",
//       role: "VP Engineering, RemoteFirst Co.",
//       initials: "JD"
//     },
//     {
//       content: "We've reduced follow-up emails by 80% since implementing Log It Once. The automatic silence recording feature has been a game-changer for accountability.",
//       author: "David Park",
//       role: "Project Manager, Global Solutions",
//       initials: "DP"
//     },
//     {
//       content: "The cryptographic verification gives us legal-grade documentation without the complexity. It's simple, elegant, and absolutely reliable.",
//       author: "Emily Zhang",
//       role: "Compliance Officer, SecureCorp",
//       initials: "EZ"
//     }
//   ];

//   const useCases = [
//     { icon: <FaBriefcase />, title: 'Delivering work and awaiting acceptance' },
//     { icon: <FaPaperPlane />, title: 'Sending a request that requires acknowledgment' },
//     { icon: <FaClock />, title: 'Setting a deadline that matters' },
//     { icon: <FaExchangeAlt />, title: 'Hand-offs and responsibility transfers' },
//     { icon: <FaHistory />, title: 'Giving notice' },
//     { icon: <FaStopwatch />, title: 'Preparing for escalation without escalating' },
//     { icon: <FaExclamationTriangle />, title: 'If you would normally chase, remind, or reconstruct later' },
//     { icon: <FaShieldAlt />, title: 'Client deliverables and acceptance' },
//     { icon: <FaLayerGroup />, title: 'Team communications and decisions' },
//     { icon: <FaFileExport />, title: 'Regulatory compliance documentation' }
//   ];

//   const stats = [
//     { value: "50M+", label: 'Actions Logged', description: 'Across thousands of teams' },
//     { value: "99%", label: 'Reduction in Disputes', description: 'For teams using systematic logging' },
//     { value: "10s", label: 'To Create a Receipt', description: 'Average time per action' },
//     { value: "100%", label: 'Append-Only', description: 'Nothing edited or deleted' },
//     { value: "24/7", label: 'Automated Recording', description: 'Including silence as an outcome' },
//     { value: "∞", label: 'Verifiable History', description: 'Cryptographically signed records' }
//   ];

//   const faqs = [
//     {
//       question: "How do I get started?",
//       answer: "Create a free account, connect your email or app, and start logging actions immediately. No credit card required for the trial."
//     },
//     {
//       question: "What happens if no one responds?",
//       answer: "Silence is recorded as a factual event. After the response window closes, the receipt shows 'No Response Recorded' as the outcome."
//     },
//     {
//       question: "Can receipts be edited or deleted?",
//       answer: "No. Log It Once is append-only. Once created, receipts cannot be edited or deleted, ensuring an authentic record of events."
//     },
//     {
//       question: "How are receipts verified?",
//       answer: "Each receipt includes a server-authoritative timestamp and cryptographic signature that can be independently verified."
//     },
//     {
//       question: "Is there a free trial?",
//       answer: "Yes, you can start with 100 free receipts per month. No credit card required to get started."
//     }
//   ];

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 50);
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const goToSignup = () => {
//     navigate("/signup");
//   };

//   // Horizontal scroll functions
//   const scrollUseCases = (direction) => {
//     if (useCasesRef.current) {
//       const scrollAmount = 300;
//       useCasesRef.current.scrollBy({
//         left: direction === 'left' ? -scrollAmount : scrollAmount,
//         behavior: 'smooth'
//       });
//     }
//   };

//   const scrollStats = (direction) => {
//     if (statsRef.current) {
//       const scrollAmount = 300;
//       statsRef.current.scrollBy({
//         left: direction === 'left' ? -scrollAmount : scrollAmount,
//         behavior: 'smooth'
//       });
//     }
//   };

//   const scrollTestimonial = (direction) => {
//     if (testimonialRef.current) {
//       const scrollAmount = 400;
//       testimonialRef.current.scrollBy({
//         left: direction === 'left' ? -scrollAmount : scrollAmount,
//         behavior: 'smooth'
//       });
//     }
//   };

//   // GIF replay function
//   const replayGif = () => {
//     if (gifRef.current) {
//       const gif = gifRef.current;
//       gif.src = gif.src;
//     }
//   };

//   const handleGifLoad = () => {
//     setIsGifLoading(false);
//   };

//   const handleGifError = () => {
//     setIsGifLoading(false);
//     console.error("Failed to load GIF");
//   };

//   return (
//     <>
//       <style jsx global>{`
//         :root {
//           --color-bg: #ffffff;
//           --color-text: #202020;
//           --color-text-light: #6b7280;
//           --color-accent-light: #E0F5FF;
//           --color-accent-dark: #F0FAFF;
//           --color-button: #202020;
//           --color-button-text: #ffffff;
//           --gradient-primary: linear-gradient(135deg, var(--color-accent-light) 0%, var(--color-accent-dark) 100%);
//           --gradient-subtle: linear-gradient(180deg, var(--color-accent-light) 0%, var(--color-accent-dark) 44.95%, #FFFFFF 100%);
//           --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.05);
//           --shadow-md: 0 8px 30px rgba(0, 0, 0, 0.12);
//           --shadow-lg: 0 20px 60px rgba(0, 0, 0, 0.15);
//           --border-radius: 12px;
//           --border-radius-lg: 24px;
//           --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//           --container-width: 1200px;
//         }

//         * {
//           margin: 0;
//           padding: 0;
//           box-sizing: border-box;
//         }

//         html {
//           scroll-behavior: smooth;
//         }

//         body {
//           font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
//           color: var(--color-text);
//           background-color: var(--color-bg);
//           line-height: 1.6;
//           overflow-x: hidden;
//         }

//         .container {
//           width: 100%;
//           max-width: var(--container-width);
//           margin: 0 auto;
//           padding: 0 24px;
//         }

//         section {
//           padding: 80px 0;
//         }

//         h1, h2, h3, h4 {
//           font-weight: 800;
//           line-height: 1.2;
//         }

//         h1 {
//           font-size: 3.5rem;
//           margin-bottom: 1.5rem;
//         }

//         h2 {
//           font-size: 2.5rem;
//           margin-bottom: 1rem;
//           text-align: center;
//         }

//         h3 {
//           font-size: 1.5rem;
//           margin-bottom: 0.75rem;
//         }

//         p {
//           color: var(--color-text-light);
//           margin-bottom: 1.5rem;
//         }

//         .section-subtitle {
//           text-align: center;
//           max-width: 700px;
//           margin: 0 auto 3rem;
//           font-size: 1.125rem;
//         }

//         /* Animations */
//         @keyframes fadeIn {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }

//         @keyframes fadeInUp {
//           from {
//             opacity: 0;
//             transform: translateY(30px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         @keyframes float {
//           0%, 100% { transform: translateY(0); }
//           50% { transform: translateY(-10px); }
//         }

//         @keyframes pulse {
//           0%, 100% { transform: scale(1); }
//           50% { transform: scale(1.05); }
//         }

//         /* Header */
//         .header {
//           position: sticky;
//           top: 0;
//           z-index: 1000;
//           background-color: rgba(255, 255, 255, 0.95);
//           backdrop-filter: blur(10px);
//           border-bottom: 1px solid rgba(0, 0, 0, 0.05);
//           padding: 1rem 0;
//           transition: var(--transition);
//         }

//         .header.scrolled {
//           box-shadow: var(--shadow-sm);
//         }

//         .header-content {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//         }

//         .logo {
//           display: flex;
//           align-items: center;
//           font-weight: 800;
//           font-size: 1.5rem;
//           text-decoration: none;
//           color: var(--color-text);
//           cursor: pointer;
//           transition: var(--transition);
//         }

//         .logo:hover {
//           transform: scale(1.05);
//         }

//         .logo-icon {
//           margin-right: 10px;
//           font-size: 1.8rem;
//           color: var(--color-text);
//           animation: float 3s ease-in-out infinite;
//         }

//         .nav {
//           display: flex;
//           gap: 2rem;
//         }

//         .nav a {
//           text-decoration: none;
//           color: var(--color-text-light);
//           font-weight: 500;
//           font-size: 0.95rem;
//           position: relative;
//           transition: var(--transition);
//         }

//         .nav a:hover {
//           color: var(--color-text);
//           transform: translateY(-2px);
//         }

//         .cta-button {
//           background-color: var(--color-button);
//           color: var(--color-button-text);
//           border: none;
//           border-radius: 9999px;
//           padding: 12px 24px;
//           font-weight: 700;
//           font-size: 0.95rem;
//           cursor: pointer;
//           transition: var(--transition);
//           display: inline-flex;
//           align-items: center;
//           gap: 8px;
//           text-decoration: none;
//         }

//         .cta-button:hover {
//           transform: translateY(-2px);
//           box-shadow: var(--shadow-md);
//           background: linear-gradient(135deg, #202020, #404040);
//           animation: pulse 1s ease-in-out;
//         }

//         .cta-button.primary {
//           padding: 16px 32px;
//           font-size: 1rem;
//         }

//         .cta-button.large {
//           padding: 18px 40px;
//           font-size: 1.1rem;
//         }

//         /* Hero */
//         .hero {
//           padding: 100px 0 120px;
//           background: var(--gradient-subtle);
//           position: relative;
//           overflow: hidden;
//           animation: fadeIn 1s ease-out;
//         }

//         @media (min-width: 1024px) {
//           .hero {
//             padding: 120px 0 140px;
//           }
//         }

//         .hero-grid {
//           display: grid;
//           grid-template-columns: 1fr;
//           gap: 4rem;
//           align-items: center;
//         }

//         @media (min-width: 1024px) {
//           .hero-grid {
//             grid-template-columns: 1.2fr 1fr;
//             gap: 6rem;
//           }
//         }

//         .hero-content {
//           position: relative;
//           z-index: 2;
//         }

//         .tagline {
//           display: inline-flex;
//           align-items: center;
//           gap: 10px;
//           background: rgba(32, 32, 32, 0.05);
//           color: var(--color-text);
//           font-weight: 600;
//           padding: 8px 16px;
//           border-radius: 9999px;
//           margin-bottom: 1.5rem;
//           animation: fadeInUp 0.8s ease-out 0.2s both;
//         }

//         .hero-subtitle {
//           font-size: 1.25rem;
//           margin-bottom: 3rem;
//           max-width: 700px;
//           animation: fadeInUp 0.8s ease-out 0.4s both;
//         }

//         .hero-actions {
//           display: flex;
//           gap: 1rem;
//           flex-wrap: wrap;
//           animation: fadeInUp 0.8s ease-out 0.6s both;
//         }

//         .secondary-button {
//           background: transparent;
//           color: var(--color-text);
//           border: 2px solid var(--color-text);
//           border-radius: 9999px;
//           padding: 12px 24px;
//           font-weight: 700;
//           font-size: 0.95rem;
//           cursor: pointer;
//           transition: var(--transition);
//           text-decoration: none;
//           display: inline-flex;
//           align-items: center;
//           gap: 8px;
//         }

//         .secondary-button:hover {
//           background-color: var(--color-text);
//           color: white;
//           transform: translateY(-2px);
//           box-shadow: var(--shadow-md);
//         }

      

       

     

//         @media (min-width: 768px) {
//           .gif-wrapper {
//             height: 300px;
//           }
//         }

//         .gif-wrapper:hover {
//           transform: translateY(-5px) translateZ(10px);
//           box-shadow: 
//             0 30px 80px rgba(0, 0, 0, 0.2),
//             0 0 0 1px rgba(224, 245, 255, 0.5);
//         }

//         .hero-gif {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           display: block;
//           border-radius: var(--border-radius-lg);
//           animation: fadeInGif 1.5s ease-out;
//         }

//         @keyframes fadeInGif {
//           from {
//             opacity: 0;
//             transform: scale(0.95);
//           }
//           to {
//             opacity: 1;
//             transform: scale(1);
//           }
//         }

//         /* GIF Overlay Effects */
//         .gif-overlay {
//           position: absolute;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           pointer-events: none;
//           border-radius: var(--border-radius-lg);
//           overflow: hidden;
//         }

//         .overlay-shine {
//           position: absolute;
//           top: -50%;
//           left: -50%;
//           width: 200%;
//           height: 200%;
//           background: linear-gradient(
//             45deg,
//             transparent 30%,
//             rgba(255, 255, 255, 0.1) 50%,
//             transparent 70%
//           );
//           animation: shine 3s ease-in-out infinite;
//         }

//         @keyframes shine {
//           0% {
//             transform: translateX(-100%) translateY(-100%) rotate(45deg);
//           }
//           100% {
//             transform: translateX(100%) translateY(100%) rotate(45deg);
//           }
//         }

//         /* Animated Highlights */
//         .highlight {
//           position: absolute;
//           border-radius: 50%;
//           background: linear-gradient(135deg, rgba(32, 32, 32, 0.1), rgba(224, 245, 255, 0.2));
//           filter: blur(20px);
//           z-index: -1;
//         }

//         .highlight-1 {
//           width: 150px;
//           height: 150px;
//           top: -40px;
//           right: -40px;
//           animation: floatHighlight 8s ease-in-out infinite;
//           background: linear-gradient(135deg, rgba(32, 32, 32, 0.05), rgba(224, 245, 255, 0.3));
//         }

//         .highlight-2 {
//           width: 100px;
//           height: 100px;
//           bottom: -20px;
//           left: -20px;
//           animation: floatHighlight 6s ease-in-out infinite reverse;
//         }

//         .highlight-3 {
//           width: 80px;
//           height: 80px;
//           top: 50%;
//           left: -30px;
//           animation: floatHighlight 10s ease-in-out infinite;
//           background: linear-gradient(135deg, rgba(32, 32, 32, 0.1), rgba(224, 245, 255, 0.4));
//         }

//         @keyframes floatHighlight {
//           0%, 100% {
//             transform: translate(0, 0) scale(1);
//             opacity: 0.7;
//           }
//           33% {
//             transform: translate(20px, -20px) scale(1.1);
//             opacity: 1;
//           }
//           66% {
//             transform: translate(-10px, 10px) scale(0.9);
//             opacity: 0.5;
//           }
//         }

//         /* GIF Controls */
//         .gif-control {
//           position: absolute;
//           bottom: 16px;
//           right: 16px;
//           width: 40px;
//           height: 40px;
//           border-radius: 50%;
//           background: rgba(32, 32, 32, 0.9);
//           color: white;
//           border: none;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           cursor: pointer;
//           transition: var(--transition);
//           opacity: 0;
//           transform: scale(0.8);
//           z-index: 10;
//         }

//         .gif-wrapper:hover .gif-control {
//           opacity: 1;
//           transform: scale(1);
//         }

//         .gif-control:hover {
//           background: var(--color-text);
//           transform: scale(1.1) rotate(90deg);
//         }

//         .gif-control svg {
//           font-size: 1rem;
//         }

//         /* GIF Caption */
//         .gif-caption {
//           display: flex;
//           align-items: center;
//           gap: 12px;
//           margin-top: 1.5rem;
//           padding: 1rem 1.5rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//           animation: slideUpCaption 1s ease-out 0.5s both;
//           max-width: 400px;
//         }

//         @keyframes slideUpCaption {
//           from {
//             opacity: 0;
//             transform: translateY(20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         .caption-icon {
//           width: 40px;
//           height: 40px;
//           border-radius: 50%;
//           background: var(--gradient-primary);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 1.2rem;
//           color: var(--color-text);
//           flex-shrink: 0;
//         }

//         .gif-caption p {
//           margin: 0;
//           font-weight: 600;
//           color: var(--color-text);
//           font-size: 0.95rem;
//         }

//         /* Receipt Preview (Appears on hover) */
//         .receipt-preview {
//           position: absolute;
//           top: -20px;
//           right: -20px;
//           background: white;
//           padding: 1rem 1.5rem;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-lg);
//           border: 2px solid rgba(224, 245, 255, 0.8);
//           opacity: 0;
//           transform: translateX(20px);
//           transition: var(--transition);
//           pointer-events: none;
//           z-index: 20;
//           max-width: 250px;
//         }

//         .gif-wrapper:hover ~ .receipt-preview {
//           opacity: 1;
//           transform: translateX(0);
//         }

//         .preview-header {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//           margin-bottom: 0.5rem;
//         }

//         .preview-header span {
//           font-weight: 700;
//           color: var(--color-text);
//           font-size: 0.9rem;
//         }

//         .preview-text {
//           margin: 0;
//           font-size: 0.85rem;
//           color: var(--color-text-light);
//         }

//         /* Mobile Stats */
//         .mobile-stats {
//           display: flex;
//           gap: 2rem;
//           margin-top: 2rem;
//           padding-top: 2rem;
//           border-top: 1px solid rgba(224, 245, 255, 0.5);
//         }

//         .mobile-stats .stat {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           flex: 1;
//         }

//         .mobile-stats .stat-number {
//           font-size: 2rem;
//           font-weight: 800;
//           color: var(--color-text);
//           display: block;
//           line-height: 1;
//         }

//         .mobile-stats .stat-label {
//           font-size: 0.85rem;
//           color: var(--color-text-light);
//           margin-top: 0.25rem;
//           text-align: center;
//         }

//         /* Horizontal Scroll Sections */
//         .horizontal-scroll-section {
//           position: relative;
//           padding: 0 24px;
//         }

//         .horizontal-scroll-container {
//           display: flex;
//           overflow-x: auto;
//           gap: 24px;
//           padding: 24px 0;
//           scrollbar-width: none;
//           -ms-overflow-style: none;
//           scroll-behavior: smooth;
//         }

//         .horizontal-scroll-container::-webkit-scrollbar {
//           display: none;
//         }

//         .scroll-button {
//           position: absolute;
//           top: 50%;
//           transform: translateY(-50%);
//           background: white;
//           border: 2px solid var(--color-text);
//           border-radius: 50%;
//           width: 48px;
//           height: 48px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           cursor: pointer;
//           transition: var(--transition);
//           z-index: 10;
//           box-shadow: var(--shadow-md);
//         }

//         .scroll-button:hover {
//           background: var(--color-text);
//           color: white;
//           transform: translateY(-50%) scale(1.1);
//         }

//         .scroll-button.left {
//           left: 0;
//         }

//         .scroll-button.right {
//           right: 0;
//         }

//         /* Statistics Section with Horizontal Scroll */
//         .stats-scroll-container {
//           display: flex;
//           overflow-x: auto;
//           gap: 24px;
//           padding: 24px 0;
//           scrollbar-width: none;
//           -ms-overflow-style: none;
//         }

//         .stats-scroll-container::-webkit-scrollbar {
//           display: none;
//         }

//         .stat-card {
//           flex: 0 0 auto;
//           width: 280px;
//           text-align: center;
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           transition: var(--transition);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//           opacity: 0;
//           transform: translateY(30px);
//           animation: fadeInUp 0.8s ease-out forwards;
//         }

//         .stat-card:hover {
//           transform: translateY(-8px);
//           box-shadow: var(--shadow-lg);
//         }

//         .stat-number {
//           font-size: 3rem;
//           font-weight: 800;
//           color: var(--color-text);
//           margin-bottom: 0.5rem;
//           display: block;
//         }

//         .stat-label {
//           font-weight: 600;
//           color: var(--color-text);
//           font-size: 1.1rem;
//           margin-bottom: 0.5rem;
//         }

//         .stat-description {
//           font-size: 0.9rem;
//           color: var(--color-text-light);
//         }

//         /* Use Cases with Horizontal Scroll */
//         .use-cases-scroll-container {
//           display: flex;
//           overflow-x: auto;
//           gap: 24px;
//           padding: 24px 0;
//           scrollbar-width: none;
//           -ms-overflow-style: none;
//         }

//         .use-cases-scroll-container::-webkit-scrollbar {
//           display: none;
//         }

//         .use-case-card {
//           flex: 0 0 auto;
//           width: 320px;
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           transition: var(--transition);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//           text-align: center;
//         }

//         .use-case-card:hover {
//           transform: translateY(-8px);
//           box-shadow: var(--shadow-md);
//           border-color: rgba(224, 245, 255, 0.8);
//         }

//         .use-case-icon {
//           font-size: 2.5rem;
//           color: var(--color-text);
//           margin-bottom: 1.5rem;
//           display: block;
//           transition: var(--transition);
//         }

//         .use-case-card:hover .use-case-icon {
//           transform: scale(1.2) rotate(5deg);
//         }

//         /* Testimonials with Horizontal Scroll */
//         .testimonials-scroll-container {
//           display: flex;
//           overflow-x: auto;
//           gap: 32px;
//           padding: 32px 0;
//           scrollbar-width: none;
//           -ms-overflow-style: none;
//         }

//         .testimonials-scroll-container::-webkit-scrollbar {
//           display: none;
//         }

//         .testimonial-card {
//           flex: 0 0 auto;
//           width: 380px;
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           transition: var(--transition);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//         }

//         .testimonial-card:hover {
//           transform: translateY(-8px);
//           box-shadow: var(--shadow-md);
//         }

//         .testimonial-content {
//           font-style: italic;
//           margin-bottom: 1.5rem;
//           color: var(--color-text);
//           font-size: 1.1rem;
//           line-height: 1.6;
//         }

//         .testimonial-author {
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//         }

//         .author-avatar {
//           width: 48px;
//           height: 48px;
//           border-radius: 50%;
//           background: var(--gradient-primary);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-weight: 700;
//           color: var(--color-text);
//           transition: var(--transition);
//         }

//         .testimonial-card:hover .author-avatar {
//           transform: rotate(360deg);
//         }

//         /* What Is Section */
//         .what-is-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
//           gap: 2rem;
//           margin-top: 3rem;
//         }

//         .what-is-card {
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           transition: var(--transition);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//           text-align: center;
//         }

//         .what-is-card:hover {
//           transform: translateY(-8px);
//           box-shadow: var(--shadow-md);
//         }

//         .what-is-icon {
//           font-size: 2.5rem;
//           color: var(--color-text);
//           margin-bottom: 1.5rem;
//         }

//         /* How It Works */
//         .steps {
//           display: flex;
//           flex-direction: column;
//           gap: 2rem;
//           max-width: 800px;
//           margin: 3rem auto 0;
//         }

//         .step {
//           display: flex;
//           gap: 2rem;
//           align-items: flex-start;
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//         }

//         .step-number {
//           width: 60px;
//           height: 60px;
//           border-radius: 50%;
//           background: var(--color-text);
//           color: white;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 1.5rem;
//           font-weight: 800;
//           flex-shrink: 0;
//         }

//         .step-content {
//           flex: 1;
//         }

//         .outcome-options {
//           display: flex;
//           flex-direction: column;
//           gap: 12px;
//           margin: 1rem 0;
//         }

//         .outcome-option {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//           font-size: 0.95rem;
//           transition: var(--transition);
//           padding: 8px 12px;
//           border-radius: 8px;
//           background: rgba(224, 245, 255, 0.2);
//         }

//         .outcome-option:hover {
//           transform: translateX(10px);
//           background: rgba(224, 245, 255, 0.4);
//         }

//         .option-icon {
//           font-size: 1.25rem;
//           flex-shrink: 0;
//         }

//         .option-icon.acknowledged {
//           color: #10B981;
//         }

//         .option-icon.disputed {
//           color: #EF4444;
//         }

//         .option-icon.no-response {
//           color: #6B7280;
//         }

//         /* Outcomes Section */
//         .outcomes-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
//           gap: 2rem;
//           margin-top: 3rem;
//         }

//         .outcome-card {
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           transition: var(--transition);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//         }

//         .outcome-card:hover {
//           transform: translateY(-8px);
//           box-shadow: var(--shadow-md);
//         }

//         .outcome-card.acknowledged {
//           border-top: 4px solid #10B981;
//         }

//         .outcome-card.disputed {
//           border-top: 4px solid #EF4444;
//         }

//         .outcome-card.no-response {
//           border-top: 4px solid #6B7280;
//         }

//         .outcome-header {
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//           margin-bottom: 1rem;
//         }

//         .outcome-icon {
//           font-size: 2rem;
//         }

//         /* Differentiator Section */
//         .comparison {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
//           gap: 3rem;
//           margin-top: 3rem;
//         }

//         .comparison-column {
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//         }

//         .comparison-list {
//           display: flex;
//           flex-direction: column;
//           gap: 1rem;
//           margin-top: 1rem;
//         }

//         .comparison-item {
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//           padding: 0.75rem;
//           border-radius: 8px;
//           transition: var(--transition);
//         }

//         .comparison-item:hover {
//           background: rgba(224, 245, 255, 0.2);
//           transform: translateX(5px);
//         }

//         .is-icon {
//           width: 24px;
//           height: 24px;
//           border-radius: 50%;
//           background: #10B981;
//           color: white;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-weight: bold;
//           flex-shrink: 0;
//         }

//         .not-icon {
//           width: 24px;
//           height: 24px;
//           border-radius: 50%;
//           background: #EF4444;
//           color: white;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-weight: bold;
//           flex-shrink: 0;
//         }

//         /* Verification Section */
//         .verification-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
//           gap: 2rem;
//           margin-top: 3rem;
//         }

//         .verification-card {
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           transition: var(--transition);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//           text-align: center;
//         }

//         .verification-card:hover {
//           transform: translateY(-8px);
//           box-shadow: var(--shadow-md);
//         }

//         .verification-icon {
//           font-size: 2.5rem;
//           color: var(--color-text);
//           margin-bottom: 1.5rem;
//         }

//         /* CTA Section */
//         .cta-card {
//           background: white;
//           border-radius: var(--border-radius);
//           padding: 4rem;
//           text-align: center;
//           box-shadow: var(--shadow-lg);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//           max-width: 900px;
//           margin: 0 auto;
//         }

//         .cta-subtitle {
//           font-size: 1.25rem;
//           margin-bottom: 3rem;
//         }

//         .integration-methods {
//           margin: 3rem 0;
//         }

//         .methods {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
//           gap: 2rem;
//           margin-top: 2rem;
//         }

//         .method {
//           padding: 1.5rem;
//           background: rgba(224, 245, 255, 0.2);
//           border-radius: var(--border-radius);
//           transition: var(--transition);
//         }

//         .method:hover {
//           transform: translateY(-5px);
//           background: rgba(224, 245, 255, 0.4);
//         }

//         .method svg {
//           font-size: 2rem;
//           color: var(--color-text);
//           margin-bottom: 1rem;
//         }

//         .email-example {
//           background: rgba(32, 32, 32, 0.05);
//           border-radius: var(--border-radius);
//           padding: 2rem;
//           margin: 2rem 0;
//           text-align: left;
//           font-family: 'Monaco', 'Courier New', monospace;
//           font-size: 0.9rem;
//         }

//         .email-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 1rem;
//           color: var(--color-text);
//           font-weight: 600;
//         }

//         /* FAQ */
//         .faq-grid {
//           max-width: 800px;
//           margin: 3rem auto 0;
//         }

//         .faq-item {
//           border-bottom: 1px solid rgba(224, 245, 255, 0.5);
//           padding: 1.5rem 0;
//         }

//         .faq-question {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           cursor: pointer;
//           font-weight: 700;
//           font-size: 1.1rem;
//           color: var(--color-text);
//           transition: var(--transition);
//         }

//         .faq-question:hover {
//           color: var(--color-text);
//           transform: translateX(5px);
//         }

//         .faq-answer {
//           max-height: 0;
//           overflow: hidden;
//           transition: max-height 0.3s ease;
//           color: var(--color-text-light);
//           padding-top: 0;
//         }

//         .faq-item.active .faq-answer {
//           max-height: 300px;
//           padding-top: 1rem;
//         }

//         .faq-item.active .faq-question svg {
//           transform: rotate(180deg);
//         }

//         /* Footer */
//         .footer {
//           background-color: var(--color-text);
//           color: white;
//           padding: 4rem 0 2rem;
//         }

//         .footer-content {
//           display: flex;
//           justify-content: space-between;
//           align-items: flex-start;
//           flex-wrap: wrap;
//           gap: 2rem;
//           margin-bottom: 3rem;
//         }

//         .footer-logo {
//           display: flex;
//           align-items: center;
//           font-weight: 800;
//           font-size: 1.5rem;
//           margin-bottom: 1rem;
//         }

//         .footer-links {
//           display: flex;
//           flex-direction: column;
//           gap: 0.75rem;
//         }

//         .footer-links a {
//           color: rgba(255, 255, 255, 0.7);
//           text-decoration: none;
//           transition: var(--transition);
//         }

//         .footer-links a:hover {
//           color: white;
//           transform: translateX(5px);
//         }

//         .footer-disclaimer {
//           text-align: center;
//           padding-top: 2rem;
//           border-top: 1px solid rgba(255, 255, 255, 0.1);
//           color: rgba(255, 255, 255, 0.5);
//           font-size: 0.9rem;
//         }

//         /* Loading State for GIF */
//         .gif-wrapper.loading .hero-gif {
//           opacity: 0;
//         }

//         .gif-wrapper.loading::after {
//           content: '';
//           position: absolute;
//           top: 50%;
//           left: 50%;
//           transform: translate(-50%, -50%);
//           width: 40px;
//           height: 40px;
//           border: 3px solid rgba(224, 245, 255, 0.3);
//           border-top-color: var(--color-text);
//           border-radius: 50%;
//           animation: spin 1s linear infinite;
//         }

//         @keyframes spin {
//           to {
//             transform: translate(-50%, -50%) rotate(360deg);
//           }
//         }

//         /* Accessibility */
//         @media (prefers-reduced-motion: reduce) {
//           .hero-gif,
//           .overlay-shine,
//           .highlight,
//           .gif-caption,
//           .receipt-preview,
//           .logo-icon,
//           .tagline,
//           .hero-subtitle,
//           .hero-actions,
//           .stat-card {
//             animation: none !important;
//             transition: none !important;
//           }
          
//           .gif-wrapper {
//             transform: none !important;
//           }
//         }

//         /* Responsive */
//         @media (max-width: 768px) {
//           h1 {
//             font-size: 2.5rem;
//           }
          
//           h2 {
//             font-size: 2rem;
//           }
          
//           .header-content {
//             flex-direction: column;
//             gap: 1rem;
//           }
          
//           .nav {
//             gap: 1rem;
//             flex-wrap: wrap;
//             justify-content: center;
//           }
          
//           .hero-actions {
//             justify-content: center;
//           }
          
//           .step {
//             flex-direction: column;
//             text-align: center;
//           }
          
//           .cta-card {
//             padding: 2rem;
//           }
          
//           .scroll-button {
//             width: 40px;
//             height: 40px;
//             font-size: 0.8rem;
//           }
          
//           .stat-card,
//           .use-case-card,
//           .testimonial-card {
//             width: 280px;
//           }
          
//           .gif-wrapper {
//             height: 220px;
//           }
          
//           .receipt-preview {
//             display: none;
//           }
          
//           .highlight {
//             display: none;
//           }
//         }

//         @media (max-width: 480px) {
//           .container {
//             padding: 0 16px;
//           }
          
//           section {
//             padding: 60px 0;
//           }
          
//           .horizontal-scroll-section {
//             padding: 0 16px;
//           }
          
//           .scroll-button {
//             display: none;
//           }
          
//           .gif-wrapper {
//             height: 200px;
//           }
          
//           .mobile-stats {
//             flex-direction: column;
//             gap: 1rem;
//           }
          
//           .mobile-stats .stat {
//             flex-direction: row;
//             justify-content: center;
//             gap: 1rem;
//           }
          
//           .mobile-stats .stat-number {
//             font-size: 1.75rem;
//           }
          
//           .gif-caption {
//             flex-direction: column;
//             text-align: center;
//             gap: 0.5rem;
//           }
//         }

//         @media (max-width: 1023px) {
//           .hero-grid {
//             gap: 3rem;
//           }
//         }
//       `}</style>

//       <header className={`header ${scrolled ? 'scrolled' : ''}`}>
//         <div className="container">
//           <div className="header-content">
//             <div className="logo">
//               <FaReceipt className="logo-icon" />
//               <span>Log It Once</span>
//             </div>

//             <nav className="nav">
//               <a href="#what">What</a>
//               <a href="#why">Why</a>
//               <a href="#how">How</a>
//               <a href="#uses">Use Cases</a>
//               <a href="#verification">Verification</a>
//             </nav>

//             <button className="cta-button" onClick={goToSignup}>
//               Start Logging
//             </button>
//           </div>
//         </div>
//       </header>

//       <section className="hero">
//         <div className="container">
//           <div className="hero-grid">
//             <div className="hero-content">
//               <div className="tagline">
//                 <FaReceipt /> Log it once. Get a receipt.
//               </div>
              
//               <h1>Log It Once</h1>
              
//               <p className="hero-subtitle">
//                 Create a neutral, time-stamped receipt for actions, requests, and outcomes —
//                 including when no one responds.
//                 <br />
//                 <strong>No chasing. No confrontation. Nothing rewritten later.</strong>
//               </p>
              
//               <div className="hero-actions">
//                 <button className="cta-button primary" onClick={goToSignup}>
//                   USE FOR FREE <FaArrowRight />
//                 </button>
                
//                 <a href="#how" className="secondary-button">
//                   See How It Works
//                 </a>
//               </div>
              
//               {/* Stats preview for mobile */}
//               <div className="mobile-stats">
//                 <div className="stat">
//                   <span className="stat-number">50M+</span>
//                   <span className="stat-label">Actions Logged</span>
//                 </div>
//                 <div className="stat">
//                   <span className="stat-number">99%</span>
//                   <span className="stat-label">Less Disputes</span>
//                 </div>
//               </div>
//             </div>
            
//             {/* GIF Animation Container */}
//             <div className="hero-animation-container">
//               {/* <div className={`gif-wrapper ${isGifLoading ? 'loading' : ''}`}> */}
//                 {/* Replace with your actual GIF path */}
//                 <img 
//                   ref={gifRef}
//                   src={logitoncegif} 
//                   alt="Log It Once Animation - Showing receipt creation process"
//                   className="hero-gif"
//                   loading="eager"
//                   onLoad={handleGifLoad}
//                   onError={handleGifError}
//                 />
                
//                 {/* Optional: Add subtle overlay effects */}
//                 {/* <div className="gif-overlay">
//                   <div className="overlay-shine"></div>
//                 </div> */}
                
//                 {/* Animated highlights around GIF */}
                
                
//                 {/* Play button for control */}
//                 {/* <button className="gif-control" onClick={replayGif} aria-label="Replay animation">
//                   <FaReplay />
//                 </button> */}
//               </div>
              
//               {/* Caption/Description for the GIF */}
//               {/* <div className="gif-caption">
//                 <div className="caption-icon">
//                   <FaReceipt />
//                 </div>
//                 <p>Watch how receipts are created in seconds</p>
//               </div> */}
              
//               {/* Interactive receipt preview that appears on hover */}
         
//             {/* </div> */}
//           </div>
//         </div>
//       </section>

//       <section id="what" className="section">
//         <div className="container">
//           <h2>What Log It Once Is</h2>
          
//           <p className="section-subtitle">
//             Log It Once issues a receipt the moment something happens.
//             That receipt records:
//           </p>
          
//           <div className="what-is-grid">
//             <div className="what-is-card">
//               <div className="what-is-icon">
//                 <FaShieldAlt />
//               </div>
//               <h3>What was sent or done</h3>
//               <p>The action, request, or delivery</p>
//             </div>
            
//             <div className="what-is-card">
//               <div className="what-is-icon">
//                 <FaLayerGroup />
//               </div>
//               <h3>Who was involved</h3>
//               <p>Sender and recipient information</p>
//             </div>
            
//             <div className="what-is-card">
//               <div className="what-is-icon">
//                 <FaServer />
//               </div>
//               <h3>When it occurred</h3>
//               <p>Server-authoritative time</p>
//             </div>
            
//             <div className="what-is-card">
//               <div className="what-is-icon">
//                 <FaHistory />
//               </div>
//               <h3>What happened next — or didn't</h3>
//               <p>Response or silence recorded</p>
//             </div>
//           </div>
          
//           <div style={{ textAlign: 'center', marginTop: '2rem' }}>
//             <FaCheckCircle style={{ fontSize: '2rem', color: '#10B981', marginBottom: '1rem' }} />
//             <p style={{ fontSize: '1.1rem', fontWeight: '600' }}>Receipts are append-only. Nothing is edited. Nothing is deleted.</p>
//           </div>
//         </div>
//       </section>

//       <section className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <h2>The Numbers That Power Log It Once</h2>
          
//           <p className="section-subtitle">
//             Real impact from teams who document actions and outcomes systematically.
//           </p>
          
//           <div className="horizontal-scroll-section">
//             <button className="scroll-button left" onClick={() => scrollStats('left')}>
//               <FaChevronLeft />
//             </button>
            
//             <div className="stats-scroll-container" ref={statsRef}>
//               {stats.map((stat, index) => (
//                 <div
//                   key={stat.label}
//                   className="stat-card"
//                   style={{ animationDelay: `${index * 0.1}s` }}
//                 >
//                   <span className="stat-number">
//                     {stat.value}
//                   </span>
//                   <span className="stat-label">{stat.label}</span>
//                   <p className="stat-description">{stat.description}</p>
//                 </div>
//               ))}
//             </div>
            
//             <button className="scroll-button right" onClick={() => scrollStats('right')}>
//               <FaChevronRight />
//             </button>
//           </div>
//         </div>
//       </section>

//       <section id="why" className="section">
//         <div className="container">
//           <h2>Why This Exists</h2>
          
//           <div style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto' }}>
//             <h3 style={{ marginBottom: '1rem' }}>Most systems record messages. They lose outcomes.</h3>
//             <p>
//               When time passes and nothing happens, the record disappears — 
//               and disputes begin. Log It Once preserves the sequence.
//             </p>
//           </div>
          
//           <div style={{ 
//             display: 'flex', 
//             justifyContent: 'center', 
//             alignItems: 'center',
//             marginTop: '3rem',
//             padding: '2rem',
//             background: 'white',
//             borderRadius: 'var(--border-radius)',
//             boxShadow: 'var(--shadow-sm)'
//           }}>
//             <div style={{ display: 'flex', alignItems: 'center', gap: '2rem', flexWrap: 'wrap', justifyContent: 'center' }}>
//               <div style={{ textAlign: 'center' }}>
//                 <div style={{ 
//                   width: '80px', 
//                   height: '80px', 
//                   borderRadius: '50%', 
//                   background: 'var(--color-text)', 
//                   color: 'white',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   fontSize: '2rem',
//                   fontWeight: '800',
//                   margin: '0 auto 1rem'
//                 }}>1</div>
//                 <p style={{ fontWeight: '600' }}>Message Sent</p>
//               </div>
              
//               <div style={{ fontSize: '2rem', color: 'var(--color-text-light)' }}>→</div>
              
//               <div style={{ textAlign: 'center' }}>
//                 <div style={{ 
//                   width: '80px', 
//                   height: '80px', 
//                   borderRadius: '50%', 
//                   background: '#EF4444', 
//                   color: 'white',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   fontSize: '2rem',
//                   fontWeight: '800',
//                   margin: '0 auto 1rem'
//                 }}>2</div>
//                 <p style={{ fontWeight: '600' }}>Outcome Lost</p>
//               </div>
              
//               <div style={{ fontSize: '2rem', color: 'var(--color-text-light)' }}>→</div>
              
//               <div style={{ textAlign: 'center' }}>
//                 <div style={{ 
//                   width: '80px', 
//                   height: '80px', 
//                   borderRadius: '50%', 
//                   background: '#DC2626', 
//                   color: 'white',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   fontSize: '2rem',
//                   fontWeight: '800',
//                   margin: '0 auto 1rem'
//                 }}>3</div>
//                 <p style={{ fontWeight: '600' }}>Dispute Begins</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       <section id="how" className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <h2>How It Works</h2>
          
//           <div className="steps">
//             <div className="step">
//               <div className="step-number">1</div>
//               <div className="step-content">
//                 <h3>You log an action</h3>
//                 <p>Email, app, calendar, or API.</p>
//               </div>
//             </div>
            
//             <div className="step">
//               <div className="step-number">2</div>
//               <div className="step-content">
//                 <h3>A receipt is created immediately</h3>
//                 <p>Time-stamped by the server.</p>
//               </div>
//             </div>
            
//             <div className="step">
//               <div className="step-number">3</div>
//               <div className="step-content">
//                 <h3>The recipient responds — or doesn't</h3>
//                 <p>Recipients receive a receipt link with three possible outcomes:</p>
//                 <div className="outcome-options">
//                   <div className="outcome-option">
//                     <FaCheck className="option-icon acknowledged" />
//                     <span>Acknowledge — they formally accept receipt</span>
//                   </div>
//                   <div className="outcome-option">
//                     <FaTimes className="option-icon disputed" />
//                     <span>Dispute — they formally contest it</span>
//                   </div>
//                   <div className="outcome-option">
//                     <FaVolumeMute className="option-icon no-response" />
//                     <span>No response — if nothing happens by the deadline, silence is recorded automatically</span>
//                   </div>
//                 </div>
//                 <p className="note" style={{ fontSize: '0.9rem', color: 'var(--color-text-light)', marginTop: '1rem' }}>
//                   <small>Replies sent by regular email are not recorded as formal responses.</small>
//                 </p>
//               </div>
//             </div>
            
//             <div className="step">
//               <div className="step-number">4</div>
//               <div className="step-content">
//                 <h3>The timeline grows intact</h3>
//                 <p>All events are appended in order. Nothing is rewritten later.</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       <section className="section">
//         <div className="container">
//           <h2>The Three Outcomes (clearly defined)</h2>
          
//           <p className="section-subtitle">
//             Every receipt ends in one of these states:
//           </p>
          
//           <div className="outcomes-grid">
//             <div className="outcome-card acknowledged">
//               <div className="outcome-header">
//                 <FaCheck className="outcome-icon" style={{ color: '#10B981' }} />
//                 <h3>Acknowledged</h3>
//               </div>
//               <p>The recipient explicitly accepted via the receipt link.</p>
//             </div>
            
//             <div className="outcome-card disputed">
//               <div className="outcome-header">
//                 <FaTimes className="outcome-icon" style={{ color: '#EF4444' }} />
//                 <h3>Disputed</h3>
//               </div>
//               <p>The recipient formally contested via the receipt link.</p>
//             </div>
            
//             <div className="outcome-card no-response">
//               <div className="outcome-header">
//                 <FaVolumeMute className="outcome-icon" style={{ color: '#6B7280' }} />
//                 <h3>No Response Recorded</h3>
//               </div>
//               <p>No formal response occurred within the response window.</p>
//             </div>
//           </div>
          
//           <div style={{ textAlign: 'center', marginTop: '3rem' }}>
//             <p style={{ fontSize: '1.1rem', fontWeight: '600' }}>
//               <strong>No interpretation is added. Only sequence is preserved.</strong>
//             </p>
//           </div>
//         </div>
//       </section>

//       <section className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <h2>Neutral by Design</h2>
          
//           <div className="comparison">
//             <div className="comparison-column">
//               <h3>Log It Once is:</h3>
//               <div className="comparison-list">
//                 <div className="comparison-item">
//                   <div className="is-icon">✓</div>
//                   <span>Chronological</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="is-icon">✓</div>
//                   <span>Append-only</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="is-icon">✓</div>
//                   <span>Independently verifiable</span>
//                 </div>
//               </div>
//             </div>
            
//             <div className="comparison-column">
//               <h3>Log It Once is not:</h3>
//               <div className="comparison-list">
//                 <div className="comparison-item">
//                   <div className="not-icon">✗</div>
//                   <span>A judge</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="not-icon">✗</div>
//                   <span>An arbitrator</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="not-icon">✗</div>
//                   <span>A score</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="not-icon">✗</div>
//                   <span>A decision engine</span>
//                 </div>
//               </div>
//             </div>
//           </div>
          
//           <div style={{ textAlign: 'center', marginTop: '3rem' }}>
//             <p style={{ fontSize: '1.1rem', fontWeight: '600' }}>
//               It records what happened. It does not decide what it means.
//             </p>
//           </div>
//         </div>
//       </section>

//       <section className="section">
//         <div className="container">
//           <h2>What The Receipt Includes</h2>
          
//           <div className="what-is-grid">
//             <div className="what-is-card">
//               <div style={{ fontSize: '2.5rem', marginBottom: '1.5rem' }}>📤</div>
//               <h3>What was sent or done</h3>
//               <p>The action, request, or delivery</p>
//             </div>
            
//             <div className="what-is-card">
//               <div style={{ fontSize: '2.5rem', marginBottom: '1.5rem' }}>👥</div>
//               <h3>Who was involved</h3>
//               <p>Sender and recipient information</p>
//             </div>
            
//             <div className="what-is-card">
//               <div style={{ fontSize: '2.5rem', marginBottom: '1.5rem' }}>🕒</div>
//               <h3>When it occurred</h3>
//               <p>Server-authoritative time</p>
//             </div>
            
//             <div className="what-is-card">
//               <div style={{ fontSize: '2.5rem', marginBottom: '1.5rem' }}>🔇</div>
//               <h3>What happened next — or didn't</h3>
//               <p>Non-response is recorded as a factual event</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       <section id="uses" className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <h2>When People Use Log It Once</h2>
          
//           <p className="section-subtitle">
//             Common scenarios where systematic documentation makes the difference.
//           </p>
          
//           <div className="horizontal-scroll-section">
//             <button className="scroll-button left" onClick={() => scrollUseCases('left')}>
//               <FaChevronLeft />
//             </button>
            
//             <div className="use-cases-scroll-container" ref={useCasesRef}>
//               {useCases.map((useCase, index) => (
//                 <div key={index} className="use-case-card">
//                   <div className="use-case-icon">
//                     {useCase.icon}
//                   </div>
//                   <h3>{useCase.title}</h3>
//                 </div>
//               ))}
//             </div>
            
//             <button className="scroll-button right" onClick={() => scrollUseCases('right')}>
//               <FaChevronRight />
//             </button>
//           </div>
//         </div>
//       </section>

//       <section className="section">
//         <div className="container">
//           <h2>Teams Love Log It Once</h2>
          
//           <p className="section-subtitle">
//             See how teams use systematic documentation to reduce conflict and increase accountability.
//           </p>
          
//           <div className="horizontal-scroll-section">
//             <button className="scroll-button left" onClick={() => scrollTestimonial('left')}>
//               <FaChevronLeft />
//             </button>
            
//             <div className="testimonials-scroll-container" ref={testimonialRef}>
//               {testimonials.map((testimonial, index) => (
//                 <div key={testimonial.author} className="testimonial-card">
//                   <p className="testimonial-content">
//                     "{testimonial.content}"
//                   </p>
//                   <div className="testimonial-author">
//                     <div className="author-avatar">
//                       {testimonial.initials}
//                     </div>
//                     <div className="author-info">
//                       <h4>{testimonial.author}</h4>
//                       <p>{testimonial.role}</p>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
            
//             <button className="scroll-button right" onClick={() => scrollTestimonial('right')}>
//               <FaChevronRight />
//             </button>
//           </div>
//         </div>
//       </section>

//       <section id="verification" className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <h2>Verification & Exports</h2>
          
//           <p className="section-subtitle">
//             When a receipt needs to leave the system, its integrity goes with it.
//           </p>
          
//           <div className="verification-grid">
//             <div className="verification-card">
//               <div className="verification-icon">
//                 <FaFileExport />
//               </div>
//               <h3>Full chronological timeline</h3>
//               <p>Export complete event sequences in original order</p>
//             </div>
            
//             <div className="verification-card">
//               <div className="verification-icon">
//                 <FaLock />
//               </div>
//               <h3>Cryptographic verification</h3>
//               <p>Receipts are cryptographically signed and verifiable</p>
//             </div>
            
//             <div className="verification-card">
//               <div className="verification-icon">
//                 <FaServer />
//               </div>
//               <h3>Server-authoritative timestamps</h3>
//               <p>All timestamps are server-based and cannot be manipulated</p>
//             </div>
//           </div>
          
//           <div style={{ textAlign: 'center', marginTop: '3rem' }}>
//             <FaDownload style={{ fontSize: '2rem', color: 'var(--color-text)', marginBottom: '1rem' }} />
//             <p style={{ fontSize: '1.1rem', fontWeight: '600' }}>
//               <strong>Records can be verified independently.</strong>
//               <br />
//               If anything is altered, verification fails.
//             </p>
//           </div>
//         </div>
//       </section>

//       <section id="faq" className="section">
//         <div className="container">
//           <h2>Have Questions? We Have Answers</h2>
          
//           <p className="section-subtitle">
//             Common questions about Log It Once and systematic documentation.
//           </p>
          
//           <div className="faq-grid">
//             {faqs.map((faq, index) => (
//               <div
//                 key={index}
//                 className={`faq-item ${activeFAQ === index ? 'active' : ''}`}
//                 onClick={() => setActiveFAQ(activeFAQ === index ? null : index)}
//               >
//                 <div className="faq-question">
//                   <span>{faq.question}</span>
//                   <FaChevronDown />
//                 </div>
//                 <div className="faq-answer">
//                   <p>{faq.answer}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       <section className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <div className="cta-card">
//             <h2>Start Now</h2>
//             <p className="cta-subtitle">Log it once. No account required. No workflow change.</p>
            
//             <div className="integration-methods">
//               <h3>Use It Without Changing Your Workflow</h3>
//               <div className="methods">
//                 <div className="method">
//                   <FaEnvelope />
//                   <h4>Email</h4>
//                   <p>BCC <strong>record@logitonce.com</strong></p>
//                 </div>
//                 <div className="method">
//                   <FaMobileAlt />
//                   <h4>App</h4>
//                   <p>One tap to log</p>
//                 </div>
//                 <div className="method">
//                   <FaCalendarAlt />
//                   <h4>Calendar</h4>
//                   <p>Log meetings & deadlines</p>
//                 </div>
//                 <div className="method">
//                   <FaCode />
//                   <h4>API</h4>
//                   <p>Programmatic ingestion</p>
//                 </div>
//               </div>
//             </div>
            
//             <p className="cta-note" style={{ fontSize: '1.1rem', fontWeight: '600', margin: '2rem 0' }}>
//               <strong>No account required to log.</strong>
//             </p>
            
//             <div className="email-example">
//               <div className="email-header">
//                 <span>Email Example</span>
//                 <FaLink />
//               </div>
//               <code>
//                 To: client@example.com<br />
//                 <strong>Bcc: record@logitonce.com</strong><br />
//                 Subject: Project deliverables for review<br />
//                 Body: [Your normal email content]
//               </code>
//             </div>
            
//             <p className="cta-final" style={{ fontSize: '1.1rem', fontWeight: '600', margin: '2rem 0' }}>
//               <strong>That's it. Your receipt will be created automatically.</strong>
//             </p>
//             <button className="cta-button large" onClick={goToSignup}>
//               Get Started Now <FaArrowRight />
//             </button>
//           </div>
//         </div>
//       </section>

//       <footer className="footer">
//         <div className="container">
//           <div className="footer-content">
//             <div>
//               <div className="footer-logo">
//                 <FaReceipt /> Log It Once
//               </div>
//               <p style={{ color: 'rgba(255,255,255,0.7)', maxWidth: '300px' }}>
//                 Create neutral, time-stamped receipts for actions, requests, and outcomes.
//               </p>
//             </div>
//             <div className="footer-links">
//               <a href="mailto:support@logitonce.com">Support: support@logitonce.com</a>
//               <a href="#how">How it works</a>
//               <a href="#uses">Use cases</a>
//               <a href="#verification">Verify</a>
//               <a href="#">Terms</a>
//               <a href="#">Privacy</a>
//             </div>
//           </div>
//           <div className="footer-disclaimer">
//             <p>© Log It Once</p>
//             <p>Log It Once records events and timestamps. It does not provide legal advice or determine outcomes.</p>
//           </div>
//         </div>
//       </footer>
//     </>
//   );
// };

// export default LogItOnce;


























































// /* eslint-disable react/jsx-no-undef */
// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from "react-router-dom";
// import logitoncegif from "./log it once Gif.gif"
// import { 
//   FaReceipt, 
//   FaExclamationTriangle, 
//   FaLayerGroup, 
//   FaShieldAlt, 
//   FaPaperPlane, 
//   FaBriefcase, 
//   FaClock, 
//   FaExchangeAlt, 
//   FaHistory, 
//   FaStopwatch,
//   FaLock,
//   FaServer,
//   FaDownload,
//   FaCheckCircle,
//   FaEnvelope,
//   FaMobileAlt,
//   FaCalendarAlt,
//   FaCode,
//   FaArrowRight,
//   FaLink,
//   FaCheck,
//   FaTimes,
//   FaVolumeMute,
//   FaFileExport,
//   FaChevronLeft,
//   FaChevronRight,
//   FaChevronDown,
//   FaHistory as FaReplay
// } from 'react-icons/fa';

// const LogItOnce = () => {
//   const navigate = useNavigate();
//   const [scrolled, setScrolled] = useState(false);
//   const [activeFAQ, setActiveFAQ] = useState(null);
//   const [isGifLoading, setIsGifLoading] = useState(true);
  
//   // Refs for horizontal scrolling
//   const useCasesRef = useRef(null);
//   const statsRef = useRef(null);
//   const testimonialRef = useRef(null);
//   const gifRef = useRef(null);
  
//   // Updated testimonials from HERO data
//   const testimonials = [
//     {
//       content: "We stopped having ‘we never approved that’ conversations.",
//       author: "Founder",
//       role: "Growth Agency",
//       initials: "FG"
//     },
//     {
//       content: "Clients respond faster when outcomes are recorded.",
//       author: "Managing Director",
//       role: "Dev Studio",
//       initials: "MD"
//     },
//     {
//       content: "It removed the awkward follow-up dynamic.",
//       author: "Ops Lead",
//       role: "Consultancy",
//       initials: "OL"
//     }
//   ];

//   // Updated use cases from HERO data
//   const useCases = [
//     { icon: <FaBriefcase />, title: 'Delivering a milestone for approval' },
//     { icon: <FaExchangeAlt />, title: 'Confirming scope changes' },
//     { icon: <FaPaperPlane />, title: 'Sending final invoices' },
//     { icon: <FaClock />, title: 'Transferring responsibility' },
//     { icon: <FaStopwatch />, title: 'Setting deadlines that matter' },
//     { icon: <FaExclamationTriangle />, title: 'Preparing for escalation without escalating' },
//     { icon: <FaHistory />, title: 'If you might need to reconstruct it later — record it once' }
//   ];

//   const stats = [
//     { value: "50M+", label: 'Actions Logged', description: 'Across thousands of teams' },
//     { value: "99%", label: 'Reduction in Disputes', description: 'For teams using systematic logging' },
//     { value: "10s", label: 'To Create a Receipt', description: 'Average time per action' },
//     { value: "100%", label: 'Append-Only', description: 'Nothing edited or deleted' },
//     { value: "24/7", label: 'Automated Recording', description: 'Including silence as an outcome' },
//     { value: "∞", label: 'Verifiable History', description: 'Cryptographically signed records' }
//   ];

//   const faqs = [
//     {
//       question: "How do I get started?",
//       answer: "Create a free account, connect your email or app, and start logging actions immediately. No credit card required for the trial."
//     },
//     {
//       question: "What happens if no one responds?",
//       answer: "Silence is recorded as a factual event. After the response window closes, the receipt shows 'No Response Recorded' as the outcome."
//     },
//     {
//       question: "Can receipts be edited or deleted?",
//       answer: "No. Log It Once is append-only. Once created, receipts cannot be edited or deleted, ensuring an authentic record of events."
//     },
//     {
//       question: "How are receipts verified?",
//       answer: "Each receipt includes a server-authoritative timestamp and cryptographic signature that can be independently verified."
//     },
//     {
//       question: "Is there a free trial?",
//       answer: "Yes, you can start with 100 free receipts per month. No credit card required to get started."
//     }
//   ];

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 50);
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const goToSignup = () => {
//     navigate("/signup");
//   };

//   // Horizontal scroll functions
//   const scrollUseCases = (direction) => {
//     if (useCasesRef.current) {
//       const scrollAmount = 300;
//       useCasesRef.current.scrollBy({
//         left: direction === 'left' ? -scrollAmount : scrollAmount,
//         behavior: 'smooth'
//       });
//     }
//   };

//   const scrollStats = (direction) => {
//     if (statsRef.current) {
//       const scrollAmount = 300;
//       statsRef.current.scrollBy({
//         left: direction === 'left' ? -scrollAmount : scrollAmount,
//         behavior: 'smooth'
//       });
//     }
//   };

//   const scrollTestimonial = (direction) => {
//     if (testimonialRef.current) {
//       const scrollAmount = 400;
//       testimonialRef.current.scrollBy({
//         left: direction === 'left' ? -scrollAmount : scrollAmount,
//         behavior: 'smooth'
//       });
//     }
//   };

//   // GIF replay function
//   const replayGif = () => {
//     if (gifRef.current) {
//       const gif = gifRef.current;
//       gif.src = gif.src;
//     }
//   };

//   const handleGifLoad = () => {
//     setIsGifLoading(false);
//   };

//   const handleGifError = () => {
//     setIsGifLoading(false);
//     console.error("Failed to load GIF");
//   };

//   return (
//     <>
//       <style jsx global>{`
//         :root {
//           --color-bg: #ffffff;
//           --color-text: #202020;
//           --color-text-light: #6b7280;
//           --color-accent-light: #E0F5FF;
//           --color-accent-dark: #F0FAFF;
//           --color-button: #202020;
//           --color-button-text: #ffffff;
//           --gradient-primary: linear-gradient(135deg, var(--color-accent-light) 0%, var(--color-accent-dark) 100%);
//           --gradient-subtle: linear-gradient(180deg, var(--color-accent-light) 0%, var(--color-accent-dark) 44.95%, #FFFFFF 100%);
//           --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.05);
//           --shadow-md: 0 8px 30px rgba(0, 0, 0, 0.12);
//           --shadow-lg: 0 20px 60px rgba(0, 0, 0, 0.15);
//           --border-radius: 12px;
//           --border-radius-lg: 24px;
//           --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//           --container-width: 1200px;
//         }

//         * {
//           margin: 0;
//           padding: 0;
//           box-sizing: border-box;
//         }

//         html {
//           scroll-behavior: smooth;
//         }

//         body {
//           font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
//           color: var(--color-text);
//           background-color: var(--color-bg);
//           line-height: 1.6;
//           overflow-x: hidden;
//         }

//         .container {
//           width: 100%;
//           max-width: var(--container-width);
//           margin: 0 auto;
//           padding: 0 24px;
//         }

//         section {
//           padding: 80px 0;
//         }

//         h1, h2, h3, h4 {
//           font-weight: 800;
//           line-height: 1.2;
//         }

//         h1 {
//           font-size: 3.5rem;
//           margin-bottom: 1.5rem;
//         }

//         h2 {
//           font-size: 2.5rem;
//           margin-bottom: 1rem;
//           text-align: center;
//         }

//         h3 {
//           font-size: 1.5rem;
//           margin-bottom: 0.75rem;
//         }

//         p {
//           color: var(--color-text-light);
//           margin-bottom: 1.5rem;
//         }

//         .section-subtitle {
//           text-align: center;
//           max-width: 700px;
//           margin: 0 auto 3rem;
//           font-size: 1.125rem;
//         }

//         /* Animations */
//         @keyframes fadeIn {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }

//         @keyframes fadeInUp {
//           from {
//             opacity: 0;
//             transform: translateY(30px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         @keyframes float {
//           0%, 100% { transform: translateY(0); }
//           50% { transform: translateY(-10px); }
//         }

//         @keyframes pulse {
//           0%, 100% { transform: scale(1); }
//           50% { transform: scale(1.05); }
//         }

//         /* Header */
//         .header {
//           position: sticky;
//           top: 0;
//           z-index: 1000;
//           background-color: rgba(255, 255, 255, 0.95);
//           backdrop-filter: blur(10px);
//           border-bottom: 1px solid rgba(0, 0, 0, 0.05);
//           padding: 1rem 0;
//           transition: var(--transition);
//         }

//         .header.scrolled {
//           box-shadow: var(--shadow-sm);
//         }

//         .header-content {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//         }

//         .logo {
//           display: flex;
//           align-items: center;
//           font-weight: 800;
//           font-size: 1.5rem;
//           text-decoration: none;
//           color: var(--color-text);
//           cursor: pointer;
//           transition: var(--transition);
//         }

//         .logo:hover {
//           transform: scale(1.05);
//         }

//         .logo-icon {
//           margin-right: 10px;
//           font-size: 1.8rem;
//           color: var(--color-text);
//           animation: float 3s ease-in-out infinite;
//         }

//         .nav {
//           display: flex;
//           gap: 2rem;
//         }

//         .nav a {
//           text-decoration: none;
//           color: var(--color-text-light);
//           font-weight: 500;
//           font-size: 0.95rem;
//           position: relative;
//           transition: var(--transition);
//         }

//         .nav a:hover {
//           color: var(--color-text);
//           transform: translateY(-2px);
//         }

//         .cta-button {
//           background-color: var(--color-button);
//           color: var(--color-button-text);
//           border: none;
//           border-radius: 9999px;
//           padding: 12px 24px;
//           font-weight: 700;
//           font-size: 0.95rem;
//           cursor: pointer;
//           transition: var(--transition);
//           display: inline-flex;
//           align-items: center;
//           gap: 8px;
//           text-decoration: none;
//         }

//         .cta-button:hover {
//           transform: translateY(-2px);
//           box-shadow: var(--shadow-md);
//           background: linear-gradient(135deg, #202020, #404040);
//           animation: pulse 1s ease-in-out;
//         }

//         .cta-button.primary {
//           padding: 16px 32px;
//           font-size: 1rem;
//         }

//         .cta-button.large {
//           padding: 18px 40px;
//           font-size: 1.1rem;
//         }

//         .microcopy {
//           display: block;
//           font-size: 0.85rem;
//           font-weight: normal;
//           color: var(--color-text-light);
//           margin-top: 0.5rem;
//         }

//         /* Hero */
//         .hero {
//           padding: 100px 0 120px;
//           background: var(--gradient-subtle);
//           position: relative;
//           overflow: hidden;
//           animation: fadeIn 1s ease-out;
//         }

//         @media (min-width: 1024px) {
//           .hero {
//             padding: 120px 0 140px;
//           }
//         }

//         .hero-grid {
//           display: grid;
//           grid-template-columns: 1fr;
//           gap: 4rem;
//           align-items: center;
//         }

//         @media (min-width: 1024px) {
//           .hero-grid {
//             grid-template-columns: 1.2fr 1fr;
//             gap: 6rem;
//           }
//         }

//         .hero-content {
//           position: relative;
//           z-index: 2;
//         }

//         .tagline {
//           display: inline-flex;
//           align-items: center;
//           gap: 10px;
//           background: rgba(32, 32, 32, 0.05);
//           color: var(--color-text);
//           font-weight: 600;
//           padding: 8px 16px;
//           border-radius: 9999px;
//           margin-bottom: 1.5rem;
//           animation: fadeInUp 0.8s ease-out 0.2s both;
//         }

//         .hero-subtitle {
//           font-size: 1.25rem;
//           margin-bottom: 3rem;
//           max-width: 700px;
//           animation: fadeInUp 0.8s ease-out 0.4s both;
//         }

//         .hero-actions {
//           display: flex;
//           gap: 1rem;
//           flex-wrap: wrap;
//           animation: fadeInUp 0.8s ease-out 0.6s both;
//         }

//         .secondary-button {
//           background: transparent;
//           color: var(--color-text);
//           border: 2px solid var(--color-text);
//           border-radius: 9999px;
//           padding: 12px 24px;
//           font-weight: 700;
//           font-size: 0.95rem;
//           cursor: pointer;
//           transition: var(--transition);
//           text-decoration: none;
//           display: inline-flex;
//           align-items: center;
//           gap: 8px;
//         }

//         .secondary-button:hover {
//           background-color: var(--color-text);
//           color: white;
//           transform: translateY(-2px);
//           box-shadow: var(--shadow-md);
//         }

//         .hero-gif {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           display: block;
//           border-radius: var(--border-radius-lg);
//           animation: fadeInGif 1.5s ease-out;
//         }

//         @keyframes fadeInGif {
//           from {
//             opacity: 0;
//             transform: scale(0.95);
//           }
//           to {
//             opacity: 1;
//             transform: scale(1);
//           }
//         }

//         .gif-wrapper {
//           position: relative;
//           width: 100%;
//           height: 280px;
//           border-radius: var(--border-radius-lg);
//           overflow: hidden;
//           box-shadow: var(--shadow-lg);
//           transform: perspective(1000px) rotateY(-2deg) rotateX(2deg);
//           transition: var(--transition);
//           background: linear-gradient(145deg, #ffffff, #f5f5f5);
//         }

//         @media (min-width: 768px) {
//           .gif-wrapper {
//             height: 300px;
//           }
//         }

//         .gif-wrapper:hover {
//           transform: translateY(-5px) translateZ(10px);
//           box-shadow: 
//             0 30px 80px rgba(0, 0, 0, 0.2),
//             0 0 0 1px rgba(224, 245, 255, 0.5);
//         }

//         .gif-control {
//           position: absolute;
//           bottom: 16px;
//           right: 16px;
//           width: 40px;
//           height: 40px;
//           border-radius: 50%;
//           background: rgba(32, 32, 32, 0.9);
//           color: white;
//           border: none;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           cursor: pointer;
//           transition: var(--transition);
//           opacity: 0;
//           transform: scale(0.8);
//           z-index: 10;
//         }

//         .gif-wrapper:hover .gif-control {
//           opacity: 1;
//           transform: scale(1);
//         }

//         .gif-control:hover {
//           background: var(--color-text);
//           transform: scale(1.1) rotate(90deg);
//         }

//         .gif-caption {
//           display: flex;
//           align-items: center;
//           gap: 12px;
//           margin-top: 1.5rem;
//           padding: 1rem 1.5rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//           animation: slideUpCaption 1s ease-out 0.5s both;
//           max-width: 400px;
//         }

//         @keyframes slideUpCaption {
//           from {
//             opacity: 0;
//             transform: translateY(20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         .caption-icon {
//           width: 40px;
//           height: 40px;
//           border-radius: 50%;
//           background: var(--gradient-primary);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 1.2rem;
//           color: var(--color-text);
//           flex-shrink: 0;
//         }

//         .gif-caption p {
//           margin: 0;
//           font-weight: 600;
//           color: var(--color-text);
//           font-size: 0.95rem;
//         }

//         /* Mobile Stats */
//         .mobile-stats {
//           display: flex;
//           gap: 2rem;
//           margin-top: 2rem;
//           padding-top: 2rem;
//           border-top: 1px solid rgba(224, 245, 255, 0.5);
//         }

//         .mobile-stats .stat {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           flex: 1;
//         }

//         .mobile-stats .stat-number {
//           font-size: 2rem;
//           font-weight: 800;
//           color: var(--color-text);
//           display: block;
//           line-height: 1;
//         }

//         .mobile-stats .stat-label {
//           font-size: 0.85rem;
//           color: var(--color-text-light);
//           margin-top: 0.25rem;
//           text-align: center;
//         }

//         /* Horizontal Scroll Sections */
//         .horizontal-scroll-section {
//           position: relative;
//           padding: 0 24px;
//         }

//         .horizontal-scroll-container {
//           display: flex;
//           overflow-x: auto;
//           gap: 24px;
//           padding: 24px 0;
//           scrollbar-width: none;
//           -ms-overflow-style: none;
//           scroll-behavior: smooth;
//         }

//         .horizontal-scroll-container::-webkit-scrollbar {
//           display: none;
//         }

//         .scroll-button {
//           position: absolute;
//           top: 50%;
//           transform: translateY(-50%);
//           background: white;
//           border: 2px solid var(--color-text);
//           border-radius: 50%;
//           width: 48px;
//           height: 48px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           cursor: pointer;
//           transition: var(--transition);
//           z-index: 10;
//           box-shadow: var(--shadow-md);
//         }

//         .scroll-button:hover {
//           background: var(--color-text);
//           color: white;
//           transform: translateY(-50%) scale(1.1);
//         }

//         .scroll-button.left {
//           left: 0;
//         }

//         .scroll-button.right {
//           right: 0;
//         }

//         /* Statistics Section with Horizontal Scroll */
//         .stats-scroll-container {
//           display: flex;
//           overflow-x: auto;
//           gap: 24px;
//           padding: 24px 0;
//           scrollbar-width: none;
//           -ms-overflow-style: none;
//         }

//         .stats-scroll-container::-webkit-scrollbar {
//           display: none;
//         }

//         .stat-card {
//           flex: 0 0 auto;
//           width: 280px;
//           text-align: center;
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           transition: var(--transition);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//           opacity: 0;
//           transform: translateY(30px);
//           animation: fadeInUp 0.8s ease-out forwards;
//         }

//         .stat-card:hover {
//           transform: translateY(-8px);
//           box-shadow: var(--shadow-lg);
//         }

//         .stat-number {
//           font-size: 3rem;
//           font-weight: 800;
//           color: var(--color-text);
//           margin-bottom: 0.5rem;
//           display: block;
//         }

//         .stat-label {
//           font-weight: 600;
//           color: var(--color-text);
//           font-size: 1.1rem;
//           margin-bottom: 0.5rem;
//         }

//         .stat-description {
//           font-size: 0.9rem;
//           color: var(--color-text-light);
//         }

//         /* Use Cases with Horizontal Scroll */
//         .use-cases-scroll-container {
//           display: flex;
//           overflow-x: auto;
//           gap: 24px;
//           padding: 24px 0;
//           scrollbar-width: none;
//           -ms-overflow-style: none;
//         }

//         .use-cases-scroll-container::-webkit-scrollbar {
//           display: none;
//         }

//         .use-case-card {
//           flex: 0 0 auto;
//           width: 320px;
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           transition: var(--transition);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//           text-align: center;
//         }

//         .use-case-card:hover {
//           transform: translateY(-8px);
//           box-shadow: var(--shadow-md);
//           border-color: rgba(224, 245, 255, 0.8);
//         }

//         .use-case-icon {
//           font-size: 2.5rem;
//           color: var(--color-text);
//           margin-bottom: 1.5rem;
//           display: block;
//           transition: var(--transition);
//         }

//         .use-case-card:hover .use-case-icon {
//           transform: scale(1.2) rotate(5deg);
//         }

//         /* Testimonials with Horizontal Scroll */
//         .testimonials-scroll-container {
//           display: flex;
//           overflow-x: auto;
//           gap: 32px;
//           padding: 32px 0;
//           scrollbar-width: none;
//           -ms-overflow-style: none;
//         }

//         .testimonials-scroll-container::-webkit-scrollbar {
//           display: none;
//         }

//         .testimonial-card {
//           flex: 0 0 auto;
//           width: 380px;
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           transition: var(--transition);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//         }

//         .testimonial-card:hover {
//           transform: translateY(-8px);
//           box-shadow: var(--shadow-md);
//         }

//         .testimonial-content {
//           font-style: italic;
//           margin-bottom: 1.5rem;
//           color: var(--color-text);
//           font-size: 1.1rem;
//           line-height: 1.6;
//         }

//         .testimonial-author {
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//         }

//         .author-avatar {
//           width: 48px;
//           height: 48px;
//           border-radius: 50%;
//           background: var(--gradient-primary);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-weight: 700;
//           color: var(--color-text);
//           transition: var(--transition);
//         }

//         .testimonial-card:hover .author-avatar {
//           transform: rotate(360deg);
//         }

//         /* What Is Section */
//         .what-is-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
//           gap: 2rem;
//           margin-top: 3rem;
//         }

//         .what-is-card {
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           transition: var(--transition);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//           text-align: center;
//         }

//         .what-is-card:hover {
//           transform: translateY(-8px);
//           box-shadow: var(--shadow-md);
//         }

//         .what-is-icon {
//           font-size: 2.5rem;
//           color: var(--color-text);
//           margin-bottom: 1.5rem;
//         }

//         /* How It Works */
//         .steps {
//           display: flex;
//           flex-direction: column;
//           gap: 2rem;
//           max-width: 800px;
//           margin: 3rem auto 0;
//         }

//         .step {
//           display: flex;
//           gap: 2rem;
//           align-items: flex-start;
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//         }

//         .step-number {
//           width: 60px;
//           height: 60px;
//           border-radius: 50%;
//           background: var(--color-text);
//           color: white;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 1.5rem;
//           font-weight: 800;
//           flex-shrink: 0;
//         }

//         .step-content {
//           flex: 1;
//         }

//         .outcome-options {
//           display: flex;
//           flex-direction: column;
//           gap: 12px;
//           margin: 1rem 0;
//         }

//         .outcome-option {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//           font-size: 0.95rem;
//           transition: var(--transition);
//           padding: 8px 12px;
//           border-radius: 8px;
//           background: rgba(224, 245, 255, 0.2);
//         }

//         .outcome-option:hover {
//           transform: translateX(10px);
//           background: rgba(224, 245, 255, 0.4);
//         }

//         .option-icon {
//           font-size: 1.25rem;
//           flex-shrink: 0;
//         }

//         .option-icon.acknowledged {
//           color: #10B981;
//         }

//         .option-icon.disputed {
//           color: #EF4444;
//         }

//         .option-icon.no-response {
//           color: #6B7280;
//         }

//         /* Outcomes Section */
//         .outcomes-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
//           gap: 2rem;
//           margin-top: 3rem;
//         }

//         .outcome-card {
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           transition: var(--transition);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//         }

//         .outcome-card:hover {
//           transform: translateY(-8px);
//           box-shadow: var(--shadow-md);
//         }

//         .outcome-card.acknowledged {
//           border-top: 4px solid #10B981;
//         }

//         .outcome-card.disputed {
//           border-top: 4px solid #EF4444;
//         }

//         .outcome-card.no-response {
//           border-top: 4px solid #6B7280;
//         }

//         .outcome-header {
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//           margin-bottom: 1rem;
//         }

//         .outcome-icon {
//           font-size: 2rem;
//         }

//         /* Differentiator Section */
//         .comparison {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
//           gap: 3rem;
//           margin-top: 3rem;
//         }

//         .comparison-column {
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//         }

//         .comparison-list {
//           display: flex;
//           flex-direction: column;
//           gap: 1rem;
//           margin-top: 1rem;
//         }

//         .comparison-item {
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//           padding: 0.75rem;
//           border-radius: 8px;
//           transition: var(--transition);
//         }

//         .comparison-item:hover {
//           background: rgba(224, 245, 255, 0.2);
//           transform: translateX(5px);
//         }

//         .is-icon {
//           width: 24px;
//           height: 24px;
//           border-radius: 50%;
//           background: #10B981;
//           color: white;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-weight: bold;
//           flex-shrink: 0;
//         }

//         .not-icon {
//           width: 24px;
//           height: 24px;
//           border-radius: 50%;
//           background: #EF4444;
//           color: white;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-weight: bold;
//           flex-shrink: 0;
//         }

//         /* Verification Section */
//         .verification-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
//           gap: 2rem;
//           margin-top: 3rem;
//         }

//         .verification-card {
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           transition: var(--transition);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//           text-align: center;
//         }

//         .verification-card:hover {
//           transform: translateY(-8px);
//           box-shadow: var(--shadow-md);
//         }

//         .verification-icon {
//           font-size: 2.5rem;
//           color: var(--color-text);
//           margin-bottom: 1.5rem;
//         }

//         /* CTA Section */
//         .cta-card {
//           background: white;
//           border-radius: var(--border-radius);
//           padding: 4rem;
//           text-align: center;
//           box-shadow: var(--shadow-lg);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//           max-width: 900px;
//           margin: 0 auto;
//         }

//         .cta-subtitle {
//           font-size: 1.25rem;
//           margin-bottom: 3rem;
//         }

//         .integration-methods {
//           margin: 3rem 0;
//         }

//         .methods {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
//           gap: 2rem;
//           margin-top: 2rem;
//         }

//         .method {
//           padding: 1.5rem;
//           background: rgba(224, 245, 255, 0.2);
//           border-radius: var(--border-radius);
//           transition: var(--transition);
//         }

//         .method:hover {
//           transform: translateY(-5px);
//           background: rgba(224, 245, 255, 0.4);
//         }

//         .method svg {
//           font-size: 2rem;
//           color: var(--color-text);
//           margin-bottom: 1rem;
//         }

//         .email-example {
//           background: rgba(32, 32, 32, 0.05);
//           border-radius: var(--border-radius);
//           padding: 2rem;
//           margin: 2rem 0;
//           text-align: left;
//           font-family: 'Monaco', 'Courier New', monospace;
//           font-size: 0.9rem;
//         }

//         .email-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 1rem;
//           color: var(--color-text);
//           font-weight: 600;
//         }

//         /* FAQ */
//         .faq-grid {
//           max-width: 800px;
//           margin: 3rem auto 0;
//         }

//         .faq-item {
//           border-bottom: 1px solid rgba(224, 245, 255, 0.5);
//           padding: 1.5rem 0;
//         }

//         .faq-question {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           cursor: pointer;
//           font-weight: 700;
//           font-size: 1.1rem;
//           color: var(--color-text);
//           transition: var(--transition);
//         }

//         .faq-question:hover {
//           color: var(--color-text);
//           transform: translateX(5px);
//         }

//         .faq-answer {
//           max-height: 0;
//           overflow: hidden;
//           transition: max-height 0.3s ease;
//           color: var(--color-text-light);
//           padding-top: 0;
//         }

//         .faq-item.active .faq-answer {
//           max-height: 300px;
//           padding-top: 1rem;
//         }

//         .faq-item.active .faq-question svg {
//           transform: rotate(180deg);
//         }

//         /* Footer */
//         .footer {
//           background-color: var(--color-text);
//           color: white;
//           padding: 4rem 0 2rem;
//         }

//         .footer-content {
//           display: flex;
//           justify-content: space-between;
//           align-items: flex-start;
//           flex-wrap: wrap;
//           gap: 2rem;
//           margin-bottom: 3rem;
//         }

//         .footer-logo {
//           display: flex;
//           align-items: center;
//           font-weight: 800;
//           font-size: 1.5rem;
//           margin-bottom: 1rem;
//         }

//         .footer-links {
//           display: flex;
//           flex-direction: column;
//           gap: 0.75rem;
//         }

//         .footer-links a {
//           color: rgba(255, 255, 255, 0.7);
//           text-decoration: none;
//           transition: var(--transition);
//         }

//         .footer-links a:hover {
//           color: white;
//           transform: translateX(5px);
//         }

//         .footer-disclaimer {
//           text-align: center;
//           padding-top: 2rem;
//           border-top: 1px solid rgba(255, 255, 255, 0.1);
//           color: rgba(255, 255, 255, 0.5);
//           font-size: 0.9rem;
//         }

//         /* Loading State for GIF */
//         .gif-wrapper.loading .hero-gif {
//           opacity: 0;
//         }

//         .gif-wrapper.loading::after {
//           content: '';
//           position: absolute;
//           top: 50%;
//           left: 50%;
//           transform: translate(-50%, -50%);
//           width: 40px;
//           height: 40px;
//           border: 3px solid rgba(224, 245, 255, 0.3);
//           border-top-color: var(--color-text);
//           border-radius: 50%;
//           animation: spin 1s linear infinite;
//         }

//         @keyframes spin {
//           to {
//             transform: translate(-50%, -50%) rotate(360deg);
//           }
//         }

//         /* Accessibility */
//         @media (prefers-reduced-motion: reduce) {
//           .hero-gif,
//           .overlay-shine,
//           .highlight,
//           .gif-caption,
//           .receipt-preview,
//           .logo-icon,
//           .tagline,
//           .hero-subtitle,
//           .hero-actions,
//           .stat-card {
//             animation: none !important;
//             transition: none !important;
//           }
          
//           .gif-wrapper {
//             transform: none !important;
//           }
//         }

//         /* Responsive */
//         @media (max-width: 768px) {
//           h1 {
//             font-size: 2.5rem;
//           }
          
//           h2 {
//             font-size: 2rem;
//           }
          
//           .header-content {
//             flex-direction: column;
//             gap: 1rem;
//           }
          
//           .nav {
//             gap: 1rem;
//             flex-wrap: wrap;
//             justify-content: center;
//           }
          
//           .hero-actions {
//             justify-content: center;
//           }
          
//           .step {
//             flex-direction: column;
//             text-align: center;
//           }
          
//           .cta-card {
//             padding: 2rem;
//           }
          
//           .scroll-button {
//             width: 40px;
//             height: 40px;
//             font-size: 0.8rem;
//           }
          
//           .stat-card,
//           .use-case-card,
//           .testimonial-card {
//             width: 280px;
//           }
          
//           .gif-wrapper {
//             height: 220px;
//           }
          
//           .receipt-preview {
//             display: none;
//           }
          
//           .highlight {
//             display: none;
//           }
//         }

//         @media (max-width: 480px) {
//           .container {
//             padding: 0 16px;
//           }
          
//           section {
//             padding: 60px 0;
//           }
          
//           .horizontal-scroll-section {
//             padding: 0 16px;
//           }
          
//           .scroll-button {
//             display: none;
//           }
          
//           .gif-wrapper {
//             height: 200px;
//           }
          
//           .mobile-stats {
//             flex-direction: column;
//             gap: 1rem;
//           }
          
//           .mobile-stats .stat {
//             flex-direction: row;
//             justify-content: center;
//             gap: 1rem;
//           }
          
//           .mobile-stats .stat-number {
//             font-size: 1.75rem;
//           }
          
//           .gif-caption {
//             flex-direction: column;
//             text-align: center;
//             gap: 0.5rem;
//           }
//         }

//         @media (max-width: 1023px) {
//           .hero-grid {
//             gap: 3rem;
//           }
//         }
//       `}</style>

//       <header className={`header ${scrolled ? 'scrolled' : ''}`}>
//         <div className="container">
//           <div className="header-content">
//             <div className="logo">
//               <FaReceipt className="logo-icon" />
//               <span>Log It Once</span>
//             </div>

//             <nav className="nav">
//               <a href="#problem">Problem</a>
//               <a href="#how">How</a>
//               <a href="#uses">Use Cases</a>
//               <a href="#what">What</a>
//               <a href="#verification">Verification</a>
//             </nav>

//             <button className="cta-button" onClick={goToSignup}>
//               Try It On Your Next Milestone Email
//             </button>
//           </div>
//         </div>
//       </header>

//       <section className="hero">
//         <div className="container">
//           <div className="hero-grid">
//             <div className="hero-content">
//               <div className="tagline">
//                 <FaReceipt /> Log it once. Get a receipt.
//               </div>
              
//               <h1>Client Silence After Delivery Is Not Neutral.</h1>
              
//               <p className="hero-subtitle">
//                 You sent the milestone. They didn’t respond. Weeks later: “We never approved that.”<br />
//                 When approval isn’t captured, leverage shifts.<br />
//                 <strong>Log It Once records the outcome before reconstruction becomes your only option.</strong>
//               </p>
              
//               <div className="hero-actions">
//                 <button className="cta-button primary" onClick={goToSignup}>
//                   Try It On Your Next Milestone Email (Free) <FaArrowRight />
                  
//                 </button>
//                                  <span className="microcopy" >Takes 30 seconds. No credit card. No meeting.</span>

               
//                 {/* <span className="microcopy">Takes 30 seconds. No credit card. No meeting.</span>
                
//                 <a href="#how" className="secondary-button">
//                   See How It Works
//                 </a> */}
//               </div>
//                <a href="#how" className="secondary-button">
//                   See How It Works
//                 </a>
//               {/* Stats preview for mobile */}
//               <div className="mobile-stats">
//                 <div className="stat">
//                   <span className="stat-number">50M+</span>
//                   <span className="stat-label">Actions Logged</span>
//                 </div>
//                 <div className="stat">
//                   <span className="stat-number">99%</span>
//                   <span className="stat-label">Less Disputes</span>
//                 </div>
//               </div>
//             </div>
            
//             {/* GIF Animation Container */}
//             <div style={{marginBottom:230,}}>
//                 <img 
//                   ref={gifRef}
//                   src={logitoncegif} 
//                   alt="Log It Once Animation - Showing receipt creation process"
//                   className="hero-gif"
//                   loading="eager"
//                   onLoad={handleGifLoad}
//                   onError={handleGifError}
//                 />
                
//                 {/* Play button for control */}
//                 <button className="gif-control" onClick={replayGif} aria-label="Replay animation">
//                   <FaReplay />
//                 </button>
//               </div>
              
//               {/* Caption/Description for the GIF */}
//               <div className="gif-caption">
//                 <div className="caption-icon">
//                   <FaReceipt />
//                 </div>
//                 <p>Watch how receipts are created in seconds</p>
//               </div>
//           </div>
//         </div>
//       </section>

//       {/* The Real Problem Section */}
//       <section id="problem" className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <h2>The Most Expensive Email Is the One With No Reply.</h2>
//           <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
//             <p style={{ fontSize: '1.25rem', marginBottom: '2rem' }}>
//               Service firms don’t lose money because they fail. They lose money because:
//             </p>
//             <ul style={{ listStyle: 'none', padding: 0, textAlign: 'left', display: 'inline-block' }}>
//               <li style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
//                 <FaTimes style={{ color: '#EF4444' }} /> Approval was implied, not recorded.
//               </li>
//               <li style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
//                 <FaTimes style={{ color: '#EF4444' }} /> A client went silent.
//               </li>
//               <li style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
//                 <FaTimes style={{ color: '#EF4444' }} /> Scope was reinterpreted later.
//               </li>
//               <li style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
//                 <FaTimes style={{ color: '#EF4444' }} /> The final invoice stalled.
//               </li>
//             </ul>
//             <p style={{ fontSize: '1.25rem', marginTop: '2rem', fontWeight: '600' }}>
//               “We never approved that.”<br />
//               When nothing happens, nothing gets documented.<br />
//               That’s when leverage flips.
//             </p>
//           </div>
//         </div>
//       </section>

//       <section id="how" className="section">
//         <div className="container">
//           <h2>How It Works</h2>
//           <p className="section-subtitle">Three Steps. No Workflow Change.</p>
          
//           <div className="steps">
//             <div className="step">
//               <div className="step-number">1</div>
//               <div className="step-content">
//                 <h3>Send your milestone email normally</h3>
//                 <p>Just include your unique Log It Once address in BCC.</p>
//               </div>
//             </div>
            
//             <div className="step">
//               <div className="step-number">2</div>
//               <div className="step-content">
//                 <h3>The recipient sees three options</h3>
//                 <div className="outcome-options">
//                   <div className="outcome-option">
//                     <FaCheck className="option-icon acknowledged" />
//                     <span>Acknowledge</span>
//                   </div>
//                   <div className="outcome-option">
//                     <FaTimes className="option-icon disputed" />
//                     <span>Dispute</span>
//                   </div>
//                   <div className="outcome-option">
//                     <FaVolumeMute className="option-icon no-response" />
//                     <span>No Response Recorded</span>
//                   </div>
//                 </div>
//                 <p>No account required for them. No confrontation. No chasing. Just a clear outcome.</p>
//               </div>
//             </div>
            
//             <div className="step">
//               <div className="step-number">3</div>
//               <div className="step-content">
//                 <h3>Whatever happens — or doesn’t — is captured</h3>
//                 <p>You get a neutral, time‑stamped receipt. If they don't respond, that's recorded too.</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Outcome States */}
//       <section className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <h2>The Three Outcome States</h2>
//           <p className="section-subtitle">Every logged action ends in one of three states:</p>
          
//           <div className="outcomes-grid">
//             <div className="outcome-card acknowledged">
//               <div className="outcome-header">
//                 <FaCheck className="outcome-icon" style={{ color: '#10B981' }} />
//                 <h3>Acknowledged</h3>
//               </div>
//               <p>The recipient formally accepted.</p>
//             </div>
            
//             <div className="outcome-card disputed">
//               <div className="outcome-header">
//                 <FaTimes className="outcome-icon" style={{ color: '#EF4444' }} />
//                 <h3>Disputed</h3>
//               </div>
//               <p>The recipient formally contested.</p>
//             </div>
            
//             <div className="outcome-card no-response">
//               <div className="outcome-header">
//                 <FaVolumeMute className="outcome-icon" style={{ color: '#6B7280' }} />
//                 <h3>No Response Recorded</h3>
//               </div>
//               <p>No formal response occurred within the response window.</p>
//             </div>
//           </div>
          
//           <div style={{ textAlign: 'center', marginTop: '2rem' }}>
//             <p style={{ fontSize: '1.1rem', fontWeight: '600' }}>
//               No interpretation is added. Only sequence is preserved.
//             </p>
//           </div>
//         </div>
//       </section>

//       <section id="uses" className="section">
//         <div className="container">
//           <h2>When to Use Log It Once</h2>
          
//           <p className="section-subtitle">
//             Use it when delivering a milestone, confirming scope, sending final invoices, transferring responsibility, setting deadlines that matter, or preparing for escalation without escalating.
//           </p>
          
//           <div className="horizontal-scroll-section">
//             <button className="scroll-button left" onClick={() => scrollUseCases('left')}>
//               <FaChevronLeft />
//             </button>
            
//             <div className="use-cases-scroll-container" ref={useCasesRef}>
//               {useCases.map((useCase, index) => (
//                 <div key={index} className="use-case-card">
//                   <div className="use-case-icon">
//                     {useCase.icon}
//                   </div>
//                   <h3>{useCase.title}</h3>
//                 </div>
//               ))}
//             </div>
            
//             <button className="scroll-button right" onClick={() => scrollUseCases('right')}>
//               <FaChevronRight />
//             </button>
//           </div>
//         </div>
//       </section>

//       {/* What This Is / Is Not */}
//       <section id="what" className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <h2>What This Is</h2>
//           <div className="comparison">
//             <div className="comparison-column">
//               <h3>Log It Once is:</h3>
//               <div className="comparison-list">
//                 <div className="comparison-item">
//                   <div className="is-icon">✓</div>
//                   <span>Chronological</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="is-icon">✓</div>
//                   <span>Append-only</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="is-icon">✓</div>
//                   <span>Server time‑stamped</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="is-icon">✓</div>
//                   <span>Independently verifiable</span>
//                 </div>
//               </div>
//             </div>
            
//             <div className="comparison-column">
//               <h3>Log It Once is not:</h3>
//               <div className="comparison-list">
//                 <div className="comparison-item">
//                   <div className="not-icon">✗</div>
//                   <span>Legal advice</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="not-icon">✗</div>
//                   <span>An arbitrator</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="not-icon">✗</div>
//                   <span>A CRM</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="not-icon">✗</div>
//                   <span>An escalation tool</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div style={{ textAlign: 'center', marginTop: '2rem' }}>
//             <p>It records what happened. It does not decide what it means.</p>
//           </div>
//         </div>
//       </section>

//       {/* Simple Example */}
//       <section className="section">
//         <div className="container">
//           <h2>Simple Example</h2>
//           <div className="email-example" style={{ maxWidth: '600px', margin: '0 auto' }}>
//             <div className="email-header">
//               <span>Email Example</span>
//               <FaLink />
//             </div>
//             <code>
//               To: client@example.com<br />
//               <strong>Bcc: record@logitonce.com</strong><br />
//               Subject: Milestone 3 – Ready for Review<br />
//               Body: [Your normal email content]
//             </code>
//             <p style={{ marginTop: '1rem', fontSize: '0.9rem' }}>
//               That’s it. Your receipt is created automatically.
//             </p>
//           </div>
//         </div>
//       </section>

//       <section className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <h2>Teams Love Log It Once</h2>
          
//           <div className="horizontal-scroll-section">
//             <button className="scroll-button left" onClick={() => scrollTestimonial('left')}>
//               <FaChevronLeft />
//             </button>
            
//             <div className="testimonials-scroll-container" ref={testimonialRef}>
//               {testimonials.map((testimonial, index) => (
//                 <div key={testimonial.author} className="testimonial-card">
//                   <p className="testimonial-content">
//                     “{testimonial.content}”
//                   </p>
//                   <div className="testimonial-author">
//                     <div className="author-avatar">
//                       {testimonial.initials}
//                     </div>
//                     <div className="author-info">
//                       <h4>{testimonial.author}</h4>
//                       <p>{testimonial.role}</p>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
            
//             <button className="scroll-button right" onClick={() => scrollTestimonial('right')}>
//               <FaChevronRight />
//             </button>
//           </div>
//         </div>
//       </section>

//       <section id="verification" className="section">
//         <div className="container">
//           <h2>Verification & Exports</h2>
          
//           <p className="section-subtitle">
//             When a receipt needs to leave the system, its integrity goes with it.
//           </p>
          
//           <div className="verification-grid">
//             <div className="verification-card">
//               <div className="verification-icon">
//                 <FaFileExport />
//               </div>
//               <h3>Full chronological timeline</h3>
//               <p>Export complete event sequences in original order</p>
//             </div>
            
//             <div className="verification-card">
//               <div className="verification-icon">
//                 <FaLock />
//               </div>
//               <h3>Cryptographic verification</h3>
//               <p>Receipts are cryptographically signed and verifiable</p>
//             </div>
            
//             <div className="verification-card">
//               <div className="verification-icon">
//                 <FaServer />
//               </div>
//               <h3>Server-authoritative timestamps</h3>
//               <p>All timestamps are server-based and cannot be manipulated</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       <section id="faq" className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <h2>Have Questions? We Have Answers</h2>
          
//           <div className="faq-grid">
//             {faqs.map((faq, index) => (
//               <div
//                 key={index}
//                 className={`faq-item ${activeFAQ === index ? 'active' : ''}`}
//                 onClick={() => setActiveFAQ(activeFAQ === index ? null : index)}
//               >
//                 <div className="faq-question">
//                   <span>{faq.question}</span>
//                   <FaChevronDown />
//                 </div>
//                 <div className="faq-answer">
//                   <p>{faq.answer}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Final CTA Section */}
//       <section className="section">
//         <div className="container">
//           <div className="cta-card">
//             <h2>Stop Arguing About What Happened.</h2>
//             <h2 style={{ marginBottom: '2rem' }}>Start Recording What Did.</h2>
            
//             <button className="cta-button large" onClick={goToSignup}>
//               Create Your Outcome Address Free <FaArrowRight />
//             </button>
//             <span className="microcopy" style={{ marginTop: '1rem' }}>No credit card. No meeting. Generate your unique BCC address instantly.</span>
            
//             <div style={{ marginTop: '3rem', fontSize: '0.9rem', color: 'var(--color-text-light)' }}>
//               <p>No workflow change. No client signup required.</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       <footer className="footer">
//         <div className="container">
//           <div className="footer-content">
//             <div>
//               <div className="footer-logo">
//                 <FaReceipt /> Log It Once
//               </div>
//               <p style={{ color: 'rgba(255,255,255,0.7)', maxWidth: '300px' }}>
//                 If it matters, log it once.
//               </p>
//             </div>
//             <div className="footer-links">
//               <a href="mailto:support@logitonce.com">Support: support@logitonce.com</a>
//               <a href="#how">How it works</a>
//               <a href="#uses">Use cases</a>
//               <a href="#verification">Verify</a>
//               <a href="#">Terms</a>
//               <a href="#">Privacy</a>
//             </div>
//           </div>
//           <div className="footer-disclaimer">
//             <p>© Log It Once</p>
//             <p>Log It Once records events and timestamps. It does not provide legal advice or determine outcomes.</p>
//           </div>
//         </div>
//       </footer>
//     </>
//   );
// };

// export default LogItOnce;


































































// /* eslint-disable react/jsx-no-undef */
// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from "react-router-dom";
// import logitoncegif from "./log it once Gif.gif"
// import { 
//   FaReceipt, 
//   FaExclamationTriangle, 
//   FaLayerGroup, 
//   FaShieldAlt, 
//   FaPaperPlane, 
//   FaBriefcase, 
//   FaClock, 
//   FaExchangeAlt, 
//   FaHistory, 
//   FaStopwatch,
//   FaLock,
//   FaServer,
//   FaDownload,
//   FaCheckCircle,
//   FaEnvelope,
//   FaMobileAlt,
//   FaCalendarAlt,
//   FaCode,
//   FaArrowRight,
//   FaLink,
//   FaCheck,
//   FaTimes,
//   FaVolumeMute,
//   FaFileExport,
//   FaChevronLeft,
//   FaChevronRight,
//   FaChevronDown,
//   FaHistory as FaReplay
// } from 'react-icons/fa';

// const LogItOnce = () => {
//   const navigate = useNavigate();
//   const [scrolled, setScrolled] = useState(false);
//   const [activeFAQ, setActiveFAQ] = useState(null);
//   const [isGifLoading, setIsGifLoading] = useState(true);
  
//   // Refs for horizontal scrolling
//   const useCasesRef = useRef(null);
//   const testimonialRef = useRef(null);
//   const gifRef = useRef(null);
  
//   const testimonials = [
//     {
//       content: "We stopped having ‘we never approved that’ conversations.",
//       author: "Founder",
//       role: "Growth Agency",
//       initials: "FG"
//     },
//     {
//       content: "Clients respond faster when outcomes are recorded.",
//       author: "Managing Director",
//       role: "Dev Studio",
//       initials: "MD"
//     },
//     {
//       content: "It removed the awkward follow-up dynamic.",
//       author: "Ops Lead",
//       role: "Consultancy",
//       initials: "OL"
//     }
//   ];

//   const useCases = [
//     { icon: <FaBriefcase />, title: 'Delivering a milestone for approval' },
//     { icon: <FaExchangeAlt />, title: 'Confirming scope changes' },
//     { icon: <FaPaperPlane />, title: 'Sending final invoices' },
//     { icon: <FaClock />, title: 'Transferring responsibility' },
//     { icon: <FaStopwatch />, title: 'Setting deadlines that matter' },
//     { icon: <FaExclamationTriangle />, title: 'Preparing for escalation without escalating' },
//     { icon: <FaHistory />, title: 'If you might need to reconstruct it later — record it once' }
//   ];

//   const faqs = [
//     {
//       question: "How do I get started?",
//       answer: "Create a free account, connect your email or app, and start logging actions immediately. No credit card required for the trial."
//     },
//     {
//       question: "What happens if no one responds?",
//       answer: "Silence is recorded as a factual event. After the response window closes, the receipt shows 'No Response Recorded' as the outcome."
//     },
//     {
//       question: "Can receipts be edited or deleted?",
//       answer: "No. Log It Once is append-only. Once created, receipts cannot be edited or deleted, ensuring an authentic record of events."
//     },
//     {
//       question: "How are receipts verified?",
//       answer: "Each receipt includes a server-authoritative timestamp and cryptographic signature that can be independently verified."
//     },
//     {
//       question: "Is there a free trial?",
//       answer: "Yes, you can start with 100 free receipts per month. No credit card required to get started."
//     }
//   ];

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 50);
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const goToSignup = () => {
//     navigate("/signup");
//   };

//   // Horizontal scroll functions
//   const scrollUseCases = (direction) => {
//     if (useCasesRef.current) {
//       const scrollAmount = 300;
//       useCasesRef.current.scrollBy({
//         left: direction === 'left' ? -scrollAmount : scrollAmount,
//         behavior: 'smooth'
//       });
//     }
//   };

//   const scrollTestimonial = (direction) => {
//     if (testimonialRef.current) {
//       const scrollAmount = 400;
//       testimonialRef.current.scrollBy({
//         left: direction === 'left' ? -scrollAmount : scrollAmount,
//         behavior: 'smooth'
//       });
//     }
//   };

//   // GIF replay function
//   const replayGif = () => {
//     if (gifRef.current) {
//       const gif = gifRef.current;
//       gif.src = gif.src;
//     }
//   };

//   const handleGifLoad = () => {
//     setIsGifLoading(false);
//   };

//   const handleGifError = () => {
//     setIsGifLoading(false);
//     console.error("Failed to load GIF");
//   };

//   return (
//     <>
//       <style jsx global>{`
//         :root {
//           --color-bg: #ffffff;
//           --color-text: #202020;
//           --color-text-light: #6b7280;
//           --color-accent-light: #E0F5FF;
//           --color-accent-dark: #F0FAFF;
//           --color-button: #202020;
//           --color-button-text: #ffffff;
//           --gradient-primary: linear-gradient(135deg, var(--color-accent-light) 0%, var(--color-accent-dark) 100%);
//           --gradient-subtle: linear-gradient(180deg, var(--color-accent-light) 0%, var(--color-accent-dark) 44.95%, #FFFFFF 100%);
//           --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.05);
//           --shadow-md: 0 8px 30px rgba(0, 0, 0, 0.12);
//           --shadow-lg: 0 20px 60px rgba(0, 0, 0, 0.15);
//           --border-radius: 12px;
//           --border-radius-lg: 24px;
//           --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//           --container-width: 1200px;
//         }

//         * {
//           margin: 0;
//           padding: 0;
//           box-sizing: border-box;
//         }

//         html {
//           scroll-behavior: smooth;
//         }

// .hero-animation {
//   position: relative;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   min-height: 400px;
// }

// .receipt-illustration {
//   position: relative;
//   width: 100%;
//   max-width: 400px;
//   height: 400px;
// }

// .receipt-card {
//   position: absolute;
//   left:80%;
//   transform: translate(-50%, -50%);
//   width: 280px;
//   padding: 1.5rem;
//   background: white;
//   border-radius: var(--border-radius);
//   box-shadow: var(--shadow-lg);
//   border: 2px solid rgba(224, 245, 255, 0.8);
//   animation: floatCard 6s ease-in-out infinite;
//   z-index: 2;
//   backdrop-filter: blur(10px);
// }

// @keyframes floatCard {
//   0%, 100% { 
//     transform: translate(-50%, -50%) translateY(0) rotate(0deg); 
//   }
//   33% { 
//     transform: translate(-50%, -50%) translateY(-10px) rotate(0.5deg); 
//   }
//   66% { 
//     transform: translate(-50%, -50%) translateY(-5px) rotate(-0.5deg); 
//   }
// }

// .receipt-header {
//   display: flex;
//   align-items: center;
//   gap: 1rem;
//   margin-bottom: 1.5rem;
//   padding-bottom: 1rem;
//   border-bottom: 2px solid rgba(224, 245, 255, 0.5);
// }

// .receipt-icon {
//   width: 48px;
//   height: 48px;
//   border-radius: 50%;
//   background: var(--gradient-primary);
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   font-size: 1.5rem;
//   color: var(--color-text);
//   animation: pulseIcon 2s ease-in-out infinite;
// }

// @keyframes pulseIcon {
//   0%, 100% { transform: scale(1); }
//   50% { transform: scale(1.05); }
// }

// .receipt-title h4 {
//   margin: 0;
//   color: var(--color-text);
//   font-size: 1.25rem;
// }

// .timestamp {
//   font-size: 0.85rem;
//   color: var(--color-text-light);
//   margin-top: 0.25rem;
// }

// .receipt-content {
//   display: flex;
//   flex-direction: column;
//   gap: 0.75rem;
//   margin-bottom: 1.5rem;
// }

// .receipt-item {
//   display: flex;
//   justify-content: space-between;
//   padding: 0.5rem 0;
//   border-bottom: 1px solid rgba(224, 245, 255, 0.3);
// }

// .receipt-item:last-child {
//   border-bottom: none;
// }

// .receipt-item .label {
//   color: var(--color-text-light);
//   font-weight: 500;
//   font-size: 0.9rem;
// }

// .receipt-item .value {
//   color: var(--color-text);
//   font-weight: 600;
//   font-size: 0.9rem;
//   text-align: right;
//   max-width: 60%;
//   overflow: hidden;
//   text-overflow: ellipsis;
// }

// .status-pending {
//   color: #F59E0B !important;
//   position: relative;
//   padding-left: 1.25rem;
// }

// .status-pending::before {
//   content: '';
//   position: absolute;
//   left: 0;
//   top: 50%;
//   transform: translateY(-50%);
//   width: 10px;
//   height: 10px;
//   border-radius: 50%;
//   background: #F59E0B;
//   animation: pulseDot 1.5s ease-in-out infinite;
// }

// @keyframes pulseDot {
//   0%, 100% { opacity: 1; transform: translateY(-50%) scale(1); }
//   50% { opacity: 0.5; transform: translateY(-50%) scale(0.8); }
// }

//         body {
//           font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
//           color: var(--color-text);
//           background-color: var(--color-bg);
//           line-height: 1.6;
//           overflow-x: hidden;
//         }

//         .container {
//           width: 100%;
//           max-width: var(--container-width);
//           margin: 0 auto;
//           padding: 0 24px;
//         }

//         section {
//           padding: 80px 0;
//         }

//         h1, h2, h3, h4 {
//           font-weight: 800;
//           line-height: 1.2;
//         }

//         h1 {
//           font-size: 3.5rem;
//           margin-bottom: 1.5rem;
//         }

//         h2 {
//           font-size: 2.5rem;
//           margin-bottom: 1rem;
//           text-align: center;
//         }

//         h3 {
//           font-size: 1.5rem;
//           margin-bottom: 0.75rem;
//         }

//         p {
//           color: var(--color-text-light);
//           margin-bottom: 1.5rem;
//         }

//         .section-subtitle {
//           text-align: center;
//           max-width: 700px;
//           margin: 0 auto 3rem;
//           font-size: 1.125rem;
//         }

//         /* Animations */
//         @keyframes fadeIn {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }

//         @keyframes fadeInUp {
//           from {
//             opacity: 0;
//             transform: translateY(30px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         @keyframes float {
//           0%, 100% { transform: translateY(0); }
//           50% { transform: translateY(-10px); }
//         }

//         @keyframes pulse {
//           0%, 100% { transform: scale(1); }
//           50% { transform: scale(1.05); }
//         }

//         /* Header */
//         .header {
//           position: sticky;
//           top: 0;
//           z-index: 1000;
//           background-color: rgba(255, 255, 255, 0.95);
//           backdrop-filter: blur(10px);
//           border-bottom: 1px solid rgba(0, 0, 0, 0.05);
//           padding: 1rem 0;
//           transition: var(--transition);
//         }

//         .header.scrolled {
//           box-shadow: var(--shadow-sm);
//         }

//         .header-content {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//         }

//         .logo {
//           display: flex;
//           align-items: center;
//           font-weight: 800;
//           font-size: 1.5rem;
//           text-decoration: none;
//           color: var(--color-text);
//           cursor: pointer;
//           transition: var(--transition);
//         }

//         .logo:hover {
//           transform: scale(1.05);
//         }

//         .logo-icon {
//           margin-right: 10px;
//           font-size: 1.8rem;
//           color: var(--color-text);
//           animation: float 3s ease-in-out infinite;
//         }

//         .nav {
//           display: flex;
//           gap: 2rem;
//         }

//         .nav a {
//           text-decoration: none;
//           color: var(--color-text-light);
//           font-weight: 500;
//           font-size: 0.95rem;
//           position: relative;
//           transition: var(--transition);
//         }

//         .nav a:hover {
//           color: var(--color-text);
//           transform: translateY(-2px);
//         }

//         .cta-button {
//           background-color: var(--color-button);
//           color: var(--color-button-text);
//           border: none;
//           border-radius: 9999px;
//           padding: 12px 24px;
//           font-weight: 700;
//           font-size: 0.95rem;
//           cursor: pointer;
//           transition: var(--transition);
//           display: inline-flex;
//           align-items: center;
//           gap: 8px;
//           text-decoration: none;
//         }

//         .cta-button:hover {
//           transform: translateY(-2px);
//           box-shadow: var(--shadow-md);
//           background: linear-gradient(135deg, #202020, #404040);
//           animation: pulse 1s ease-in-out;
//         }

//         .cta-button.primary {
//           padding: 16px 32px;
//           font-size: 1rem;
//         }

//         .cta-button.large {
//           padding: 18px 40px;
//           font-size: 1.1rem;
//         }

//         .microcopy {
//           display: block;
//           font-size: 0.85rem;
//           font-weight: normal;
//           color: var(--color-text-light);
//           margin-top: 0.5rem;
//         }

//         /* Hero */
//         .hero {
//           padding: 100px 0 120px;
//           background: var(--gradient-subtle);
//           position: relative;
//           overflow: hidden;
//           animation: fadeIn 1s ease-out;
//         }

//         @media (min-width: 1024px) {
//           .hero {
//             padding: 120px 0 140px;
//           }
//         }

//         .hero-grid {
//           display: grid;
//           grid-template-columns: 1fr;
//           gap: 4rem;
//           align-items: center;
//         }

//         @media (min-width: 1024px) {
//           .hero-grid {
//             grid-template-columns: 1.2fr 1fr;
//             gap: 6rem;
//           }
//         }

//         .hero-content {
//           position: relative;
//           z-index: 2;
//         }

//         .tagline {
//           display: inline-flex;
//           align-items: center;
//           gap: 10px;
//           background: rgba(32, 32, 32, 0.05);
//           color: var(--color-text);
//           font-weight: 600;
//           padding: 8px 16px;
//           border-radius: 9999px;
//           margin-bottom: 1.5rem;
//           animation: fadeInUp 0.8s ease-out 0.2s both;
//         }

//         .hero-subtitle {
//           font-size: 1.25rem;
//           margin-bottom: 3rem;
//           max-width: 700px;
//           animation: fadeInUp 0.8s ease-out 0.4s both;
//         }

//         .hero-actions {
//           display: flex;
//           gap: 1rem;
//           flex-wrap: wrap;
//           animation: fadeInUp 0.8s ease-out 0.6s both;
//         }

//         .secondary-button {
//           background: transparent;
//           color: var(--color-text);
//           border: 2px solid var(--color-text);
//           border-radius: 9999px;
//           padding: 12px 24px;
//           font-weight: 700;
//           font-size: 0.95rem;
//           cursor: pointer;
//           transition: var(--transition);
//           text-decoration: none;
//           display: inline-flex;
//           align-items: center;
//           gap: 8px;
//         }

//         .secondary-button:hover {
//           background-color: var(--color-text);
//           color: white;
//           transform: translateY(-2px);
//           box-shadow: var(--shadow-md);
//         }

//         .hero-gif {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           display: block;
//           border-radius: var(--border-radius-lg);
//           animation: fadeInGif 1.5s ease-out;
//         }

//         @keyframes fadeInGif {
//           from {
//             opacity: 0;
//             transform: scale(0.95);
//           }
//           to {
//             opacity: 1;
//             transform: scale(1);
//           }
//         }

//         .gif-wrapper {
//           position: relative;
//           width: 100%;
//           height: 280px;
//           border-radius: var(--border-radius-lg);
//           overflow: hidden;
//           box-shadow: var(--shadow-lg);
//           transform: perspective(1000px) rotateY(-2deg) rotateX(2deg);
//           transition: var(--transition);
//           background: linear-gradient(145deg, #ffffff, #f5f5f5);
//         }

//         @media (min-width: 768px) {
//           .gif-wrapper {
//             height: 300px;
//           }
//         }

//         .gif-wrapper:hover {
//           transform: translateY(-5px) translateZ(10px);
//           box-shadow: 
//             0 30px 80px rgba(0, 0, 0, 0.2),
//             0 0 0 1px rgba(224, 245, 255, 0.5);
//         }

//         .gif-control {
//           position: absolute;
//           bottom: 16px;
//           right: 16px;
//           width: 40px;
//           height: 40px;
//           border-radius: 50%;
//           background: rgba(32, 32, 32, 0.9);
//           color: white;
//           border: none;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           cursor: pointer;
//           transition: var(--transition);
//           opacity: 0;
//           transform: scale(0.8);
//           z-index: 10;
//         }

//         .gif-wrapper:hover .gif-control {
//           opacity: 1;
//           transform: scale(1);
//         }

//         .gif-control:hover {
//           background: var(--color-text);
//           transform: scale(1.1) rotate(90deg);
//         }

//         .gif-caption {
//           display: flex;
//           align-items: center;
//           gap: 12px;
//           margin-top: 1.5rem;
//           padding: 1rem 1.5rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//           animation: slideUpCaption 1s ease-out 0.5s both;
//           max-width: 400px;
//         }

//         @keyframes slideUpCaption {
//           from {
//             opacity: 0;
//             transform: translateY(20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         .caption-icon {
//           width: 40px;
//           height: 40px;
//           border-radius: 50%;
//           background: var(--gradient-primary);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 1.2rem;
//           color: var(--color-text);
//           flex-shrink: 0;
//         }

//         .gif-caption p {
//           margin: 0;
//           font-weight: 600;
//           color: var(--color-text);
//           font-size: 0.95rem;
//         }

//         /* Horizontal Scroll Sections */
//         .horizontal-scroll-section {
//           position: relative;
//           padding: 0 24px;
//         }

//         .horizontal-scroll-container {
//           display: flex;
//           overflow-x: auto;
//           gap: 24px;
//           padding: 24px 0;
//           scrollbar-width: none;
//           -ms-overflow-style: none;
//           scroll-behavior: smooth;
//         }

//         .horizontal-scroll-container::-webkit-scrollbar {
//           display: none;
//         }

//         .scroll-button {
//           position: absolute;
//           top: 50%;
//           transform: translateY(-50%);
//           background: white;
//           border: 2px solid var(--color-text);
//           border-radius: 50%;
//           width: 48px;
//           height: 48px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           cursor: pointer;
//           transition: var(--transition);
//           z-index: 10;
//           box-shadow: var(--shadow-md);
//         }

//         .scroll-button:hover {
//           background: var(--color-text);
//           color: white;
//           transform: translateY(-50%) scale(1.1);
//         }

//         .scroll-button.left {
//           left: 0;
//         }

//         .scroll-button.right {
//           right: 0;
//         }

//         /* Use Cases with Horizontal Scroll */
//         .use-cases-scroll-container {
//           display: flex;
//           overflow-x: auto;
//           gap: 24px;
//           padding: 24px 0;
//           scrollbar-width: none;
//           -ms-overflow-style: none;
//         }

//         .use-cases-scroll-container::-webkit-scrollbar {
//           display: none;
//         }

//         .use-case-card {
//           flex: 0 0 auto;
//           width: 320px;
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           transition: var(--transition);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//           text-align: center;
//         }

//         .use-case-card:hover {
//           transform: translateY(-8px);
//           box-shadow: var(--shadow-md);
//           border-color: rgba(224, 245, 255, 0.8);
//         }

//         .use-case-icon {
//           font-size: 2.5rem;
//           color: var(--color-text);
//           margin-bottom: 1.5rem;
//           display: block;
//           transition: var(--transition);
//         }

//         .use-case-card:hover .use-case-icon {
//           transform: scale(1.2) rotate(5deg);
//         }

//         /* Testimonials with Horizontal Scroll */
//         .testimonials-scroll-container {
//           display: flex;
//           overflow-x: auto;
//           gap: 32px;
//           padding: 32px 0;
//           scrollbar-width: none;
//           -ms-overflow-style: none;
//         }

//         .testimonials-scroll-container::-webkit-scrollbar {
//           display: none;
//         }

//         .testimonial-card {
//           flex: 0 0 auto;
//           width: 380px;
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           transition: var(--transition);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//         }

//         .testimonial-card:hover {
//           transform: translateY(-8px);
//           box-shadow: var(--shadow-md);
//         }

//         .testimonial-content {
//           font-style: italic;
//           margin-bottom: 1.5rem;
//           color: var(--color-text);
//           font-size: 1.1rem;
//           line-height: 1.6;
//         }

//         .testimonial-author {
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//         }

//         .author-avatar {
//           width: 48px;
//           height: 48px;
//           border-radius: 50%;
//           background: var(--gradient-primary);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-weight: 700;
//           color: var(--color-text);
//           transition: var(--transition);
//         }

//         .testimonial-card:hover .author-avatar {
//           transform: rotate(360deg);
//         }

//         /* What Is Section (Is / Is Not) */
//         .comparison {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
//           gap: 3rem;
//           margin-top: 3rem;
//         }

//         .comparison-column {
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//         }

//         .comparison-list {
//           display: flex;
//           flex-direction: column;
//           gap: 1rem;
//           margin-top: 1rem;
//         }

//         .comparison-item {
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//           padding: 0.75rem;
//           border-radius: 8px;
//           transition: var(--transition);
//         }

//         .comparison-item:hover {
//           background: rgba(224, 245, 255, 0.2);
//           transform: translateX(5px);
//         }

//         .is-icon {
//           width: 24px;
//           height: 24px;
//           border-radius: 50%;
//           background: #10B981;
//           color: white;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-weight: bold;
//           flex-shrink: 0;
//         }

//         .not-icon {
//           width: 24px;
//           height: 24px;
//           border-radius: 50%;
//           background: #EF4444;
//           color: white;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-weight: bold;
//           flex-shrink: 0;
//         }

//         /* Steps / How It Works */
//         .steps {
//           display: flex;
//           flex-direction: column;
//           gap: 2rem;
//           max-width: 800px;
//           margin: 3rem auto 0;
//         }

//         .step {
//           display: flex;
//           gap: 2rem;
//           align-items: flex-start;
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//         }

//         .step-number {
//           width: 60px;
//           height: 60px;
//           border-radius: 50%;
//           background: var(--color-text);
//           color: white;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 1.5rem;
//           font-weight: 800;
//           flex-shrink: 0;
//         }

//         .step-content {
//           flex: 1;
//         }

//         .outcome-options {
//           display: flex;
//           flex-direction: column;
//           gap: 12px;
//           margin: 1rem 0;
//         }

//         .outcome-option {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//           font-size: 0.95rem;
//           transition: var(--transition);
//           padding: 8px 12px;
//           border-radius: 8px;
//           background: rgba(224, 245, 255, 0.2);
//         }

//         .outcome-option:hover {
//           transform: translateX(10px);
//           background: rgba(224, 245, 255, 0.4);
//         }

//         .option-icon {
//           font-size: 1.25rem;
//           flex-shrink: 0;
//         }

//         .option-icon.acknowledged {
//           color: #10B981;
//         }

//         .option-icon.disputed {
//           color: #EF4444;
//         }

//         .option-icon.no-response {
//           color: #6B7280;
//         }

//         /* Outcomes Grid */
//         .outcomes-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
//           gap: 2rem;
//           margin-top: 3rem;
//         }

//         .outcome-card {
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           transition: var(--transition);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//         }

//         .outcome-card:hover {
//           transform: translateY(-8px);
//           box-shadow: var(--shadow-md);
//         }

//         .outcome-card.acknowledged {
//           border-top: 4px solid #10B981;
//         }

//         .outcome-card.disputed {
//           border-top: 4px solid #EF4444;
//         }

//         .outcome-card.no-response {
//           border-top: 4px solid #6B7280;
//         }

//         .outcome-header {
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//           margin-bottom: 1rem;
//         }

//         .outcome-icon {
//           font-size: 2rem;
//         }

//         /* Verification */
//         .verification-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
//           gap: 2rem;
//           margin-top: 3rem;
//         }

//         .verification-card {
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           transition: var(--transition);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//           text-align: center;
//         }

//         .verification-card:hover {
//           transform: translateY(-8px);
//           box-shadow: var(--shadow-md);
//         }

//         .verification-icon {
//           font-size: 2.5rem;
//           color: var(--color-text);
//           margin-bottom: 1.5rem;
//         }

//         /* Email Example */
//         .email-example {
//           background: rgba(32, 32, 32, 0.05);
//           border-radius: var(--border-radius);
//           padding: 2rem;
//           margin: 2rem 0;
//           text-align: left;
//           font-family: 'Monaco', 'Courier New', monospace;
//           font-size: 0.9rem;
//           max-width: 600px;
//           margin-left: auto;
//           margin-right: auto;
//         }

//         .email-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 1rem;
//           color: var(--color-text);
//           font-weight: 600;
//         }

//         /* FAQ */
//         .faq-grid {
//           max-width: 800px;
//           margin: 3rem auto 0;
//         }

//         .faq-item {
//           border-bottom: 1px solid rgba(224, 245, 255, 0.5);
//           padding: 1.5rem 0;
//         }

//         .faq-question {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           cursor: pointer;
//           font-weight: 700;
//           font-size: 1.1rem;
//           color: var(--color-text);
//           transition: var(--transition);
//         }

//         .faq-question:hover {
//           color: var(--color-text);
//           transform: translateX(5px);
//         }

//         .faq-answer {
//           max-height: 0;
//           overflow: hidden;
//           transition: max-height 0.3s ease;
//           color: var(--color-text-light);
//           padding-top: 0;
//         }

//         .faq-item.active .faq-answer {
//           max-height: 300px;
//           padding-top: 1rem;
//         }

//         .faq-item.active .faq-question svg {
//           transform: rotate(180deg);
//         }

//         /* CTA Card */
//         .cta-card {
//           background: white;
//           border-radius: var(--border-radius);
//           padding: 4rem;
//           text-align: center;
//           box-shadow: var(--shadow-lg);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//           max-width: 900px;
//           margin: 0 auto;
//         }

//         /* Footer */
//         .footer {
//           background-color: var(--color-text);
//           color: white;
//           padding: 4rem 0 2rem;
//         }

//         .footer-content {
//           display: flex;
//           justify-content: space-between;
//           align-items: flex-start;
//           flex-wrap: wrap;
//           gap: 2rem;
//           margin-bottom: 3rem;
//         }

//         .footer-logo {
//           display: flex;
//           align-items: center;
//           font-weight: 800;
//           font-size: 1.5rem;
//           margin-bottom: 1rem;
//         }

//         .footer-links {
//           display: flex;
//           flex-direction: column;
//           gap: 0.75rem;
//         }

//         .footer-links a {
//           color: rgba(255, 255, 255, 0.7);
//           text-decoration: none;
//           transition: var(--transition);
//         }

//         .footer-links a:hover {
//           color: white;
//           transform: translateX(5px);
//         }

//         .footer-disclaimer {
//           text-align: center;
//           padding-top: 2rem;
//           border-top: 1px solid rgba(255, 255, 255, 0.1);
//           color: rgba(255, 255, 255, 0.5);
//           font-size: 0.9rem;
//         }

//         /* Accessibility */
//         @media (prefers-reduced-motion: reduce) {
//           .hero-gif,
//           .overlay-shine,
//           .highlight,
//           .gif-caption,
//           .logo-icon,
//           .tagline,
//           .hero-subtitle,
//           .hero-actions,
//           .stat-card {
//             animation: none !important;
//             transition: none !important;
//           }
          
//           .gif-wrapper {
//             transform: none !important;
//           }
//         }

//         /* Responsive */
//         @media (max-width: 768px) {
//           h1 {
//             font-size: 2.5rem;
//           }
          
//           h2 {
//             font-size: 2rem;
//           }
          
//           .header-content {
//             flex-direction: column;
//             gap: 1rem;
//           }
          
//           .nav {
//             gap: 1rem;
//             flex-wrap: wrap;
//             justify-content: center;
//           }
          
//           .hero-actions {
//             justify-content: center;
//           }
          
//           .step {
//             flex-direction: column;
//             text-align: center;
//           }
          
//           .cta-card {
//             padding: 2rem;
//           }
          
//           .scroll-button {
//             width: 40px;
//             height: 40px;
//             font-size: 0.8rem;
//           }
//           .
//           .use-case-card,
//           .testimonial-card {
//             width: 280px;
//           }
          
//           .gif-wrapper {
//             height: 220px;
//           }
//         }

//         @media (max-width: 480px) {
//           .container {
//             padding: 0 16px;
//           }
          
//           section {
//             padding: 60px 0;
//           }
          
//           .horizontal-scroll-section {
//             padding: 0 16px;
//           }
          
//           .scroll-button {
//             display: none;
//           }
          
//           .gif-wrapper {
//             height: 200px;
//           }
          
//           .gif-caption {
//             flex-direction: column;
//             text-align: center;
//             gap: 0.5rem;
//           }
//         }

//         @media (max-width: 1023px) {
//           .hero-grid {
//             gap: 3rem;
//           }
//         }
//       `}</style>

//       <header className={`header ${scrolled ? 'scrolled' : ''}`}>
//         <div className="container">
//           <div className="header-content">
//             <div className="logo">
//               <FaReceipt className="logo-icon" />
//               <span>Log It Once</span>
//             </div>

//             <nav className="nav">
//               <a href="#problem">Problem</a>
//               <a href="#how">How It Works</a>
//               <a href="#uses">Use Cases</a>
//               <a href="#verification">Verification</a>
//             </nav>

//             <button className="cta-button" onClick={goToSignup}>
//               Try It On Your Next Milestone Email
//             </button>
//           </div>
//         </div>
//       </header>

//       <section className="hero">
//         <div className="container">
//           <div className="hero-grid">
//             <div className="hero-content">
//               <div className="tagline">
//                 <FaReceipt /> Log it once. Get a receipt.
//               </div>
              
//               <h1>Client Silence After Delivery Is Not Neutral.</h1>
              
//               <p className="hero-subtitle">
//                 You sent the milestone. They didn’t respond. Weeks later: “We never approved that.”<br />
//                 When approval isn’t captured, leverage shifts.<br />
//                 <strong>Log It Once records the outcome before reconstruction becomes your only option.</strong>
//               </p>
              
//               <div className="hero-actions">
//                 <button className="cta-button primary" onClick={goToSignup}>
//                   Try It On Your Next Milestone Email (Free) <FaArrowRight />
//                 </button>
//                 <span className="microcopy">Takes 30 seconds. No credit card. No meeting. No client signup required.</span>
//               </div>
//             </div>
             
//             {/* GIF Animation Container */}
//             <div style={{ }}>
//               <div className="receipt-card">
//           <div className="receipt-header">
//             <div className="receipt-icon">
//               <FaReceipt />
//             </div>
//             <div className="receipt-title">
//               <h4>Action Receipt</h4>
//               <div className="timestamp">Just now</div>
//             </div>
//           </div>
          
//           <div className="receipt-content">
//             <div className="receipt-item">
//               <span className="label">Action:</span>
//               <span className="value">Deliverable sent</span>
//             </div>
//             <div className="receipt-item">
//               <span className="label">To:</span>
//               <span className="value">client@company.com</span>
//             </div>
//             <div className="receipt-item">
//               <span className="label">Status:</span>
//               <span className="value status-pending">Awaiting response</span>
//             </div>
//           </div>
          
//           <div className="receipt-footer">
//             <div className="receipt-id">#LOG-9842-2024</div>
//             <div className="verification-badge">
//               <FaLock /> Verified
//             </div>
//           </div>
//         </div>
//               </div>
              
//               {/* Optional: simple caption */}
//               <div className="gif-caption">
//                 <div className="caption-icon">
//                   <FaReceipt />
//                 </div>
//                 <p>Watch how receipts are created in seconds</p>
//               </div>
//             </div>
//           {/* </div> */}
//         </div>
//       </section>

//       {/* The Real Problem */}
//       <section id="problem" className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <h2>The Most Expensive Email Is the One With No Reply.</h2>
//           <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
//             <p style={{ fontSize: '1.25rem', marginBottom: '2rem' }}>
//               Service firms don’t lose money because they fail. They lose money because:
//             </p>
//             <ul style={{ listStyle: 'none', padding: 0, textAlign: 'left', display: 'inline-block' }}>
//               <li style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
//                 <FaTimes style={{ color: '#EF4444' }} /> Approval was implied, not recorded.
//               </li>
//               <li style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
//                 <FaTimes style={{ color: '#EF4444' }} /> A client went silent.
//               </li>
//               <li style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
//                 <FaTimes style={{ color: '#EF4444' }} /> Scope was reinterpreted later.
//               </li>
//               <li style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
//                 <FaTimes style={{ color: '#EF4444' }} /> The final invoice stalled.
//               </li>
//             </ul>
//             <p style={{ fontSize: '1.25rem', marginTop: '2rem', fontWeight: '600' }}>
//               “We never approved that.”<br />
//               When nothing happens, nothing gets documented.<br />
//               That’s when leverage flips.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* How It Works */}
//       <section id="how" className="section">
//         <div className="container">
//           <h2>How It Works</h2>
//           <p className="section-subtitle">Three Steps. No Workflow Change.</p>
          
//           <div className="steps">
//             <div className="step">
//               <div className="step-number">1</div>
//               <div className="step-content">
//                 <h3>Send your milestone email normally</h3>
//                 <p>Just include your unique Log It Once address in BCC.</p>
//               </div>
//             </div>
            
//             <div className="step">
//               <div className="step-number">2</div>
//               <div className="step-content">
//                 <h3>The recipient sees three options</h3>
//                 <div className="outcome-options">
//                   <div className="outcome-option">
//                     <FaCheck className="option-icon acknowledged" />
//                     <span>Acknowledge</span>
//                   </div>
//                   <div className="outcome-option">
//                     <FaTimes className="option-icon disputed" />
//                     <span>Dispute</span>
//                   </div>
//                   <div className="outcome-option">
//                     <FaVolumeMute className="option-icon no-response" />
//                     <span>No Response Recorded</span>
//                   </div>
//                 </div>
//                 <p>No account required for them. No confrontation. No chasing.</p>
//               </div>
//             </div>
            
//             <div className="step">
//               <div className="step-number">3</div>
//               <div className="step-content">
//                 <h3>Whatever happens — or doesn’t — is captured</h3>
//                 <p>You receive a neutral, time‑stamped receipt. If they don’t respond, that’s recorded too.</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* The Three Outcome States */}
//       <section className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <h2>The Three Outcome States</h2>
//           <p className="section-subtitle">Every logged action ends in one of three states:</p>
          
//           <div className="outcomes-grid">
//             <div className="outcome-card acknowledged">
//               <div className="outcome-header">
//                 <FaCheck className="outcome-icon" style={{ color: '#10B981' }} />
//                 <h3>Acknowledged</h3>
//               </div>
//               <p>The recipient formally accepted.</p>
//             </div>
            
//             <div className="outcome-card disputed">
//               <div className="outcome-header">
//                 <FaTimes className="outcome-icon" style={{ color: '#EF4444' }} />
//                 <h3>Disputed</h3>
//               </div>
//               <p>The recipient formally contested.</p>
//             </div>
            
//             <div className="outcome-card no-response">
//               <div className="outcome-header">
//                 <FaVolumeMute className="outcome-icon" style={{ color: '#6B7280' }} />
//                 <h3>No Response Recorded</h3>
//               </div>
//               <p>No formal response occurred within the response window.</p>
//             </div>
//           </div>
          
//           <div style={{ textAlign: 'center', marginTop: '2rem' }}>
//             <p style={{ fontSize: '1.1rem', fontWeight: '600' }}>
//               No interpretation is added. Only sequence is preserved.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* When to Use It */}
//       <section id="uses" className="section">
//         <div className="container">
//           <h2>When to Use Log It Once</h2>
          
//           <div className="horizontal-scroll-section">
//             <button className="scroll-button left" onClick={() => scrollUseCases('left')}>
//               <FaChevronLeft />
//             </button>
            
//             <div className="use-cases-scroll-container" ref={useCasesRef}>
//               {useCases.map((useCase, index) => (
//                 <div key={index} className="use-case-card">
//                   <div className="use-case-icon">
//                     {useCase.icon}
//                   </div>
//                   <h3>{useCase.title}</h3>
//                 </div>
//               ))}
//             </div>
            
//             <button className="scroll-button right" onClick={() => scrollUseCases('right')}>
//               <FaChevronRight />
//             </button>
//           </div>
//         </div>
//       </section>

//       {/* What This Is (Is / Is Not) */}
//       <section className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <h2>What This Is</h2>
//           <div className="comparison">
//             <div className="comparison-column">
//               <h3>Log It Once is:</h3>
//               <div className="comparison-list">
//                 <div className="comparison-item">
//                   <div className="is-icon">✓</div>
//                   <span>Chronological</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="is-icon">✓</div>
//                   <span>Append-only</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="is-icon">✓</div>
//                   <span>Server time‑stamped</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="is-icon">✓</div>
//                   <span>Independently verifiable</span>
//                 </div>
//               </div>
//             </div>
            
//             <div className="comparison-column">
//               <h3>Log It Once is not:</h3>
//               <div className="comparison-list">
//                 <div className="comparison-item">
//                   <div className="not-icon">✗</div>
//                   <span>Legal advice</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="not-icon">✗</div>
//                   <span>An arbitrator</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="not-icon">✗</div>
//                   <span>A CRM</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="not-icon">✗</div>
//                   <span>An escalation tool</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div style={{ textAlign: 'center', marginTop: '2rem' }}>
//             <p>It records what happened. It does not decide what it means.</p>
//           </div>
//         </div>
//       </section>

//       {/* Simple Example */}
//       <section className="section">
//         <div className="container">
//           <h2>Simple Example</h2>
//           <div className="email-example">
//             <div className="email-header">
//               <span>Email Example</span>
//               <FaLink />
//             </div>
//             <code>
//               To: client@example.com<br />
//               <strong>Bcc: record@logitonce.com</strong><br />
//               Subject: Milestone 3 – Ready for Review<br />
//               Body: [Your normal email content]
//             </code>
//             <p style={{ marginTop: '1rem', fontSize: '0.9rem' }}>
//               That’s it. Your receipt is created automatically.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Testimonials */}
//       <section className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <h2>Teams Love Log It Once</h2>
          
//           <div className="horizontal-scroll-section">
//             <button className="scroll-button left" onClick={() => scrollTestimonial('left')}>
//               <FaChevronLeft />
//             </button>
            
//             <div className="testimonials-scroll-container" ref={testimonialRef}>
//               {testimonials.map((testimonial, index) => (
//                 <div key={testimonial.author} className="testimonial-card">
//                   <p className="testimonial-content">
//                     “{testimonial.content}”
//                   </p>
//                   <div className="testimonial-author">
//                     <div className="author-avatar">
//                       {testimonial.initials}
//                     </div>
//                     <div className="author-info">
//                       <h4>{testimonial.author}</h4>
//                       <p>{testimonial.role}</p>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
            
//             <button className="scroll-button right" onClick={() => scrollTestimonial('right')}>
//               <FaChevronRight />
//             </button>
//           </div>
//         </div>
//       </section>

//       {/* Verification (Condensed) */}
//       <section id="verification" className="section">
//         <div className="container">
//           <h2>Verification</h2>
//           <p className="section-subtitle">
//             When a receipt needs to leave the system, its integrity goes with it.
//           </p>
          
//           <div className="verification-grid">
//             <div className="verification-card">
//               <div className="verification-icon">
//                 <FaFileExport />
//               </div>
//               <h3>Full chronological timeline</h3>
//             </div>
            
//             <div className="verification-card">
//               <div className="verification-icon">
//                 <FaServer />
//               </div>
//               <h3>Server‑authoritative timestamps</h3>
//             </div>
            
//             <div className="verification-card">
//               <div className="verification-icon">
//                 <FaLock />
//               </div>
//               <h3>Independently verifiable</h3>
//             </div>
//           </div>
          
//           <div style={{ textAlign: 'center', marginTop: '2rem' }}>
//             <p style={{ fontWeight: '600' }}>If anything is altered, verification fails.</p>
//           </div>
//         </div>
//       </section>

//       {/* FAQ (optional but kept) */}
//       <section id="faq" className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <h2>Frequently Asked Questions</h2>
          
//           <div className="faq-grid">
//             {faqs.map((faq, index) => (
//               <div
//                 key={index}
//                 className={`faq-item ${activeFAQ === index ? 'active' : ''}`}
//                 onClick={() => setActiveFAQ(activeFAQ === index ? null : index)}
//               >
//                 <div className="faq-question">
//                   <span>{faq.question}</span>
//                   <FaChevronDown />
//                 </div>
//                 <div className="faq-answer">
//                   <p>{faq.answer}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Final CTA */}
//       <section className="section">
//         <div className="container">
//           <div className="cta-card">
//             <h2>Stop Arguing About What Happened.</h2>
//             <h2 style={{ marginBottom: '2rem' }}>Start Recording What Did.</h2>
            
//             <button className="cta-button large" onClick={goToSignup}>
//               Create Your Outcome Address (Free) <FaArrowRight />
//             </button>
//             <span className="microcopy" style={{ marginTop: '1rem' }}>Takes 30 seconds. No workflow change. No client signup required.</span>
//           </div>
//         </div>
//       </section>

//       <footer className="footer">
//         <div className="container">
//           <div className="footer-content">
//             <div>
//               <div className="footer-logo">
//                 <FaReceipt /> Log It Once
//               </div>
//               <p style={{ color: 'rgba(255,255,255,0.7)', maxWidth: '300px' }}>
//                 If it matters, log it once.
//               </p>
//             </div>
//             <div className="footer-links">
//               <a href="mailto:support@logitonce.com">Support: support@logitonce.com</a>
//               <a href="#how">How it works</a>
//               <a href="#uses">Use cases</a>
//               <a href="#verification">Verify</a>
//               <a href="#">Terms</a>
//               <a href="#">Privacy</a>
//             </div>
//           </div>
//           <div className="footer-disclaimer">
//             <p>© Log It Once</p>
//             <p>Log It Once records events and timestamps. It does not provide legal advice or determine outcomes.</p>
//           </div>
//         </div>
//       </footer>
//     </>
//   );
// };

// export default LogItOnce;











































// /* eslint-disable react/jsx-no-undef */
// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from "react-router-dom";
// import logitoncegif from "./log it once Gif.gif"
// import { 
//   FaReceipt, 
//   FaExclamationTriangle, 
//   FaLayerGroup, 
//   FaShieldAlt, 
//   FaPaperPlane, 
//   FaBriefcase, 
//   FaClock, 
//   FaExchangeAlt, 
//   FaHistory, 
//   FaStopwatch,
//   FaLock,
//   FaServer,
//   FaDownload,
//   FaCheckCircle,
//   FaEnvelope,
//   FaMobileAlt,
//   FaCalendarAlt,
//   FaCode,
//   FaArrowRight,
//   FaLink,
//   FaCheck,
//   FaTimes,
//   FaVolumeMute,
//   FaFileExport,
//   FaChevronLeft,
//   FaChevronRight,
//   FaChevronDown,
//   FaHistory as FaReplay
// } from 'react-icons/fa';

// const LogItOnce = () => {
//   const navigate = useNavigate();
//   const [scrolled, setScrolled] = useState(false);
//   const [activeFAQ, setActiveFAQ] = useState(null);
//   const [isGifLoading, setIsGifLoading] = useState(true);
  
//   // Refs for horizontal scrolling
//   const useCasesRef = useRef(null);
//   const testimonialRef = useRef(null);
//   const gifRef = useRef(null);
  
//   const testimonials = [
//     {
//       content: "We stopped having ‘we never approved that’ conversations.",
//       author: "Founder",
//       role: "Growth Agency",
//       initials: "FG"
//     },
//     {
//       content: "Clients respond faster when outcomes are recorded.",
//       author: "Managing Director",
//       role: "Dev Studio",
//       initials: "MD"
//     },
//     {
//       content: "It removed the awkward follow-up dynamic.",
//       author: "Ops Lead",
//       role: "Consultancy",
//       initials: "OL"
//     }
//   ];

//   const useCases = [
//     { icon: <FaBriefcase />, title: 'Delivering a milestone for approval' },
//     { icon: <FaExchangeAlt />, title: 'Confirming scope changes' },
//     { icon: <FaPaperPlane />, title: 'Sending final invoices' },
//     { icon: <FaClock />, title: 'Transferring responsibility' },
//     { icon: <FaStopwatch />, title: 'Setting deadlines that matter' },
//     { icon: <FaExclamationTriangle />, title: 'Preparing for escalation without escalating' },
//     { icon: <FaHistory />, title: 'If you might need to reconstruct it later — record it once' }
//   ];

//   const faqs = [
//     {
//       question: "How do I get started?",
//       answer: "Create a free account, connect your email or app, and start logging actions immediately. No credit card required for the trial."
//     },
//     {
//       question: "What happens if no one responds?",
//       answer: "Silence is recorded as a factual event. After the response window closes, the receipt shows 'No Response Recorded' as the outcome."
//     },
//     {
//       question: "Can receipts be edited or deleted?",
//       answer: "No. Log It Once is append-only. Once created, receipts cannot be edited or deleted, ensuring an authentic record of events."
//     },
//     {
//       question: "How are receipts verified?",
//       answer: "Each receipt includes a server-authoritative timestamp and cryptographic signature that can be independently verified."
//     },
//     {
//       question: "Is there a free trial?",
//       answer: "Yes, you can start with 100 free receipts per month. No credit card required to get started."
//     }
//   ];

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 50);
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const goToSignup = () => {
//     navigate("/signup");
//   };

//   // Horizontal scroll functions
//   const scrollUseCases = (direction) => {
//     if (useCasesRef.current) {
//       const scrollAmount = 300;
//       useCasesRef.current.scrollBy({
//         left: direction === 'left' ? -scrollAmount : scrollAmount,
//         behavior: 'smooth'
//       });
//     }
//   };

//   const scrollTestimonial = (direction) => {
//     if (testimonialRef.current) {
//       const scrollAmount = 400;
//       testimonialRef.current.scrollBy({
//         left: direction === 'left' ? -scrollAmount : scrollAmount,
//         behavior: 'smooth'
//       });
//     }
//   };

//   // GIF replay function
//   const replayGif = () => {
//     if (gifRef.current) {
//       const gif = gifRef.current;
//       gif.src = gif.src;
//     }
//   };

//   const handleGifLoad = () => {
//     setIsGifLoading(false);
//   };

//   const handleGifError = () => {
//     setIsGifLoading(false);
//     console.error("Failed to load GIF");
//   };

//   return (
//     <>
//       <style jsx global>{`
//         :root {
//           --color-bg: #ffffff;
//           --color-text: #202020;
//           --color-text-light: #6b7280;
//           --color-accent-light: #E0F5FF;
//           --color-accent-dark: #F0FAFF;
//           --color-button: #202020;
//           --color-button-text: #ffffff;
//           --gradient-primary: linear-gradient(135deg, var(--color-accent-light) 0%, var(--color-accent-dark) 100%);
//           --gradient-subtle: linear-gradient(180deg, var(--color-accent-light) 0%, var(--color-accent-dark) 44.95%, #FFFFFF 100%);
//           --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.05);
//           --shadow-md: 0 8px 30px rgba(0, 0, 0, 0.12);
//           --shadow-lg: 0 20px 60px rgba(0, 0, 0, 0.15);
//           --border-radius: 12px;
//           --border-radius-lg: 24px;
//           --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//           --container-width: 1200px;
//         }

//         * {
//           margin: 0;
//           padding: 0;
//           box-sizing: border-box;
//         }

//         html {
//           scroll-behavior: smooth;
//         }

//         .hero-animation {
//           position: relative;
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           min-height: 400px;
//         }

//         .receipt-illustration {
//           position: relative;
//           width: 100%;
//           max-width: 400px;
//           height: 400px;
//         }

//         .receipt-card {
//           position: absolute;
//           top:30%;
//           left: 80%;
//           transform: translate(-50%, -50%);
//           width: 300px; /* Slightly increased to accommodate buttons */
//           padding: 1.5rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-lg);
//           border: 2px solid rgba(224, 245, 255, 0.8);
//           animation: floatCard 6s ease-in-out infinite;
//           z-index: 2;
//           backdrop-filter: blur(10px);
//           transition: var(--transition);
//         }

//         .receipt-card:hover {
//           box-shadow: 0 30px 70px rgba(0, 0, 0, 0.2);
//           border-color: var(--color-accent-light);
//           transform: translate(-50%, -50%) scale(1.02);
//         }

//         @keyframes floatCard {
//           0%, 100% { 
//             transform: translate(-50%, -50%) translateY(0) rotate(0deg); 
//           }
//           33% { 
//             transform: translate(-50%, -50%) translateY(-10px) rotate(0.5deg); 
//           }
//           66% { 
//             transform: translate(-50%, -50%) translateY(-5px) rotate(-0.5deg); 
//           }
//         }

//         .receipt-header {
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//           margin-bottom: 1.5rem;
//           padding-bottom: 1rem;
//           border-bottom: 2px solid rgba(224, 245, 255, 0.5);
//         }

//         .receipt-icon {
//           width: 48px;
//           height: 48px;
//           border-radius: 50%;
//           background: var(--gradient-primary);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 1.5rem;
//           color: var(--color-text);
//           animation: pulseIcon 2s ease-in-out infinite;
//         }

//         @keyframes pulseIcon {
//           0%, 100% { transform: scale(1); }
//           50% { transform: scale(1.05); }
//         }

//         .receipt-title h4 {
//           margin: 0;
//           color: var(--color-text);
//           font-size: 1.25rem;
//         }

//         .timestamp {
//           font-size: 0.85rem;
//           color: var(--color-text-light);
//           margin-top: 0.25rem;
//         }

//         .receipt-content {
//           display: flex;
//           flex-direction: column;
//           gap: 0.75rem;
//           margin-bottom: 1rem;
//         }

//         .receipt-item {
//           display: flex;
//           justify-content: space-between;
//           padding: 0.5rem 0;
//           border-bottom: 1px solid rgba(224, 245, 255, 0.3);
//         }

//         .receipt-item:last-child {
//           border-bottom: none;
//         }

//         .receipt-item .label {
//           color: var(--color-text-light);
//           font-weight: 500;
//           font-size: 0.9rem;
//         }

//         .receipt-item .value {
//           color: var(--color-text);
//           font-weight: 600;
//           font-size: 0.9rem;
//           text-align: right;
//           max-width: 60%;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         .status-pending {
//           color: #F59E0B !important;
//           position: relative;
//           padding-left: 1.25rem;
//         }

//         .status-pending::before {
//           content: '';
//           position: absolute;
//           left: 0;
//           top: 50%;
//           transform: translateY(-50%);
//           width: 10px;
//           height: 10px;
//           border-radius: 50%;
//           background: #F59E0B;
//           animation: pulseDot 1.5s ease-in-out infinite;
//         }

//         @keyframes pulseDot {
//           0%, 100% { opacity: 1; transform: translateY(-50%) scale(1); }
//           50% { opacity: 0.5; transform: translateY(-50%) scale(0.8); }
//         }






//         .receipt-actions {
//           display: flex;
//           flex-direction: row;
//           gap: 8px;
//           margin: 1rem 0 1.5rem;
//           justify-content: space-between;
//         }

//         .action-btn {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 4px;
//           padding: 8px 10px;
//           border: none;
//           border-radius: 30px;
//           font-weight: 600;
//           font-size: 0.85rem;
//           cursor: pointer;
//           transition: var(--transition);
//           flex: 1; /* Make buttons take equal width */
//           white-space: nowrap; /* Prevent text wrapping */
//           box-shadow: var(--shadow-sm);
//         }        .action-btn.accept {
//           background-color: #10B981;
//           color: white;
//         }

//         .action-btn.accept:hover {
//           background-color: #059669;
//           transform: translateY(-2px);
//           box-shadow: var(--shadow-md);
//         }

//         .action-btn.dispute {
//           background-color: #EF4444;
//           color: white;
//         }

//         .action-btn.dispute:hover {
//           background-color: #DC2626;
//           transform: translateY(-2px);
//           box-shadow: var(--shadow-md);
//         }

//         .action-btn.ignore {
//           background-color: #6B7280;
//           color: white;
//         }

//         .action-btn.ignore:hover {
//           background-color: #4B5563;
//           transform: translateY(-2px);
//           box-shadow: var(--shadow-md);
//         }

//         .action-btn:active {
//           transform: translateY(0);
//           box-shadow: var(--shadow-sm);
//         }

//         .receipt-footer {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           padding-top: 1rem;
//           border-top: 2px solid rgba(224, 245, 255, 0.5);
//           font-size: 0.85rem;
//           color: var(--color-text-light);
//         }

//         .receipt-id {
//           font-family: monospace;
//           font-weight: 600;
//         }

//         .verification-badge {
//           display: flex;
//           align-items: center;
//           gap: 4px;
//           color: var(--color-text);
//           background: var(--gradient-primary);
//           padding: 4px 8px;
//           border-radius: 20px;
//           font-weight: 600;
//           font-size: 0.75rem;
//         }

//         body {
//           font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
//           color: var(--color-text);
//           background-color: var(--color-bg);
//           line-height: 1.6;
//           overflow-x: hidden;
//         }

//         .container {
//           width: 100%;
//           max-width: var(--container-width);
//           margin: 0 auto;
//           padding: 0 24px;
//         }

//         section {
//           padding: 80px 0;
//         }

//         h1, h2, h3, h4 {
//           font-weight: 800;
//           line-height: 1.2;
//         }

//         h1 {
//           font-size: 3.5rem;
//           margin-bottom: 1.5rem;
//         }

//         h2 {
//           font-size: 2.5rem;
//           margin-bottom: 1rem;
//           text-align: center;
//         }

//         h3 {
//           font-size: 1.5rem;
//           margin-bottom: 0.75rem;
//         }

//         p {
//           color: var(--color-text-light);
//           margin-bottom: 1.5rem;
//         }

//         .section-subtitle {
//           text-align: center;
//           max-width: 700px;
//           margin: 0 auto 3rem;
//           font-size: 1.125rem;
//         }

//         /* Animations */
//         @keyframes fadeIn {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }

//         @keyframes fadeInUp {
//           from {
//             opacity: 0;
//             transform: translateY(30px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         @keyframes float {
//           0%, 100% { transform: translateY(0); }
//           50% { transform: translateY(-10px); }
//         }

//         @keyframes pulse {
//           0%, 100% { transform: scale(1); }
//           50% { transform: scale(1.05); }
//         }

//         /* Header */
//         .header {
//           position: sticky;
//           top: 0;
//           z-index: 1000;
//           background-color: rgba(255, 255, 255, 0.95);
//           backdrop-filter: blur(10px);
//           border-bottom: 1px solid rgba(0, 0, 0, 0.05);
//           padding: 1rem 0;
//           transition: var(--transition);
//         }

//         .header.scrolled {
//           box-shadow: var(--shadow-sm);
//         }

//         .header-content {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//         }

//         .logo {
//           display: flex;
//           align-items: center;
//           font-weight: 800;
//           font-size: 1.5rem;
//           text-decoration: none;
//           color: var(--color-text);
//           cursor: pointer;
//           transition: var(--transition);
//         }

//         .logo:hover {
//           transform: scale(1.05);
//         }

//         .logo-icon {
//           margin-right: 10px;
//           font-size: 1.8rem;
//           color: var(--color-text);
//           animation: float 3s ease-in-out infinite;
//         }

//         .nav {
//           display: flex;
//           gap: 2rem;
//         }

//         .nav a {
//           text-decoration: none;
//           color: var(--color-text-light);
//           font-weight: 500;
//           font-size: 0.95rem;
//           position: relative;
//           transition: var(--transition);
//         }

//         .nav a:hover {
//           color: var(--color-text);
//           transform: translateY(-2px);
//         }

//         .cta-button {
//           background-color: var(--color-button);
//           color: var(--color-button-text);
//           border: none;
//           border-radius: 9999px;
//           padding: 12px 24px;
//           font-weight: 700;
//           font-size: 0.95rem;
//           cursor: pointer;
//           transition: var(--transition);
//           display: inline-flex;
//           align-items: center;
//           gap: 8px;
//           text-decoration: none;
//         }

//         .cta-button:hover {
//           transform: translateY(-2px);
//           box-shadow: var(--shadow-md);
//           background: linear-gradient(135deg, #202020, #404040);
//           animation: pulse 1s ease-in-out;
//         }

//         .cta-button.primary {
//           padding: 16px 32px;
//           font-size: 1rem;
//         }

//         .cta-button.large {
//           padding: 18px 40px;
//           font-size: 1.1rem;
//         }

//         .microcopy {
//           display: block;
//           font-size: 0.85rem;
//           font-weight: normal;
//           color: var(--color-text-light);
//           margin-top: 0.5rem;
//         }

//         /* Hero */
//         .hero {
//           padding: 100px 0 120px;
//           background: var(--gradient-subtle);
//           position: relative;
//           overflow: hidden;
//           animation: fadeIn 1s ease-out;
//         }

//         @media (min-width: 1024px) {
//           .hero {
//             padding: 120px 0 140px;
//           }
//         }

//         .hero-grid {
//           display: grid;
//           grid-template-columns: 1fr;
//           gap: 4rem;
//           align-items: center;
//         }

//         @media (min-width: 1024px) {
//           .hero-grid {
//             grid-template-columns: 1.2fr 1fr;
//             gap: 6rem;
//           }
//         }

//         .hero-content {
//           position: relative;
//           z-index: 2;
//         }

//         .tagline {
//           display: inline-flex;
//           align-items: center;
//           gap: 10px;
//           background: rgba(32, 32, 32, 0.05);
//           color: var(--color-text);
//           font-weight: 600;
//           padding: 8px 16px;
//           border-radius: 9999px;
//           margin-bottom: 1.5rem;
//           animation: fadeInUp 0.8s ease-out 0.2s both;
//         }

//         .hero-subtitle {
//           font-size: 1.25rem;
//           margin-bottom: 3rem;
//           max-width: 700px;
//           animation: fadeInUp 0.8s ease-out 0.4s both;
//         }

//         .hero-actions {
//           display: flex;
//           gap: 1rem;
//           flex-wrap: wrap;
//           animation: fadeInUp 0.8s ease-out 0.6s both;
//         }

//         .secondary-button {
//           background: transparent;
//           color: var(--color-text);
//           border: 2px solid var(--color-text);
//           border-radius: 9999px;
//           padding: 12px 24px;
//           font-weight: 700;
//           font-size: 0.95rem;
//           cursor: pointer;
//           transition: var(--transition);
//           text-decoration: none;
//           display: inline-flex;
//           align-items: center;
//           gap: 8px;
//         }

//         .secondary-button:hover {
//           background-color: var(--color-text);
//           color: white;
//           transform: translateY(-2px);
//           box-shadow: var(--shadow-md);
//         }

//         .hero-gif {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           display: block;
//           border-radius: var(--border-radius-lg);
//           animation: fadeInGif 1.5s ease-out;
//         }

//         @keyframes fadeInGif {
//           from {
//             opacity: 0;
//             transform: scale(0.95);
//           }
//           to {
//             opacity: 1;
//             transform: scale(1);
//           }
//         }

//         .gif-wrapper {
//           position: relative;
//           width: 100%;
//           height: 280px;
//           border-radius: var(--border-radius-lg);
//           overflow: hidden;
//           box-shadow: var(--shadow-lg);
//           transform: perspective(1000px) rotateY(-2deg) rotateX(2deg);
//           transition: var(--transition);
//           background: linear-gradient(145deg, #ffffff, #f5f5f5);
//         }

//         @media (min-width: 768px) {
//           .gif-wrapper {
//             height: 300px;
//           }
//         }

//         .gif-wrapper:hover {
//           transform: translateY(-5px) translateZ(10px);
//           box-shadow: 
//             0 30px 80px rgba(0, 0, 0, 0.2),
//             0 0 0 1px rgba(224, 245, 255, 0.5);
//         }

//         .gif-control {
//           position: absolute;
//           bottom: 16px;
//           right: 16px;
//           width: 40px;
//           height: 40px;
//           border-radius: 50%;
//           background: rgba(32, 32, 32, 0.9);
//           color: white;
//           border: none;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           cursor: pointer;
//           transition: var(--transition);
//           opacity: 0;
//           transform: scale(0.8);
//           z-index: 10;
//         }

//         .gif-wrapper:hover .gif-control {
//           opacity: 1;
//           transform: scale(1);
//         }

//         .gif-control:hover {
//           background: var(--color-text);
//           transform: scale(1.1) rotate(90deg);
//         }

//         .gif-caption {
//           display: flex;
//           align-items: center;
//           gap: 12px;
//           margin-top: 1.5rem;
//           padding: 1rem 1.5rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//           animation: slideUpCaption 1s ease-out 0.5s both;
//           max-width: 400px;
//         }

//         @keyframes slideUpCaption {
//           from {
//             opacity: 0;
//             transform: translateY(20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         .caption-icon {
//           width: 40px;
//           height: 40px;
//           border-radius: 50%;
//           background: var(--gradient-primary);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 1.2rem;
//           color: var(--color-text);
//           flex-shrink: 0;
//         }

//         .gif-caption p {
//           margin: 0;
//           font-weight: 600;
//           color: var(--color-text);
//           font-size: 0.95rem;
//         }

//         /* Horizontal Scroll Sections */
//         .horizontal-scroll-section {
//           position: relative;
//           padding: 0 24px;
//         }

//         .horizontal-scroll-container {
//           display: flex;
//           overflow-x: auto;
//           gap: 24px;
//           padding: 24px 0;
//           scrollbar-width: none;
//           -ms-overflow-style: none;
//           scroll-behavior: smooth;
//         }

//         .horizontal-scroll-container::-webkit-scrollbar {
//           display: none;
//         }

//         .scroll-button {
//           position: absolute;
//           top: 50%;
//           transform: translateY(-50%);
//           background: white;
//           border: 2px solid var(--color-text);
//           border-radius: 50%;
//           width: 48px;
//           height: 48px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           cursor: pointer;
//           transition: var(--transition);
//           z-index: 10;
//           box-shadow: var(--shadow-md);
//         }

//         .scroll-button:hover {
//           background: var(--color-text);
//           color: white;
//           transform: translateY(-50%) scale(1.1);
//         }

//         .scroll-button.left {
//           left: 0;
//         }

//         .scroll-button.right {
//           right: 0;
//         }

//         /* Use Cases with Horizontal Scroll */
//         .use-cases-scroll-container {
//           display: flex;
//           overflow-x: auto;
//           gap: 24px;
//           padding: 24px 0;
//           scrollbar-width: none;
//           -ms-overflow-style: none;
//         }

//         .use-cases-scroll-container::-webkit-scrollbar {
//           display: none;
//         }

//         .use-case-card {
//           flex: 0 0 auto;
//           width: 320px;
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           transition: var(--transition);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//           text-align: center;
//         }

//         .use-case-card:hover {
//           transform: translateY(-8px);
//           box-shadow: var(--shadow-md);
//           border-color: rgba(224, 245, 255, 0.8);
//         }

//         .use-case-icon {
//           font-size: 2.5rem;
//           color: var(--color-text);
//           margin-bottom: 1.5rem;
//           display: block;
//           transition: var(--transition);
//         }

//         .use-case-card:hover .use-case-icon {
//           transform: scale(1.2) rotate(5deg);
//         }

//         /* Testimonials with Horizontal Scroll */
//         .testimonials-scroll-container {
//           display: flex;
//           overflow-x: auto;
//           gap: 32px;
//           padding: 32px 0;
//           scrollbar-width: none;
//           -ms-overflow-style: none;
//         }

//         .testimonials-scroll-container::-webkit-scrollbar {
//           display: none;
//         }

//         .testimonial-card {
//           flex: 0 0 auto;
//           width: 380px;
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           transition: var(--transition);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//         }

//         .testimonial-card:hover {
//           transform: translateY(-8px);
//           box-shadow: var(--shadow-md);
//         }

//         .testimonial-content {
//           font-style: italic;
//           margin-bottom: 1.5rem;
//           color: var(--color-text);
//           font-size: 1.1rem;
//           line-height: 1.6;
//         }

//         .testimonial-author {
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//         }

//         .author-avatar {
//           width: 48px;
//           height: 48px;
//           border-radius: 50%;
//           background: var(--gradient-primary);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-weight: 700;
//           color: var(--color-text);
//           transition: var(--transition);
//         }

//         .testimonial-card:hover .author-avatar {
//           transform: rotate(360deg);
//         }

//         /* What Is Section (Is / Is Not) */
//         .comparison {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
//           gap: 3rem;
//           margin-top: 3rem;
//         }

//         .comparison-column {
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//         }

//         .comparison-list {
//           display: flex;
//           flex-direction: column;
//           gap: 1rem;
//           margin-top: 1rem;
//         }

//         .comparison-item {
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//           padding: 0.75rem;
//           border-radius: 8px;
//           transition: var(--transition);
//         }

//         .comparison-item:hover {
//           background: rgba(224, 245, 255, 0.2);
//           transform: translateX(5px);
//         }

//         .is-icon {
//           width: 24px;
//           height: 24px;
//           border-radius: 50%;
//           background: #10B981;
//           color: white;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-weight: bold;
//           flex-shrink: 0;
//         }

//         .not-icon {
//           width: 24px;
//           height: 24px;
//           border-radius: 50%;
//           background: #EF4444;
//           color: white;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-weight: bold;
//           flex-shrink: 0;
//         }

//         /* Steps / How It Works */
//         .steps {
//           display: flex;
//           flex-direction: column;
//           gap: 2rem;
//           max-width: 800px;
//           margin: 3rem auto 0;
//         }

//         .step {
//           display: flex;
//           gap: 2rem;
//           align-items: flex-start;
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//         }

//         .step-number {
//           width: 60px;
//           height: 60px;
//           border-radius: 50%;
//           background: var(--color-text);
//           color: white;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 1.5rem;
//           font-weight: 800;
//           flex-shrink: 0;
//         }

//         .step-content {
//           flex: 1;
//         }

//         .outcome-options {
//           display: flex;
//           flex-direction: column;
//           gap: 12px;
//           margin: 1rem 0;
//         }

//         .outcome-option {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//           font-size: 0.95rem;
//           transition: var(--transition);
//           padding: 8px 12px;
//           border-radius: 8px;
//           background: rgba(224, 245, 255, 0.2);
//         }

//         .outcome-option:hover {
//           transform: translateX(10px);
//           background: rgba(224, 245, 255, 0.4);
//         }

//         .option-icon {
//           font-size: 1.25rem;
//           flex-shrink: 0;
//         }

//         .option-icon.acknowledged {
//           color: #10B981;
//         }

//         .option-icon.disputed {
//           color: #EF4444;
//         }

//         .option-icon.no-response {
//           color: #6B7280;
//         }

//         /* Outcomes Grid */
//         .outcomes-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
//           gap: 2rem;
//           margin-top: 3rem;
//         }

//         .outcome-card {
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           transition: var(--transition);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//         }

//         .outcome-card:hover {
//           transform: translateY(-8px);
//           box-shadow: var(--shadow-md);
//         }

//         .outcome-card.acknowledged {
//           border-top: 4px solid #10B981;
//         }

//         .outcome-card.disputed {
//           border-top: 4px solid #EF4444;
//         }

//         .outcome-card.no-response {
//           border-top: 4px solid #6B7280;
//         }

//         .outcome-header {
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//           margin-bottom: 1rem;
//         }

//         .outcome-icon {
//           font-size: 2rem;
//         }

//         /* Verification */
//         .verification-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
//           gap: 2rem;
//           margin-top: 3rem;
//         }

//         .verification-card {
//           padding: 2rem;
//           background: white;
//           border-radius: var(--border-radius);
//           box-shadow: var(--shadow-sm);
//           transition: var(--transition);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//           text-align: center;
//         }

//         .verification-card:hover {
//           transform: translateY(-8px);
//           box-shadow: var(--shadow-md);
//         }

//         .verification-icon {
//           font-size: 2.5rem;
//           color: var(--color-text);
//           margin-bottom: 1.5rem;
//         }

//         /* Email Example */
//         .email-example {
//           background: rgba(32, 32, 32, 0.05);
//           border-radius: var(--border-radius);
//           padding: 2rem;
//           margin: 2rem 0;
//           text-align: left;
//           font-family: 'Monaco', 'Courier New', monospace;
//           font-size: 0.9rem;
//           max-width: 600px;
//           margin-left: auto;
//           margin-right: auto;
//         }

//         .email-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 1rem;
//           color: var(--color-text);
//           font-weight: 600;
//         }

//         /* FAQ */
//         .faq-grid {
//           max-width: 800px;
//           margin: 3rem auto 0;
//         }

//         .faq-item {
//           border-bottom: 1px solid rgba(224, 245, 255, 0.5);
//           padding: 1.5rem 0;
//         }

//         .faq-question {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           cursor: pointer;
//           font-weight: 700;
//           font-size: 1.1rem;
//           color: var(--color-text);
//           transition: var(--transition);
//         }

//         .faq-question:hover {
//           color: var(--color-text);
//           transform: translateX(5px);
//         }

//         .faq-answer {
//           max-height: 0;
//           overflow: hidden;
//           transition: max-height 0.3s ease;
//           color: var(--color-text-light);
//           padding-top: 0;
//         }

//         .faq-item.active .faq-answer {
//           max-height: 300px;
//           padding-top: 1rem;
//         }

//         .faq-item.active .faq-question svg {
//           transform: rotate(180deg);
//         }

//         /* CTA Card */
//         .cta-card {
//           background: white;
//           border-radius: var(--border-radius);
//           padding: 4rem;
//           text-align: center;
//           box-shadow: var(--shadow-lg);
//           border: 1px solid rgba(224, 245, 255, 0.5);
//           max-width: 900px;
//           margin: 0 auto;
//         }

//         /* Footer */
//         .footer {
//           background-color: var(--color-text);
//           color: white;
//           padding: 4rem 0 2rem;
//         }

//         .footer-content {
//           display: flex;
//           justify-content: space-between;
//           align-items: flex-start;
//           flex-wrap: wrap;
//           gap: 2rem;
//           margin-bottom: 3rem;
//         }

//         .footer-logo {
//           display: flex;
//           align-items: center;
//           font-weight: 800;
//           font-size: 1.5rem;
//           margin-bottom: 1rem;
//         }

//         .footer-links {
//           display: flex;
//           flex-direction: column;
//           gap: 0.75rem;
//         }

//         .footer-links a {
//           color: rgba(255, 255, 255, 0.7);
//           text-decoration: none;
//           transition: var(--transition);
//         }

//         .footer-links a:hover {
//           color: white;
//           transform: translateX(5px);
//         }

//         .footer-disclaimer {
//           text-align: center;
//           padding-top: 2rem;
//           border-top: 1px solid rgba(255, 255, 255, 0.1);
//           color: rgba(255, 255, 255, 0.5);
//           font-size: 0.9rem;
//         }

//         /* Accessibility */
//         @media (prefers-reduced-motion: reduce) {
//           .hero-gif,
//           .overlay-shine,
//           .highlight,
//           .gif-caption,
//           .logo-icon,
//           .tagline,
//           .hero-subtitle,
//           .hero-actions,
//           .stat-card {
//             animation: none !important;
//             transition: none !important;
//           }
          
//           .gif-wrapper {
//             transform: none !important;
//           }
//         }

//         /* Responsive */
//         @media (max-width: 768px) {
//           h1 {
//             font-size: 2.5rem;
//           }
          
//           h2 {
//             font-size: 2rem;
//           }
          
//           .header-content {
//             flex-direction: column;
//             gap: 1rem;
//           }
          
//           .nav {
//             gap: 1rem;
//             flex-wrap: wrap;
//             justify-content: center;
//           }
          
//           .hero-actions {
//             justify-content: center;
//           }
          
//           .step {
//             flex-direction: column;
//             text-align: center;
//           }
          
//           .cta-card {
//             padding: 2rem;
//           }
          
//           .scroll-button {
//             width: 40px;
//             height: 40px;
//             font-size: 0.8rem;
//           }
          
//           .use-case-card,
//           .testimonial-card {
//             width: 280px;
//           }
          
//           .gif-wrapper {
//             height: 220px;
//           }

//           .receipt-card {
//             width: 260px;
//             padding: 1rem;
//           }
//         }

//         @media (max-width: 480px) {
//           .container {
//             padding: 0 16px;
//           }
          
//           section {
//             padding: 60px 0;
//           }
          
//           .horizontal-scroll-section {
//             padding: 0 16px;
//           }
          
//           .scroll-button {
//             display: none;
//           }
          
//           .gif-wrapper {
//             height: 200px;
//           }
          
//           .gif-caption {
//             flex-direction: column;
//             text-align: center;
//             gap: 0.5rem;
//           }
//         }

//         @media (max-width: 1023px) {
//           .hero-grid {
//             gap: 3rem;
//           }
//         }
//       `}</style>

//       <header className={`header ${scrolled ? 'scrolled' : ''}`}>
//         <div className="container">
//           <div className="header-content">
//             <div className="logo">
//               <FaReceipt className="logo-icon" />
//               <span>Log It Once</span>
//             </div>

//             <nav className="nav">
//               <a href="#problem">Problem</a>
//               <a href="#how">How It Works</a>
//               <a href="#uses">Use Cases</a>
//               <a href="#verification">Verification</a>
//             </nav>

//             <button className="cta-button" onClick={goToSignup}>
//               Try It On Your Next Milestone Email
//             </button>
//           </div>
//         </div>
//       </header>

//       <section className="hero">
//         <div className="container">
//           <div className="hero-grid">
//             <div className="hero-content">
//               <div className="tagline">
//                 <FaReceipt /> Log it once. Get a receipt.
//               </div>
              
//               <h1>Client Silence After Delivery Is Not Neutral.</h1>
              
//               <p className="hero-subtitle">
//                 You sent the milestone. They didn’t respond. Weeks later: “We never approved that.”<br />
//                 When approval isn’t captured, leverage shifts.<br />
//                 <strong>Log It Once records the outcome before reconstruction becomes your only option.</strong>
//               </p>
              
//               <div className="hero-actions">
//                 <button className="cta-button primary" onClick={goToSignup}>
//                   Try It On Your Next Milestone Email (Free) <FaArrowRight />
//                 </button>
//                 <span className="microcopy">Takes 30 seconds. No credit card. No meeting. No client signup required.</span>
//               </div>
//             </div>
             
//             {/* Updated Receipt Card with Buttons */}
//             <div style={{ position: 'relative', minHeight: '400px' }}>
//               <div className="receipt-card">
//                 <div className="receipt-header">
//                   <div className="receipt-icon">
//                     <FaReceipt />
//                   </div>
//                   <div className="receipt-title">
//                     <h4>Action Receipt</h4>
//                     <div className="timestamp">Just now</div>
//                   </div>
//                 </div>
                
//                 <div className="receipt-content">
//                   <div className="receipt-item">
//                     <span className="label">Action:</span>
//                     <span className="value">Deliverable sent</span>
//                   </div>
//                   <div className="receipt-item">
//                     <span className="label">To:</span>
//                     <span className="value">client@company.com</span>
//                   </div>
//                   <div className="receipt-item">
//                     <span className="label">Status:</span>
//                     <span className="value status-pending">Awaiting response</span>
//                   </div>
//                 </div>

//                 {/* New Action Buttons */}
//                 <div className="receipt-actions">
//                   <button className="action-btn accept">
//                     <FaCheck /> Accept
//                   </button>
//                   <button className="action-btn dispute">
//                     <FaTimes /> Dispute
//                   </button>
//                   <button className="action-btn ignore">
//                     <FaVolumeMute /> Ignore
//                   </button>
//                 </div>
                
//                 <div className="receipt-footer">
//                   <div className="receipt-id">#LOG-9842-2024</div>
//                   <div className="verification-badge">
//                     <FaLock /> Verified
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
          
//           {/* Optional caption */}
//           <div className="gif-caption">
//             <div className="caption-icon">
//               <FaReceipt />
//             </div>
//             <p>Recipients can respond with one click – no account needed</p>
//           </div>
//         </div>
//       </section>

//       {/* The Real Problem */}
//       <section id="problem" className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <h2>The Most Expensive Email Is the One With No Reply.</h2>
//           <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
//             <p style={{ fontSize: '1.25rem', marginBottom: '2rem' }}>
//               Service firms don’t lose money because they fail. They lose money because:
//             </p>
//             <ul style={{ listStyle: 'none', padding: 0, textAlign: 'left', display: 'inline-block' }}>
//               <li style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
//                 <FaTimes style={{ color: '#EF4444' }} /> Approval was implied, not recorded.
//               </li>
//               <li style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
//                 <FaTimes style={{ color: '#EF4444' }} /> A client went silent.
//               </li>
//               <li style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
//                 <FaTimes style={{ color: '#EF4444' }} /> Scope was reinterpreted later.
//               </li>
//               <li style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
//                 <FaTimes style={{ color: '#EF4444' }} /> The final invoice stalled.
//               </li>
//             </ul>
//             <p style={{ fontSize: '1.25rem', marginTop: '2rem', fontWeight: '600' }}>
//               “We never approved that.”<br />
//               When nothing happens, nothing gets documented.<br />
//               That’s when leverage flips.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* How It Works */}
//       <section id="how" className="section">
//         <div className="container">
//           <h2>How It Works</h2>
//           <p className="section-subtitle">Three Steps. No Workflow Change.</p>
          
//           <div className="steps">
//             <div className="step">
//               <div className="step-number">1</div>
//               <div className="step-content">
//                 <h3>Send your milestone email normally</h3>
//                 <p>Just include your unique Log It Once address in BCC.</p>
//               </div>
//             </div>
            
//             <div className="step">
//               <div className="step-number">2</div>
//               <div className="step-content">
//                 <h3>The recipient sees three options</h3>
//                 <div className="outcome-options">
//                   <div className="outcome-option">
//                     <FaCheck className="option-icon acknowledged" />
//                     <span>Acknowledge</span>
//                   </div>
//                   <div className="outcome-option">
//                     <FaTimes className="option-icon disputed" />
//                     <span>Dispute</span>
//                   </div>
//                   <div className="outcome-option">
//                     <FaVolumeMute className="option-icon no-response" />
//                     <span>No Response Recorded</span>
//                   </div>
//                 </div>
//                 <p>No account required for them. No confrontation. No chasing.</p>
//               </div>
//             </div>
            
//             <div className="step">
//               <div className="step-number">3</div>
//               <div className="step-content">
//                 <h3>Whatever happens — or doesn’t — is captured</h3>
//                 <p>You receive a neutral, time‑stamped receipt. If they don’t respond, that’s recorded too.</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* The Three Outcome States */}
//       <section className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <h2>The Three Outcome States</h2>
//           <p className="section-subtitle">Every logged action ends in one of three states:</p>
          
//           <div className="outcomes-grid">
//             <div className="outcome-card acknowledged">
//               <div className="outcome-header">
//                 <FaCheck className="outcome-icon" style={{ color: '#10B981' }} />
//                 <h3>Acknowledged</h3>
//               </div>
//               <p>The recipient formally accepted.</p>
//             </div>
            
//             <div className="outcome-card disputed">
//               <div className="outcome-header">
//                 <FaTimes className="outcome-icon" style={{ color: '#EF4444' }} />
//                 <h3>Disputed</h3>
//               </div>
//               <p>The recipient formally contested.</p>
//             </div>
            
//             <div className="outcome-card no-response">
//               <div className="outcome-header">
//                 <FaVolumeMute className="outcome-icon" style={{ color: '#6B7280' }} />
//                 <h3>No Response Recorded</h3>
//               </div>
//               <p>No formal response occurred within the response window.</p>
//             </div>
//           </div>
          
//           <div style={{ textAlign: 'center', marginTop: '2rem' }}>
//             <p style={{ fontSize: '1.1rem', fontWeight: '600' }}>
//               No interpretation is added. Only sequence is preserved.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* When to Use It */}
//       <section id="uses" className="section">
//         <div className="container">
//           <h2>When to Use Log It Once</h2>
          
//           <div className="horizontal-scroll-section">
//             <button className="scroll-button left" onClick={() => scrollUseCases('left')}>
//               <FaChevronLeft />
//             </button>
            
//             <div className="use-cases-scroll-container" ref={useCasesRef}>
//               {useCases.map((useCase, index) => (
//                 <div key={index} className="use-case-card">
//                   <div className="use-case-icon">
//                     {useCase.icon}
//                   </div>
//                   <h3>{useCase.title}</h3>
//                 </div>
//               ))}
//             </div>
            
//             <button className="scroll-button right" onClick={() => scrollUseCases('right')}>
//               <FaChevronRight />
//             </button>
//           </div>
//         </div>
//       </section>

//       {/* What This Is (Is / Is Not) */}
//       <section className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <h2>What This Is</h2>
//           <div className="comparison">
//             <div className="comparison-column">
//               <h3>Log It Once is:</h3>
//               <div className="comparison-list">
//                 <div className="comparison-item">
//                   <div className="is-icon">✓</div>
//                   <span>Chronological</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="is-icon">✓</div>
//                   <span>Append-only</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="is-icon">✓</div>
//                   <span>Server time‑stamped</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="is-icon">✓</div>
//                   <span>Independently verifiable</span>
//                 </div>
//               </div>
//             </div>
            
//             <div className="comparison-column">
//               <h3>Log It Once is not:</h3>
//               <div className="comparison-list">
//                 <div className="comparison-item">
//                   <div className="not-icon">✗</div>
//                   <span>Legal advice</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="not-icon">✗</div>
//                   <span>An arbitrator</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="not-icon">✗</div>
//                   <span>A CRM</span>
//                 </div>
//                 <div className="comparison-item">
//                   <div className="not-icon">✗</div>
//                   <span>An escalation tool</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div style={{ textAlign: 'center', marginTop: '2rem' }}>
//             <p>It records what happened. It does not decide what it means.</p>
//           </div>
//         </div>
//       </section>

//       {/* Simple Example */}
//       <section className="section">
//         <div className="container">
//           <h2>Simple Example</h2>
//           <div className="email-example">
//             <div className="email-header">
//               <span>Email Example</span>
//               <FaLink />
//             </div>
//             <code>
//               To: client@example.com<br />
//               <strong>Bcc: record@logitonce.com</strong><br />
//               Subject: Milestone 3 – Ready for Review<br />
//               Body: [Your normal email content]
//             </code>
//             <p style={{ marginTop: '1rem', fontSize: '0.9rem' }}>
//               That’s it. Your receipt is created automatically.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Testimonials */}
//       <section className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <h2>Teams Love Log It Once</h2>
          
//           <div className="horizontal-scroll-section">
//             <button className="scroll-button left" onClick={() => scrollTestimonial('left')}>
//               <FaChevronLeft />
//             </button>
            
//             <div className="testimonials-scroll-container" ref={testimonialRef}>
//               {testimonials.map((testimonial, index) => (
//                 <div key={testimonial.author} className="testimonial-card">
//                   <p className="testimonial-content">
//                     “{testimonial.content}”
//                   </p>
//                   <div className="testimonial-author">
//                     <div className="author-avatar">
//                       {testimonial.initials}
//                     </div>
//                     <div className="author-info">
//                       <h4>{testimonial.author}</h4>
//                       <p>{testimonial.role}</p>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
            
//             <button className="scroll-button right" onClick={() => scrollTestimonial('right')}>
//               <FaChevronRight />
//             </button>
//           </div>
//         </div>
//       </section>

//       {/* Verification (Condensed) */}
//       <section id="verification" className="section">
//         <div className="container">
//           <h2>Verification</h2>
//           <p className="section-subtitle">
//             When a receipt needs to leave the system, its integrity goes with it.
//           </p>
          
//           <div className="verification-grid">
//             <div className="verification-card">
//               <div className="verification-icon">
//                 <FaFileExport />
//               </div>
//               <h3>Full chronological timeline</h3>
//             </div>
            
//             <div className="verification-card">
//               <div className="verification-icon">
//                 <FaServer />
//               </div>
//               <h3>Server‑authoritative timestamps</h3>
//             </div>
            
//             <div className="verification-card">
//               <div className="verification-icon">
//                 <FaLock />
//               </div>
//               <h3>Independently verifiable</h3>
//             </div>
//           </div>
          
//           <div style={{ textAlign: 'center', marginTop: '2rem' }}>
//             <p style={{ fontWeight: '600' }}>If anything is altered, verification fails.</p>
//           </div>
//         </div>
//       </section>

//       {/* FAQ (optional but kept) */}
//       <section id="faq" className="section" style={{ background: 'var(--gradient-subtle)' }}>
//         <div className="container">
//           <h2>Frequently Asked Questions</h2>
          
//           <div className="faq-grid">
//             {faqs.map((faq, index) => (
//               <div
//                 key={index}
//                 className={`faq-item ${activeFAQ === index ? 'active' : ''}`}
//                 onClick={() => setActiveFAQ(activeFAQ === index ? null : index)}
//               >
//                 <div className="faq-question">
//                   <span>{faq.question}</span>
//                   <FaChevronDown />
//                 </div>
//                 <div className="faq-answer">
//                   <p>{faq.answer}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Final CTA */}
//       <section className="section">
//         <div className="container">
//           <div className="cta-card">
//             <h2>Stop Arguing About What Happened.</h2>
//             <h2 style={{ marginBottom: '2rem' }}>Start Recording What Did.</h2>
            
//             <button className="cta-button large" onClick={goToSignup}>
//               Create Your Outcome Address (Free) <FaArrowRight />
//             </button>
//             <span className="microcopy" style={{ marginTop: '1rem' }}>Takes 30 seconds. No workflow change. No client signup required.</span>
//           </div>
//         </div>
//       </section>

//       <footer className="footer">
//         <div className="container">
//           <div className="footer-content">
//             <div>
//               <div className="footer-logo">
//                 <FaReceipt /> Log It Once
//               </div>
//               <p style={{ color: 'rgba(255,255,255,0.7)', maxWidth: '300px' }}>
//                 If it matters, log it once.
//               </p>
//             </div>
//             <div className="footer-links">
//               <a href="mailto:support@logitonce.com">Support: support@logitonce.com</a>
//               <a href="#how">How it works</a>
//               <a href="#uses">Use cases</a>
//               <a href="#verification">Verify</a>
//               <a href="#">Terms</a>
//               <a href="#">Privacy</a>
//             </div>
//           </div>
//           <div className="footer-disclaimer">
//             <p>© Log It Once</p>
//             <p>Log It Once records events and timestamps. It does not provide legal advice or determine outcomes.</p>
//           </div>
//         </div>
//       </footer>
//     </>
//   );
// };

// export default LogItOnce;
































































/* eslint-disable react/jsx-no-undef */
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import logitoncegif from "./log it once Gif.gif"
import { 
  FaReceipt, 
  FaExclamationTriangle, 
  FaLayerGroup, 
  FaShieldAlt, 
  FaPaperPlane, 
  FaBriefcase, 
  FaClock, 
  FaExchangeAlt, 
  FaHistory, 
  FaStopwatch,
  FaLock,
  FaServer,
  FaDownload,
  FaCheckCircle,
  FaEnvelope,
  FaMobileAlt,
  FaCalendarAlt,
  FaCode,
  FaArrowRight,
  FaLink,
  FaCheck,
  FaTimes,
  FaVolumeMute,
  FaFileExport,
  FaChevronLeft,
  FaChevronRight,
  FaChevronDown,
  FaHistory as FaReplay
} from 'react-icons/fa';

const LogItOnce = () => {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [activeFAQ, setActiveFAQ] = useState(null);
  const [isGifLoading, setIsGifLoading] = useState(true);
  
  // Refs for horizontal scrolling
  const useCasesRef = useRef(null);
  const testimonialRef = useRef(null);
  const gifRef = useRef(null);
  
  const testimonials = [
    {
      content: "We stopped having ‘we never approved that’ conversations.",
      author: "Founder",
      role: "Growth Agency",
      initials: "FG"
    },
    {
      content: "Clients respond faster when outcomes are recorded.",
      author: "Managing Director",
      role: "Dev Studio",
      initials: "MD"
    },
    {
      content: "It removed the awkward follow-up dynamic.",
      author: "Ops Lead",
      role: "Consultancy",
      initials: "OL"
    }
  ];

  const useCases = [
    { icon: <FaBriefcase />, title: 'Delivering a milestone for approval' },
    { icon: <FaExchangeAlt />, title: 'Confirming scope changes' },
    { icon: <FaPaperPlane />, title: 'Sending final invoices' },
    { icon: <FaClock />, title: 'Transferring responsibility' },
    { icon: <FaStopwatch />, title: 'Setting deadlines that matter' },
    { icon: <FaExclamationTriangle />, title: 'Preparing for escalation without escalating' },
    { icon: <FaHistory />, title: 'If you might need to reconstruct it later — record it once' }
  ];

  const faqs = [
    {
      question: "How do I get started?",
      answer: "Create a free account, connect your email or app, and start logging actions immediately. No credit card required for the trial."
    },
    {
      question: "What happens if no one responds?",
      answer: "Silence is recorded as a factual event. After the response window closes, the receipt shows 'No Response Recorded' as the outcome."
    },
    {
      question: "Can receipts be edited or deleted?",
      answer: "No. Log It Once is append-only. Once created, receipts cannot be edited or deleted, ensuring an authentic record of events."
    },
    {
      question: "How are receipts verified?",
      answer: "Each receipt includes a server-authoritative timestamp and cryptographic signature that can be independently verified."
    },
    {
      question: "Is there a free trial?",
      answer: "Yes, you can start with 100 free receipts per month. No credit card required to get started."
    }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const goToSignup = () => {
    navigate("/signup");
  };

  // Horizontal scroll functions
  const scrollUseCases = (direction) => {
    if (useCasesRef.current) {
      const scrollAmount = 300;
      useCasesRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  const scrollTestimonial = (direction) => {
    if (testimonialRef.current) {
      const scrollAmount = 400;
      testimonialRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  // GIF replay function
  const replayGif = () => {
    if (gifRef.current) {
      const gif = gifRef.current;
      gif.src = gif.src;
    }
  };

  const handleGifLoad = () => {
    setIsGifLoading(false);
  };

  const handleGifError = () => {
    setIsGifLoading(false);
    console.error("Failed to load GIF");
  };

  return (
    <>
      <style jsx global>{`
        :root {
          --color-bg: #ffffff;
          --color-text: #202020;
          --color-text-light: #6b7280;
          --color-accent-light: #E0F5FF;
          --color-accent-dark: #F0FAFF;
          --color-button: #202020;
          --color-button-text: #ffffff;
          --gradient-primary: linear-gradient(135deg, var(--color-accent-light) 0%, var(--color-accent-dark) 100%);
          --gradient-subtle: linear-gradient(180deg, var(--color-accent-light) 0%, var(--color-accent-dark) 44.95%, #FFFFFF 100%);
          --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.05);
          --shadow-md: 0 8px 30px rgba(0, 0, 0, 0.12);
          --shadow-lg: 0 20px 60px rgba(0, 0, 0, 0.15);
          --border-radius: 12px;
          --border-radius-lg: 24px;
          --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          --container-width: 1200px;
        }

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        html {
          scroll-behavior: smooth;
        }

        .hero-animation {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 400px;
        }

        .receipt-illustration {
          position: relative;
          width: 100%;
          max-width: 400px;
          height: 400px;
        }

        .receipt-card {
          position: absolute;
          top: 30%;
          left: 80%;
          transform: translate(-50%, -50%);
          width: 300px;
          padding: 1.5rem;
          background: white;
          border-radius: var(--border-radius);
          box-shadow: var(--shadow-lg);
          border: 2px solid rgba(224, 245, 255, 0.8);
          animation: floatCard 6s ease-in-out infinite;
          z-index: 2;
          backdrop-filter: blur(10px);
          transition: var(--transition);
        }

        .receipt-card:hover {
          box-shadow: 0 30px 70px rgba(0, 0, 0, 0.2);
          border-color: var(--color-accent-light);
          transform: translate(-50%, -50%) scale(1.02);
        }

        @keyframes floatCard {
          0%, 100% { 
            transform: translate(-50%, -50%) translateY(0) rotate(0deg); 
          }
          33% { 
            transform: translate(-50%, -50%) translateY(-10px) rotate(0.5deg); 
          }
          66% { 
            transform: translate(-50%, -50%) translateY(-5px) rotate(-0.5deg); 
          }
        }

        .receipt-header {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-bottom: 1.5rem;
          padding-bottom: 1rem;
          border-bottom: 2px solid rgba(224, 245, 255, 0.5);
        }

        .receipt-icon {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: var(--gradient-primary);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          color: var(--color-text);
          animation: pulseIcon 2s ease-in-out infinite;
        }

        @keyframes pulseIcon {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }

        .receipt-title h4 {
          margin: 0;
          color: var(--color-text);
          font-size: 1.25rem;
        }

        .timestamp {
          font-size: 0.85rem;
          color: var(--color-text-light);
          margin-top: 0.25rem;
        }

        .receipt-content {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
          margin-bottom: 1rem;
        }

        .receipt-item {
          display: flex;
          justify-content: space-between;
          padding: 0.5rem 0;
          border-bottom: 1px solid rgba(224, 245, 255, 0.3);
        }

        .receipt-item:last-child {
          border-bottom: none;
        }

        .receipt-item .label {
          color: var(--color-text-light);
          font-weight: 500;
          font-size: 0.9rem;
        }

        .receipt-item .value {
          color: var(--color-text);
          font-weight: 600;
          font-size: 0.9rem;
          text-align: right;
          max-width: 60%;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .status-pending {
          color: #F59E0B !important;
          position: relative;
          padding-left: 1.25rem;
        }

        .status-pending::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: #F59E0B;
          animation: pulseDot 1.5s ease-in-out infinite;
        }

        @keyframes pulseDot {
          0%, 100% { opacity: 1; transform: translateY(-50%) scale(1); }
          50% { opacity: 0.5; transform: translateY(-50%) scale(0.8); }
        }

        .receipt-actions {
          display: flex;
          flex-direction: row;
          gap: 8px;
          margin: 1rem 0 1.5rem;
          justify-content: space-between;
        }

        .action-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 4px;
          padding: 8px 10px;
          border: none;
          border-radius: 30px;
          font-weight: 600;
          font-size: 0.85rem;
          cursor: pointer;
          transition: var(--transition);
          flex: 1;
          white-space: nowrap;
          box-shadow: var(--shadow-sm);
        }

        .action-btn.accept {
          background-color: #10B981;
          color: white;
        }

        .action-btn.accept:hover {
          background-color: #059669;
          transform: translateY(-2px);
          box-shadow: var(--shadow-md);
        }

        .action-btn.dispute {
          background-color: #EF4444;
          color: white;
        }

        .action-btn.dispute:hover {
          background-color: #DC2626;
          transform: translateY(-2px);
          box-shadow: var(--shadow-md);
        }

        .action-btn.ignore {
          background-color: #6B7280;
          color: white;
        }

        .action-btn.ignore:hover {
          background-color: #4B5563;
          transform: translateY(-2px);
          box-shadow: var(--shadow-md);
        }

        .action-btn:active {
          transform: translateY(0);
          box-shadow: var(--shadow-sm);
        }

        .receipt-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-top: 1rem;
          border-top: 2px solid rgba(224, 245, 255, 0.5);
          font-size: 0.85rem;
          color: var(--color-text-light);
        }

        .receipt-id {
          font-family: monospace;
          font-weight: 600;
        }

        .verification-badge {
          display: flex;
          align-items: center;
          gap: 4px;
          color: var(--color-text);
          background: var(--gradient-primary);
          padding: 4px 8px;
          border-radius: 20px;
          font-weight: 600;
          font-size: 0.75rem;
        }

        body {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          color: var(--color-text);
          background-color: var(--color-bg);
          line-height: 1.6;
          overflow-x: hidden;
        }

        .container {
          width: 100%;
          max-width: var(--container-width);
          margin: 0 auto;
          padding: 0 24px;
        }

        section {
          padding: 80px 0;
        }

        h1, h2, h3, h4 {
          font-weight: 800;
          line-height: 1.2;
        }

        h1 {
          font-size: 3.5rem;
          margin-bottom: 1.5rem;
        }

        h2 {
          font-size: 2.5rem;
          margin-bottom: 1rem;
          text-align: center;
        }

        h3 {
          font-size: 1.5rem;
          margin-bottom: 0.75rem;
        }

        p {
          color: var(--color-text-light);
          margin-bottom: 1.5rem;
        }

        .section-subtitle {
          text-align: center;
          max-width: 700px;
          margin: 0 auto 3rem;
          font-size: 1.125rem;
        }

        /* Animations */
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }

        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }

        /* Header */
        .header {
          position: sticky;
          top: 0;
          z-index: 1000;
          background-color: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          border-bottom: 1px solid rgba(0, 0, 0, 0.05);
          padding: 1rem 0;
          transition: var(--transition);
        }

        .header.scrolled {
          box-shadow: var(--shadow-sm);
        }

        .header-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .logo {
          display: flex;
          align-items: center;
          font-weight: 800;
          font-size: 1.5rem;
          text-decoration: none;
          color: var(--color-text);
          cursor: pointer;
          transition: var(--transition);
        }

        .logo:hover {
          transform: scale(1.05);
        }

        .logo-icon {
          margin-right: 10px;
          font-size: 1.8rem;
          color: var(--color-text);
          animation: float 3s ease-in-out infinite;
        }

        .nav {
          display: flex;
          gap: 2rem;
        }

        .nav a {
          text-decoration: none;
          color: var(--color-text-light);
          font-weight: 500;
          font-size: 0.95rem;
          position: relative;
          transition: var(--transition);
        }

        .nav a:hover {
          color: var(--color-text);
          transform: translateY(-2px);
        }

        .cta-button {
          background-color: var(--color-button);
          color: var(--color-button-text);
          border: none;
          border-radius: 9999px;
          padding: 12px 24px;
          font-weight: 700;
          font-size: 0.95rem;
          cursor: pointer;
          transition: var(--transition);
          display: inline-flex;
          align-items: center;
          gap: 8px;
          text-decoration: none;
        }

        .cta-button:hover {
          transform: translateY(-2px);
          box-shadow: var(--shadow-md);
          background: linear-gradient(135deg, #202020, #404040);
          animation: pulse 1s ease-in-out;
        }

        .cta-button.primary {
          padding: 16px 32px;
          font-size: 1rem;
        }

        .cta-button.large {
          padding: 18px 40px;
          font-size: 1.1rem;
        }

        .microcopy {
          display: block;
          font-size: 0.85rem;
          font-weight: normal;
          color: var(--color-text-light);
          margin-top: 0.5rem;
        }

        /* Hero */
        .hero {
          padding: 100px 0 120px;
          background: var(--gradient-subtle);
          position: relative;
          overflow: hidden;
          animation: fadeIn 1s ease-out;
        }

        @media (min-width: 1024px) {
          .hero {
            padding: 120px 0 140px;
          }
        }

        .hero-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 4rem;
          align-items: center;
        }

        @media (min-width: 1024px) {
          .hero-grid {
            grid-template-columns: 1.2fr 1fr;
            gap: 6rem;
          }
        }

        .hero-content {
          position: relative;
          z-index: 2;
        }

        .tagline {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          background: rgba(32, 32, 32, 0.05);
          color: var(--color-text);
          font-weight: 600;
          padding: 8px 16px;
          border-radius: 9999px;
          margin-bottom: 1.5rem;
          animation: fadeInUp 0.8s ease-out 0.2s both;
        }

        .hero-subtitle {
          font-size: 1.25rem;
          margin-bottom: 3rem;
          max-width: 700px;
          animation: fadeInUp 0.8s ease-out 0.4s both;
        }

        .hero-actions {
          display: flex;
          gap: 1rem;
          flex-wrap: wrap;
          animation: fadeInUp 0.8s ease-out 0.6s both;
        }

        .secondary-button {
          background: transparent;
          color: var(--color-text);
          border: 2px solid var(--color-text);
          border-radius: 9999px;
          padding: 12px 24px;
          font-weight: 700;
          font-size: 0.95rem;
          cursor: pointer;
          transition: var(--transition);
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }

        .secondary-button:hover {
          background-color: var(--color-text);
          color: white;
          transform: translateY(-2px);
          box-shadow: var(--shadow-md);
        }

        .hero-gif {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          border-radius: var(--border-radius-lg);
          animation: fadeInGif 1.5s ease-out;
        }

        @keyframes fadeInGif {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        .gif-wrapper {
          position: relative;
          width: 100%;
          height: 280px;
          border-radius: var(--border-radius-lg);
          overflow: hidden;
          box-shadow: var(--shadow-lg);
          transform: perspective(1000px) rotateY(-2deg) rotateX(2deg);
          transition: var(--transition);
          background: linear-gradient(145deg, #ffffff, #f5f5f5);
        }

        @media (min-width: 768px) {
          .gif-wrapper {
            height: 300px;
          }
        }

        .gif-wrapper:hover {
          transform: translateY(-5px) translateZ(10px);
          box-shadow: 
            0 30px 80px rgba(0, 0, 0, 0.2),
            0 0 0 1px rgba(224, 245, 255, 0.5);
        }

        .gif-control {
          position: absolute;
          bottom: 16px;
          right: 16px;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(32, 32, 32, 0.9);
          color: white;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: var(--transition);
          opacity: 0;
          transform: scale(0.8);
          z-index: 10;
        }

        .gif-wrapper:hover .gif-control {
          opacity: 1;
          transform: scale(1);
        }

        .gif-control:hover {
          background: var(--color-text);
          transform: scale(1.1) rotate(90deg);
        }

        .gif-caption {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-top: 1.5rem;
          padding: 1rem 1.5rem;
          background: white;
          border-radius: var(--border-radius);
          box-shadow: var(--shadow-sm);
          border: 1px solid rgba(224, 245, 255, 0.5);
          animation: slideUpCaption 1s ease-out 0.5s both;
          max-width: 400px;
        }

        @keyframes slideUpCaption {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .caption-icon {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: var(--gradient-primary);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.2rem;
          color: var(--color-text);
          flex-shrink: 0;
        }

        .gif-caption p {
          margin: 0;
          font-weight: 600;
          color: var(--color-text);
          font-size: 0.95rem;
        }

        /* Horizontal Scroll Sections */
        .horizontal-scroll-section {
          position: relative;
          padding: 0 24px;
        }

        .horizontal-scroll-container {
          display: flex;
          overflow-x: auto;
          gap: 24px;
          padding: 24px 0;
          scrollbar-width: none;
          -ms-overflow-style: none;
          scroll-behavior: smooth;
        }

        .horizontal-scroll-container::-webkit-scrollbar {
          display: none;
        }

        .scroll-button {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: white;
          border: 2px solid var(--color-text);
          border-radius: 50%;
          width: 48px;
          height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: var(--transition);
          z-index: 10;
          box-shadow: var(--shadow-md);
        }

        .scroll-button:hover {
          background: var(--color-text);
          color: white;
          transform: translateY(-50%) scale(1.1);
        }

        .scroll-button.left {
          left: 0;
        }

        .scroll-button.right {
          right: 0;
        }

        /* Use Cases with Horizontal Scroll */
        .use-cases-scroll-container {
          display: flex;
          overflow-x: auto;
          gap: 24px;
          padding: 24px 0;
          scrollbar-width: none;
          -ms-overflow-style: none;
        }

        .use-cases-scroll-container::-webkit-scrollbar {
          display: none;
        }

        .use-case-card {
          flex: 0 0 auto;
          width: 320px;
          padding: 2rem;
          background: white;
          border-radius: var(--border-radius);
          box-shadow: var(--shadow-sm);
          transition: var(--transition);
          border: 1px solid rgba(224, 245, 255, 0.5);
          text-align: center;
        }

        .use-case-card:hover {
          transform: translateY(-8px);
          box-shadow: var(--shadow-md);
          border-color: rgba(224, 245, 255, 0.8);
        }

        .use-case-icon {
          font-size: 2.5rem;
          color: var(--color-text);
          margin-bottom: 1.5rem;
          display: block;
          transition: var(--transition);
        }

        .use-case-card:hover .use-case-icon {
          transform: scale(1.2) rotate(5deg);
        }

        /* Testimonials with Horizontal Scroll */
        .testimonials-scroll-container {
          display: flex;
          overflow-x: auto;
          gap: 32px;
          padding: 32px 0;
          scrollbar-width: none;
          -ms-overflow-style: none;
        }

        .testimonials-scroll-container::-webkit-scrollbar {
          display: none;
        }

        .testimonial-card {
          flex: 0 0 auto;
          width: 380px;
          padding: 2rem;
          background: white;
          border-radius: var(--border-radius);
          box-shadow: var(--shadow-sm);
          transition: var(--transition);
          border: 1px solid rgba(224, 245, 255, 0.5);
        }

        .testimonial-card:hover {
          transform: translateY(-8px);
          box-shadow: var(--shadow-md);
        }

        .testimonial-content {
          font-style: italic;
          margin-bottom: 1.5rem;
          color: var(--color-text);
          font-size: 1.1rem;
          line-height: 1.6;
        }

        .testimonial-author {
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .author-avatar {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: var(--gradient-primary);
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          color: var(--color-text);
          transition: var(--transition);
        }

        .testimonial-card:hover .author-avatar {
          transform: rotate(360deg);
        }

        /* What Is Section (Is / Is Not) */
        .comparison {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 3rem;
          margin-top: 3rem;
        }

        .comparison-column {
          padding: 2rem;
          background: white;
          border-radius: var(--border-radius);
          box-shadow: var(--shadow-sm);
          border: 1px solid rgba(224, 245, 255, 0.5);
        }

        .comparison-list {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          margin-top: 1rem;
        }

        .comparison-item {
          display: flex;
          align-items: center;
          gap: 1rem;
          padding: 0.75rem;
          border-radius: 8px;
          transition: var(--transition);
        }

        .comparison-item:hover {
          background: rgba(224, 245, 255, 0.2);
          transform: translateX(5px);
        }

        .is-icon {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background: #10B981;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          flex-shrink: 0;
        }

        .not-icon {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background: #EF4444;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          flex-shrink: 0;
        }

        /* Steps / How It Works */
        .steps {
          display: flex;
          flex-direction: column;
          gap: 2rem;
          max-width: 800px;
          margin: 3rem auto 0;
        }

        .step {
          display: flex;
          gap: 2rem;
          align-items: flex-start;
          padding: 2rem;
          background: white;
          border-radius: var(--border-radius);
          box-shadow: var(--shadow-sm);
          border: 1px solid rgba(224, 245, 255, 0.5);
        }

        .step-number {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: var(--color-text);
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          font-weight: 800;
          flex-shrink: 0;
        }

        .step-content {
          flex: 1;
        }

        .outcome-options {
          display: flex;
          flex-direction: column;
          gap: 12px;
          margin: 1rem 0;
        }

        .outcome-option {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 0.95rem;
          transition: var(--transition);
          padding: 8px 12px;
          border-radius: 8px;
          background: rgba(224, 245, 255, 0.2);
        }

        .outcome-option:hover {
          transform: translateX(10px);
          background: rgba(224, 245, 255, 0.4);
        }

        .option-icon {
          font-size: 1.25rem;
          flex-shrink: 0;
        }

        .option-icon.acknowledged {
          color: #10B981;
        }

        .option-icon.disputed {
          color: #EF4444;
        }

        .option-icon.no-response {
          color: #6B7280;
        }

        /* Outcomes Grid */
        .outcomes-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 2rem;
          margin-top: 3rem;
        }

        .outcome-card {
          padding: 2rem;
          background: white;
          border-radius: var(--border-radius);
          box-shadow: var(--shadow-sm);
          transition: var(--transition);
          border: 1px solid rgba(224, 245, 255, 0.5);
        }

        .outcome-card:hover {
          transform: translateY(-8px);
          box-shadow: var(--shadow-md);
        }

        .outcome-card.acknowledged {
          border-top: 4px solid #10B981;
        }

        .outcome-card.disputed {
          border-top: 4px solid #EF4444;
        }

        .outcome-card.no-response {
          border-top: 4px solid #6B7280;
        }

        .outcome-header {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-bottom: 1rem;
        }

        .outcome-icon {
          font-size: 2rem;
        }

        /* Verification */
        .verification-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 2rem;
          margin-top: 3rem;
        }

        .verification-card {
          padding: 2rem;
          background: white;
          border-radius: var(--border-radius);
          box-shadow: var(--shadow-sm);
          transition: var(--transition);
          border: 1px solid rgba(224, 245, 255, 0.5);
          text-align: center;
        }

        .verification-card:hover {
          transform: translateY(-8px);
          box-shadow: var(--shadow-md);
        }

        .verification-icon {
          font-size: 2.5rem;
          color: var(--color-text);
          margin-bottom: 1.5rem;
        }

        /* Email Example */
        .email-example {
          background: rgba(32, 32, 32, 0.05);
          border-radius: var(--border-radius);
          padding: 2rem;
          margin: 2rem 0;
          text-align: left;
          font-family: 'Monaco', 'Courier New', monospace;
          font-size: 0.9rem;
          max-width: 600px;
          margin-left: auto;
          margin-right: auto;
        }

        .email-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1rem;
          color: var(--color-text);
          font-weight: 600;
        }

        /* FAQ */
        .faq-grid {
          max-width: 800px;
          margin: 3rem auto 0;
        }

        .faq-item {
          border-bottom: 1px solid rgba(224, 245, 255, 0.5);
          padding: 1.5rem 0;
        }

        .faq-question {
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          font-weight: 700;
          font-size: 1.1rem;
          color: var(--color-text);
          transition: var(--transition);
        }

        .faq-question:hover {
          color: var(--color-text);
          transform: translateX(5px);
        }

        .faq-answer {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s ease;
          color: var(--color-text-light);
          padding-top: 0;
        }

        .faq-item.active .faq-answer {
          max-height: 300px;
          padding-top: 1rem;
        }

        .faq-item.active .faq-question svg {
          transform: rotate(180deg);
        }

        /* CTA Card */
        .cta-card {
          background: white;
          border-radius: var(--border-radius);
          padding: 4rem;
          text-align: center;
          box-shadow: var(--shadow-lg);
          border: 1px solid rgba(224, 245, 255, 0.5);
          max-width: 900px;
          margin: 0 auto;
        }

        /* Footer */
        .footer {
          background-color: var(--color-text);
          color: white;
          padding: 4rem 0 2rem;
        }

        .footer-content {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          flex-wrap: wrap;
          gap: 2rem;
          margin-bottom: 3rem;
        }

        .footer-logo {
          display: flex;
          align-items: center;
          font-weight: 800;
          font-size: 1.5rem;
          margin-bottom: 1rem;
        }

        .footer-links {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
        }

        .footer-links a {
          color: rgba(255, 255, 255, 0.7);
          text-decoration: none;
          transition: var(--transition);
        }

        .footer-links a:hover {
          color: white;
          transform: translateX(5px);
        }

        .footer-disclaimer {
          text-align: center;
          padding-top: 2rem;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          color: rgba(255, 255, 255, 0.5);
          font-size: 0.9rem;
        }

        /* Accessibility */
        @media (prefers-reduced-motion: reduce) {
          .hero-gif,
          .overlay-shine,
          .highlight,
          .gif-caption,
          .logo-icon,
          .tagline,
          .hero-subtitle,
          .hero-actions,
          .stat-card {
            animation: none !important;
            transition: none !important;
          }
          
          .gif-wrapper {
            transform: none !important;
          }
        }

        /* Responsive */
        @media (max-width: 768px) {
          h1 {
            font-size: 2.5rem;
          }
          
          h2 {
            font-size: 2rem;
          }
          
          .header-content {
            flex-direction: column;
            gap: 1rem;
          }
          
          .nav {
            gap: 1rem;
            flex-wrap: wrap;
            justify-content: center;
          }
          
          .hero-actions {
            justify-content: center;
          }
          
          .step {
            flex-direction: column;
            text-align: center;
          }
          
          .cta-card {
            padding: 2rem;
          }
          
          .scroll-button {
            width: 40px;
            height: 40px;
            font-size: 0.8rem;
          }
          
          .use-case-card,
          .testimonial-card {
            width: 280px;
          }
          
          .gif-wrapper {
            height: 220px;
          }

          .receipt-card {
            width: 260px;
            padding: 1rem;
          }
        }

        @media (max-width: 480px) {
          .container {
            padding: 0 16px;
          }
          
          section {
            padding: 60px 0;
          }
          
          .horizontal-scroll-section {
            padding: 0 16px;
          }
          
          .scroll-button {
            display: none;
          }
          
          .gif-wrapper {
            height: 200px;
          }
          
          .gif-caption {
            flex-direction: column;
            text-align: center;
            gap: 0.5rem;
          }

          /* Hero receipt card adjustments */
          .hero-grid > div:last-child {
            min-height: auto;
            margin-top: 2rem;
          }

          .receipt-card {
            position: static;
            transform: none;
            width: 100%;
            max-width: 300px;
            margin: 0 auto;
            animation: none;
          }

          .receipt-card:hover {
            transform: scale(1.02);
          }
        }

        @media (max-width: 1023px) {
          .hero-grid {
            gap: 3rem;
          }
        }
      `}</style>

      <header className={`header ${scrolled ? 'scrolled' : ''}`}>
        <div className="container">
          <div className="header-content">
            <div className="logo">
              <FaReceipt className="logo-icon" />
              <span>Log It Once</span>
            </div>

            <nav className="nav">
              <a href="#problem">Problem</a>
              <a href="#how">How It Works</a>
              <a href="#uses">Use Cases</a>
              <a href="#verification">Verification</a>
            </nav>

            <button className="cta-button" onClick={goToSignup}>
              Try It On Your Next Milestone Email
            </button>
          </div>
        </div>
      </header>

      <section className="hero">
        <div className="container">
          <div className="hero-grid">
            <div className="hero-content">
              <div className="tagline">
                <FaReceipt /> Log it once. Get a receipt.
              </div>
              
              <h1>Client Silence After Delivery Is Not Neutral.</h1>
              
              <p className="hero-subtitle">
                You sent the milestone. They didn’t respond. Weeks later: “We never approved that.”<br />
                When approval isn’t captured, leverage shifts.<br />
                <strong>Log It Once records the outcome before reconstruction becomes your only option.</strong>
              </p>
              
              <div className="hero-actions">
                <button className="cta-button primary" onClick={goToSignup}>
                  Try It On Your Next Milestone Email (Free) <FaArrowRight />
                </button>
                <span className="microcopy">Takes 30 seconds. No credit card. No meeting. No client signup required.</span>
              </div>
            </div>
             
            {/* Updated Receipt Card with Buttons */}
            <div style={{ position: 'relative', minHeight: '400px' }}>
              <div className="receipt-card">
                <div className="receipt-header">
                  <div className="receipt-icon">
                    <FaReceipt />
                  </div>
                  <div className="receipt-title">
                    <h4>Action Receipt</h4>
                    <div className="timestamp">Just now</div>
                  </div>
                </div>
                
                <div className="receipt-content">
                  <div className="receipt-item">
                    <span className="label">Action:</span>
                    <span className="value">Deliverable sent</span>
                  </div>
                  <div className="receipt-item">
                    <span className="label">To:</span>
                    <span className="value">client@company.com</span>
                  </div>
                  <div className="receipt-item">
                    <span className="label">Status:</span>
                    <span className="value status-pending">Awaiting response</span>
                  </div>
                </div>

                {/* New Action Buttons */}
                <div className="receipt-actions">
                  <button className="action-btn accept">
                    <FaCheck /> Accept
                  </button>
                  <button className="action-btn dispute">
                    <FaTimes /> Dispute
                  </button>
                  <button className="action-btn ignore">
                    <FaVolumeMute /> Ignore
                  </button>
                </div>
                
                <div className="receipt-footer">
                  <div className="receipt-id">#LOG-9842-2024</div>
                  <div className="verification-badge">
                    <FaLock /> Verified
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Optional caption */}
          <div className="gif-caption">
            <div className="caption-icon">
              <FaReceipt />
            </div>
            <p>Recipients can respond with one click – no account needed</p>
          </div>
        </div>
      </section>

      {/* The Real Problem */}
      <section id="problem" className="section" style={{ background: 'var(--gradient-subtle)' }}>
        <div className="container">
          <h2>The Most Expensive Email Is the One With No Reply.</h2>
          <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
            <p style={{ fontSize: '1.25rem', marginBottom: '2rem' }}>
              Service firms don’t lose money because they fail. They lose money because:
            </p>
            <ul style={{ listStyle: 'none', padding: 0, textAlign: 'left', display: 'inline-block' }}>
              <li style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <FaTimes style={{ color: '#EF4444' }} /> Approval was implied, not recorded.
              </li>
              <li style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <FaTimes style={{ color: '#EF4444' }} /> A client went silent.
              </li>
              <li style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <FaTimes style={{ color: '#EF4444' }} /> Scope was reinterpreted later.
              </li>
              <li style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <FaTimes style={{ color: '#EF4444' }} /> The final invoice stalled.
              </li>
            </ul>
            <p style={{ fontSize: '1.25rem', marginTop: '2rem', fontWeight: '600' }}>
              “We never approved that.”<br />
              When nothing happens, nothing gets documented.<br />
              That’s when leverage flips.
            </p>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section id="how" className="section">
        <div className="container">
          <h2>How It Works</h2>
          <p className="section-subtitle">Three Steps. No Workflow Change.</p>
          
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Send your milestone email normally</h3>
                <p>Just include your unique Log It Once address in BCC.</p>
              </div>
            </div>
            
            <div className="step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>The recipient sees three options</h3>
                <div className="outcome-options">
                  <div className="outcome-option">
                    <FaCheck className="option-icon acknowledged" />
                    <span>Acknowledge</span>
                  </div>
                  <div className="outcome-option">
                    <FaTimes className="option-icon disputed" />
                    <span>Dispute</span>
                  </div>
                  <div className="outcome-option">
                    <FaVolumeMute className="option-icon no-response" />
                    <span>No Response Recorded</span>
                  </div>
                </div>
                <p>No account required for them. No confrontation. No chasing.</p>
              </div>
            </div>
            
            <div className="step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Whatever happens — or doesn’t — is captured</h3>
                <p>You receive a neutral, time‑stamped receipt. If they don’t respond, that’s recorded too.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* The Three Outcome States */}
      <section className="section" style={{ background: 'var(--gradient-subtle)' }}>
        <div className="container">
          <h2>The Three Outcome States</h2>
          <p className="section-subtitle">Every logged action ends in one of three states:</p>
          
          <div className="outcomes-grid">
            <div className="outcome-card acknowledged">
              <div className="outcome-header">
                <FaCheck className="outcome-icon" style={{ color: '#10B981' }} />
                <h3>Acknowledged</h3>
              </div>
              <p>The recipient formally accepted.</p>
            </div>
            
            <div className="outcome-card disputed">
              <div className="outcome-header">
                <FaTimes className="outcome-icon" style={{ color: '#EF4444' }} />
                <h3>Disputed</h3>
              </div>
              <p>The recipient formally contested.</p>
            </div>
            
            <div className="outcome-card no-response">
              <div className="outcome-header">
                <FaVolumeMute className="outcome-icon" style={{ color: '#6B7280' }} />
                <h3>No Response Recorded</h3>
              </div>
              <p>No formal response occurred within the response window.</p>
            </div>
          </div>
          
          <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <p style={{ fontSize: '1.1rem', fontWeight: '600' }}>
              No interpretation is added. Only sequence is preserved.
            </p>
          </div>
        </div>
      </section>

      {/* When to Use It */}
      <section id="uses" className="section">
        <div className="container">
          <h2>When to Use Log It Once</h2>
          
          <div className="horizontal-scroll-section">
            <button className="scroll-button left" onClick={() => scrollUseCases('left')}>
              <FaChevronLeft />
            </button>
            
            <div className="use-cases-scroll-container" ref={useCasesRef}>
              {useCases.map((useCase, index) => (
                <div key={index} className="use-case-card">
                  <div className="use-case-icon">
                    {useCase.icon}
                  </div>
                  <h3>{useCase.title}</h3>
                </div>
              ))}
            </div>
            
            <button className="scroll-button right" onClick={() => scrollUseCases('right')}>
              <FaChevronRight />
            </button>
          </div>
        </div>
      </section>

      {/* What This Is (Is / Is Not) */}
      <section className="section" style={{ background: 'var(--gradient-subtle)' }}>
        <div className="container">
          <h2>What This Is</h2>
          <div className="comparison">
            <div className="comparison-column">
              <h3>Log It Once is:</h3>
              <div className="comparison-list">
                <div className="comparison-item">
                  <div className="is-icon">✓</div>
                  <span>Chronological</span>
                </div>
                <div className="comparison-item">
                  <div className="is-icon">✓</div>
                  <span>Append-only</span>
                </div>
                <div className="comparison-item">
                  <div className="is-icon">✓</div>
                  <span>Server time‑stamped</span>
                </div>
                <div className="comparison-item">
                  <div className="is-icon">✓</div>
                  <span>Independently verifiable</span>
                </div>
              </div>
            </div>
            
            <div className="comparison-column">
              <h3>Log It Once is not:</h3>
              <div className="comparison-list">
                <div className="comparison-item">
                  <div className="not-icon">✗</div>
                  <span>Legal advice</span>
                </div>
                <div className="comparison-item">
                  <div className="not-icon">✗</div>
                  <span>An arbitrator</span>
                </div>
                <div className="comparison-item">
                  <div className="not-icon">✗</div>
                  <span>A CRM</span>
                </div>
                <div className="comparison-item">
                  <div className="not-icon">✗</div>
                  <span>An escalation tool</span>
                </div>
              </div>
            </div>
          </div>
          <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <p>It records what happened. It does not decide what it means.</p>
          </div>
        </div>
      </section>

      {/* Simple Example */}
      <section className="section">
        <div className="container">
          <h2>Simple Example</h2>
          <div className="email-example">
            <div className="email-header">
              <span>Email Example</span>
              <FaLink />
            </div>
            <code>
              To: client@example.com<br />
              <strong>Bcc: record@logitonce.com</strong><br />
              Subject: Milestone 3 – Ready for Review<br />
              Body: [Your normal email content]
            </code>
            <p style={{ marginTop: '1rem', fontSize: '0.9rem' }}>
              That’s it. Your receipt is created automatically.
            </p>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="section" style={{ background: 'var(--gradient-subtle)' }}>
        <div className="container">
          <h2>Teams Love Log It Once</h2>
          
          <div className="horizontal-scroll-section">
            <button className="scroll-button left" onClick={() => scrollTestimonial('left')}>
              <FaChevronLeft />
            </button>
            
            <div className="testimonials-scroll-container" ref={testimonialRef}>
              {testimonials.map((testimonial, index) => (
                <div key={testimonial.author} className="testimonial-card">
                  <p className="testimonial-content">
                    “{testimonial.content}”
                  </p>
                  <div className="testimonial-author">
                    <div className="author-avatar">
                      {testimonial.initials}
                    </div>
                    <div className="author-info">
                      <h4>{testimonial.author}</h4>
                      <p>{testimonial.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            
            <button className="scroll-button right" onClick={() => scrollTestimonial('right')}>
              <FaChevronRight />
            </button>
          </div>
        </div>
      </section>

      {/* Verification (Condensed) */}
      <section id="verification" className="section">
        <div className="container">
          <h2>Verification</h2>
          <p className="section-subtitle">
            When a receipt needs to leave the system, its integrity goes with it.
          </p>
          
          <div className="verification-grid">
            <div className="verification-card">
              <div className="verification-icon">
                <FaFileExport />
              </div>
              <h3>Full chronological timeline</h3>
            </div>
            
            <div className="verification-card">
              <div className="verification-icon">
                <FaServer />
              </div>
              <h3>Server‑authoritative timestamps</h3>
            </div>
            
            <div className="verification-card">
              <div className="verification-icon">
                <FaLock />
              </div>
              <h3>Independently verifiable</h3>
            </div>
          </div>
          
          <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <p style={{ fontWeight: '600' }}>If anything is altered, verification fails.</p>
          </div>
        </div>
      </section>

      {/* FAQ (optional but kept) */}
      <section id="faq" className="section" style={{ background: 'var(--gradient-subtle)' }}>
        <div className="container">
          <h2>Frequently Asked Questions</h2>
          
          <div className="faq-grid">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className={`faq-item ${activeFAQ === index ? 'active' : ''}`}
                onClick={() => setActiveFAQ(activeFAQ === index ? null : index)}
              >
                <div className="faq-question">
                  <span>{faq.question}</span>
                  <FaChevronDown />
                </div>
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="section">
        <div className="container">
          <div className="cta-card">
            <h2>Stop Arguing About What Happened.</h2>
            <h2 style={{ marginBottom: '2rem' }}>Start Recording What Did.</h2>
            
            <button className="cta-button large" onClick={goToSignup}>
              Create Your Outcome Address (Free) <FaArrowRight />
            </button>
            <span className="microcopy" style={{ marginTop: '1rem' }}>Takes 30 seconds. No workflow change. No client signup required.</span>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div>
              <div className="footer-logo">
                <FaReceipt /> Log It Once
              </div>
              <p style={{ color: 'rgba(255,255,255,0.7)', maxWidth: '300px' }}>
                If it matters, log it once.
              </p>
            </div>
            <div className="footer-links">
              <a href="mailto:support@logitonce.com">Support: support@logitonce.com</a>
              <a href="#how">How it works</a>
              <a href="#uses">Use cases</a>
              <a href="#verification">Verify</a>
              <a href="#">Terms</a>
              <a href="#">Privacy</a>
            </div>
          </div>
          <div className="footer-disclaimer">
            <p>© Log It Once</p>
            <p>Log It Once records events and timestamps. It does not provide legal advice or determine outcomes.</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default LogItOnce;